var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatbot401(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 416.54 404.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-11,.cls-12,.cls-2,.cls-268,.cls-269,.cls-270,.cls-271,.cls-3,.cls-34,.cls-35,.cls-6,.cls-7,.cls-9{mix-blend-mode:multiply;}.cls-11,.cls-12,.cls-2,.cls-3,.cls-6,.cls-7{opacity:0.5;}.cls-2{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2);}.cls-3{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-2);}.cls-4{fill:#fff;}.cls-5,.cls-9{fill:#bfbfbf;}.cls-6{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-3);}.cls-7{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-4);}.cls-11,.cls-8{fill:#606060;}.cls-10{opacity:0.2;}.cls-13{fill:#f3f3f3;}.cls-14{fill:#e7e7e7;}.cls-15{fill:#dbdbdb;}.cls-16{fill:#cecece;}.cls-17{fill:#c2c2c2;}.cls-18{fill:#b6b6b6;}.cls-19{fill:#aaa;}.cls-20{fill:#9e9e9e;}.cls-21{fill:#929292;}.cls-22{fill:#868686;}.cls-23{fill:#797979;}.cls-24{fill:#6d6d6d;}.cls-25{fill:#616161;}.cls-26{fill:#555;}.cls-27{fill:#494949;}.cls-28{fill:#3d3d3d;}.cls-29{fill:#313131;}.cls-30{fill:#242424;}.cls-31{fill:#181818;}.cls-32{fill:#0c0c0c;}.cls-33{fill:#09769c;}.cls-35{opacity:0.3;}.cls-36{fill:#fefefe;}.cls-37{fill:#fdfdfd;}.cls-38{fill:#fcfcfc;}.cls-39{fill:#fbfbfb;}.cls-40{fill:#fafafa;}.cls-41{fill:#f9f9f9;}.cls-42{fill:#f8f8f8;}.cls-43{fill:#f7f7f7;}.cls-44{fill:#f6f6f6;}.cls-45{fill:#f5f5f5;}.cls-46{fill:#f4f4f4;}.cls-47{fill:#f2f2f2;}.cls-48{fill:#f1f1f1;}.cls-49{fill:#f0f0f0;}.cls-50{fill:#efefef;}.cls-51{fill:#eee;}.cls-52{fill:#ededed;}.cls-53{fill:#ececec;}.cls-54{fill:#ebebeb;}.cls-55{fill:#eaeaea;}.cls-56{fill:#e9e9e9;}.cls-57{fill:#e8e8e8;}.cls-58{fill:#e6e6e6;}.cls-270,.cls-59{fill:#e5e5e5;}.cls-60{fill:#e4e4e4;}.cls-61{fill:#e3e3e3;}.cls-62{fill:#e2e2e2;}.cls-63{fill:#e1e1e1;}.cls-64{fill:#e0e0e0;}.cls-65{fill:#dfdfdf;}.cls-271,.cls-66{fill:#dedede;}.cls-67{fill:#ddd;}.cls-68{fill:#dcdcdc;}.cls-69{fill:#dadada;}.cls-70{fill:#d9d9d9;}.cls-71{fill:#d8d8d8;}.cls-72{fill:#d7d7d7;}.cls-73{fill:#d6d6d6;}.cls-74{fill:#d5d5d5;}.cls-268,.cls-75{fill:#d4d4d4;}.cls-76{fill:#d3d3d3;}.cls-77{fill:#d2d2d2;}.cls-269,.cls-78{fill:#d1d1d1;}.cls-79{fill:#d0d0d0;}.cls-80{fill:#cfcfcf;}.cls-81{fill:#cdcdcd;}.cls-82{fill:#ccc;}.cls-83{fill:#cbcbcb;}.cls-84{fill:#cacaca;}.cls-85{fill:#c9c9c9;}.cls-86{fill:#c8c8c8;}.cls-87{fill:#c7c7c7;}.cls-88{fill:#c6c6c6;}.cls-89{fill:#c5c5c5;}.cls-90{fill:#c4c4c4;}.cls-91{fill:#c3c3c3;}.cls-92{fill:#c1c1c1;}.cls-93{fill:silver;}.cls-94{fill:#bebebe;}.cls-95{fill:#bdbdbd;}.cls-96{fill:#bcbcbc;}.cls-97{fill:#bbb;}.cls-98{fill:#bababa;}.cls-99{fill:#b9b9b9;}.cls-100{fill:#b8b8b8;}.cls-101{fill:#b7b7b7;}.cls-102{fill:#b5b5b5;}.cls-103{fill:#b4b4b4;}.cls-104{fill:#b3b3b3;}.cls-105{fill:#b2b2b2;}.cls-106{fill:#b1b1b1;}.cls-107{fill:#b0b0b0;}.cls-108{fill:#afafaf;}.cls-109{fill:#aeaeae;}.cls-110{fill:#adadad;}.cls-111{fill:#acacac;}.cls-112{fill:#ababab;}.cls-113{fill:#a9a9a9;}.cls-114{fill:#a8a8a8;}.cls-115{fill:#a7a7a7;}.cls-116{fill:#a6a6a6;}.cls-117{fill:#a5a5a5;}.cls-118{fill:#a4a4a4;}.cls-119{fill:#a3a3a3;}.cls-120{fill:#a2a2a2;}.cls-121{fill:#a1a1a1;}.cls-122{fill:#a0a0a0;}.cls-123{fill:#9f9f9f;}.cls-124{fill:#9d9d9d;}.cls-125{fill:#9c9c9c;}.cls-126{fill:#9b9b9b;}.cls-127{fill:#9a9a9a;}.cls-128{fill:#999;}.cls-129{fill:#989898;}.cls-130{fill:#979797;}.cls-131{fill:#969696;}.cls-132{fill:#959595;}.cls-133{fill:#949494;}.cls-134{fill:#939393;}.cls-135{fill:#919191;}.cls-136{fill:#909090;}.cls-137{fill:#8f8f8f;}.cls-138{fill:#8e8e8e;}.cls-139{fill:#8d8d8d;}.cls-140{fill:#8c8c8c;}.cls-141{fill:#8b8b8b;}.cls-142{fill:#8a8a8a;}.cls-143{fill:#898989;}.cls-144{fill:#888;}.cls-145{fill:#878787;}.cls-146{fill:#858585;}.cls-147{fill:#848484;}.cls-148{fill:#838383;}.cls-149{fill:#828282;}.cls-150{fill:#818181;}.cls-151{fill:gray;}.cls-152{fill:#7f7f7f;}.cls-153{fill:#7e7e7e;}.cls-154{fill:#7d7d7d;}.cls-155{fill:#7c7c7c;}.cls-156{fill:#7b7b7b;}.cls-157{fill:#7a7a7a;}.cls-158{fill:#787878;}.cls-159{fill:#777;}.cls-160{fill:#767676;}.cls-161{fill:#757575;}.cls-162{fill:#747474;}.cls-163{fill:#737373;}.cls-164{fill:#727272;}.cls-165{fill:#717171;}.cls-166{fill:#707070;}.cls-167{fill:#6f6f6f;}.cls-168{fill:#6e6e6e;}.cls-169{fill:#6c6c6c;}.cls-170{fill:#6b6b6b;}.cls-171{fill:#6a6a6a;}.cls-172{fill:#696969;}.cls-173{fill:#686868;}.cls-174{fill:#676767;}.cls-175{fill:#666;}.cls-176{fill:#656565;}.cls-177{fill:#646464;}.cls-178{fill:#636363;}.cls-179{fill:#626262;}.cls-180{fill:#5f5f5f;}.cls-181{fill:#5e5e5e;}.cls-182{fill:#5d5d5d;}.cls-183{fill:#5c5c5c;}.cls-184{fill:#5b5b5b;}.cls-185{fill:#5a5a5a;}.cls-186{fill:#595959;}.cls-187{fill:#585858;}.cls-188{fill:#575757;}.cls-189{fill:#565656;}.cls-190{fill:#545454;}.cls-191{fill:#535353;}.cls-192{fill:#525252;}.cls-193{fill:#515151;}.cls-194{fill:#505050;}.cls-195{fill:#4f4f4f;}.cls-196{fill:#4e4e4e;}.cls-197{fill:#4d4d4d;}.cls-198{fill:#4c4c4c;}.cls-199{fill:#4b4b4b;}.cls-200{fill:#4a4a4a;}.cls-201{fill:#484848;}.cls-202{fill:#474747;}.cls-203{fill:#464646;}.cls-204{fill:#454545;}.cls-205{fill:#444;}.cls-206{fill:#434343;}.cls-207{fill:#424242;}.cls-208{fill:#414141;}.cls-209{fill:#404040;}.cls-210{fill:#3f3f3f;}.cls-211{fill:#3e3e3e;}.cls-212{fill:#3c3c3c;}.cls-213{fill:#3b3b3b;}.cls-214{fill:#3a3a3a;}.cls-215{fill:#393939;}.cls-216{fill:#383838;}.cls-217{fill:#373737;}.cls-218{fill:#363636;}.cls-219{fill:#353535;}.cls-220{fill:#343434;}.cls-221{fill:#333;}.cls-222{fill:#323232;}.cls-223{fill:#303030;}.cls-224{fill:#2f2f2f;}.cls-225{fill:#2e2e2e;}.cls-226{fill:#2d2d2d;}.cls-227{fill:#2c2c2c;}.cls-228{fill:#2b2b2b;}.cls-229{fill:#2a2a2a;}.cls-230{fill:#292929;}.cls-231{fill:#282828;}.cls-232{fill:#272727;}.cls-233{fill:#262626;}.cls-234{fill:#252525;}.cls-235{fill:#232323;}.cls-236{fill:#222;}.cls-237{fill:#212121;}.cls-238{fill:#202020;}.cls-239{fill:#1f1f1f;}.cls-240{fill:#1e1e1e;}.cls-241{fill:#1d1d1d;}.cls-242{fill:#1c1c1c;}.cls-243{fill:#1b1b1b;}.cls-244{fill:#1a1a1a;}.cls-245{fill:#191919;}.cls-246{fill:#171717;}.cls-247{fill:#161616;}.cls-248{fill:#151515;}.cls-249{fill:#141414;}.cls-250{fill:#131313;}.cls-251{fill:#121212;}.cls-252{fill:#111;}.cls-253{fill:#101010;}.cls-254{fill:#0f0f0f;}.cls-255{fill:#0e0e0e;}.cls-256{fill:#0d0d0d;}.cls-257{fill:#0b0b0b;}.cls-258{fill:#0a0a0a;}.cls-259{fill:#090909;}.cls-260{fill:#080808;}.cls-261{fill:#070707;}.cls-262{fill:#060606;}.cls-263{fill:#050505;}.cls-264{fill:#040404;}.cls-265{fill:#030303;}.cls-266{fill:#020202;}.cls-267{fill:#010101;}.cls-272{fill:#9bdfee;}.cls-273{fill:#054459;}.cls-274{fill:#6ed3ed;}.cls-275{fill:#6dd2ec;}.cls-276{fill:#6cd1eb;}.cls-277{fill:#6bd0eb;}.cls-278{fill:#6acfea;}.cls-279{fill:#69cee9;}.cls-280{fill:#68cee8;}.cls-281{fill:#67cde7;}.cls-282{fill:#66cce7;}.cls-283{fill:#65cbe6;}.cls-284{fill:#64cae5;}.cls-285{fill:#63c9e4;}.cls-286{fill:#62c8e3;}.cls-287{fill:#61c7e3;}.cls-288{fill:#60c6e2;}.cls-289{fill:#5fc5e1;}.cls-290{fill:#5ec4e0;}.cls-291{fill:#5dc3df;}.cls-292{fill:#5cc3df;}.cls-293{fill:#5bc2de;}.cls-294{fill:#5ac1dd;}.cls-295{fill:#59c0dc;}.cls-296{fill:#58bfdc;}.cls-297{fill:#57bedb;}.cls-298{fill:#56bdda;}.cls-299{fill:#55bcd9;}.cls-300{fill:#54bbd8;}.cls-301{fill:#53bad8;}.cls-302{fill:#52b9d7;}.cls-303{fill:#51b9d6;}.cls-304{fill:#50b8d5;}.cls-305{fill:#4fb7d4;}.cls-306{fill:#4eb6d4;}.cls-307{fill:#4db5d3;}.cls-308{fill:#4cb4d2;}.cls-309{fill:#4bb3d1;}.cls-310{fill:#4ab2d0;}.cls-311{fill:#49b1d0;}.cls-312{fill:#48b0cf;}.cls-313{fill:#47afce;}.cls-314{fill:#46afcd;}.cls-315{fill:#45aecc;}.cls-316{fill:#44adcc;}.cls-317{fill:#43accb;}.cls-318{fill:#42abca;}.cls-319{fill:#41aac9;}.cls-320{fill:#40a9c8;}.cls-321{fill:#3fa8c8;}.cls-322{fill:#3ea7c7;}.cls-323{fill:#3da6c6;}.cls-324{fill:#3ca5c5;}.cls-325{fill:#3ba4c4;}.cls-326{fill:#3aa3c3;}.cls-327{fill:#39a2c2;}.cls-328{fill:#38a1c1;}.cls-329{fill:#37a0c1;}.cls-330{fill:#369fc0;}.cls-331{fill:#359ebf;}.cls-332{fill:#349dbe;}.cls-333{fill:#339cbd;}.cls-334{fill:#329bbd;}.cls-335{fill:#319abc;}.cls-336{fill:#309abb;}.cls-337{fill:#2f99ba;}.cls-338{fill:#2e98b9;}.cls-339{fill:#2d97b9;}.cls-340{fill:#2c96b8;}.cls-341{fill:#2b95b7;}.cls-342{fill:#2a94b6;}.cls-343{fill:#2993b5;}.cls-344{fill:#2892b5;}.cls-345{fill:#2791b4;}.cls-346{fill:#2690b3;}.cls-347{fill:#2590b2;}.cls-348{fill:#248fb1;}.cls-349{fill:#238eb1;}.cls-350{fill:#228db0;}.cls-351{fill:#218caf;}.cls-352{fill:#208bae;}.cls-353{fill:#1f8aad;}.cls-354{fill:#1e89ad;}.cls-355{fill:#1d88ac;}.cls-356{fill:#1c87ab;}.cls-357{fill:#1b86aa;}.cls-358{fill:#1a86aa;}.cls-359{fill:#1985a9;}.cls-360{fill:#1884a8;}.cls-361{fill:#1783a7;}.cls-362{fill:#1682a6;}.cls-363{fill:#1581a6;}.cls-364{fill:#1480a5;}.cls-365{fill:#137fa4;}.cls-366{fill:#127ea3;}.cls-367{fill:#117da2;}.cls-368{fill:#107ca2;}.cls-369{fill:#0f7ba1;}.cls-370{fill:#0e7ba0;}.cls-371{fill:#0d7a9f;}.cls-372{fill:#0c799e;}.cls-373{fill:#0b789e;}.cls-374{fill:#0a779d;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2",
    cx: 406.83,
    cy: 28065.81,
    r: 25.71,
    gradientTransform: "matrix(0.11, 2.09, 0.78, -0.04, -21957.02, 532.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-2",
    cx: 479.59,
    cy: 28199.96,
    r: 25.71,
    gradientTransform: "matrix(0.88, 1.59, 0.72, -0.4, -20788.44, 10902.12)",
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-3",
    cx: 361.45,
    cy: 29141.2,
    r: 39.71,
    gradientTransform: "matrix(-0.84, 2.4, 1.15, 0.4, -33000.4, -12266.87)",
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-4",
    cx: 356.72,
    cy: 29166.1,
    r: 7.61,
    gradientTransform: "matrix(-0.01, 2.56, 2.86, 0.01, -83253.49, -1003.6)",
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.83,311c11.78-.61,20.07-25.56,18.52-55.74S60,201.08,48.22,201.69s-20.08,25.56-18.53,55.74S42.05,311.58,53.83,311Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96.19,377.58c10.91-6.05,9.47-29.51-3.22-52.41s-31.83-36.56-42.74-30.51-9.46,29.51,3.23,52.41S85.28,383.63,96.19,377.58Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.14,
    y: 75.94,
    width: 22.77,
    height: 46.1,
    rx: 8.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.53,115V84.8c0-3.69,2.69-6.68,6-6.68h7.32a5.47,5.47,0,0,1,2.41.56,5.66,5.66,0,0,0-3.83-1.53H79.13c-3.32,0-6,3-6,6.69V114a6.73,6.73,0,0,0,3.6,6.12A7,7,0,0,1,74.53,115Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 66.03,
    y: 81.87,
    width: 6.11,
    height: 33.7,
    rx: 2.37,
    transform: "translate(138.17 197.44) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.31,113V85.49A2.44,2.44,0,0,1,69.65,83h.8a2.25,2.25,0,0,1,1,.27,2.28,2.28,0,0,0-1.66-.74H69A2.44,2.44,0,0,0,66.68,85v27.51A2.54,2.54,0,0,0,68,114.78,2.64,2.64,0,0,1,67.31,113Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.95,
    y: 89.28,
    width: 4.07,
    height: 19.72,
    rx: 1.58,
    transform: "translate(127.98 198.27) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.08,107.81V92.11a1.48,1.48,0,0,1,1.41-1.55h.7a1.28,1.28,0,0,1,.44.09,1.37,1.37,0,0,0-1.16-.71h-.7a1.5,1.5,0,0,0-1.42,1.56v15.69a1.54,1.54,0,0,0,1,1.46A1.62,1.62,0,0,1,63.08,107.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.89,386c26.73,9.33,63.51-26.43,82.15-79.86s12.1-104.3-14.62-113.63-63.5,26.43-82.15,79.86S134.17,376.69,160.89,386Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M164.39,199.77c12.74,0,23.1-8.76,23.13-19.68s-10.26-19.78-23-19.83-23.1,8.77-23.14,19.68S151.65,199.73,164.39,199.77Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 149.35,
    y: 165.01,
    width: 28.51,
    height: 20.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M177.86,165v12.63a75,75,0,0,1-28.51-.63V165Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M240.26,96.5a74.49,74.49,0,0,1-12.44,41.35c-1.2,1.84-2.48,3.61-3.86,5.33a75,75,0,1,1,16.3-46.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M189.86,151.15v2.19A72.48,72.48,0,0,0,224,143.18c1.38-1.72,2.66-3.49,3.86-5.33C217.9,145.65,204.28,150.52,189.86,151.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M188.37,147.59h-.74a1.52,1.52,0,0,0-.48.1,6.56,6.56,0,0,0-6.2-4.47h-25a6.57,6.57,0,0,0-6.57,6.57v2a6.57,6.57,0,0,0,6.57,6.57h25a6.54,6.54,0,0,0,5.67-3.3,1.45,1.45,0,0,0,1,.41h.74a1.48,1.48,0,0,0,1.48-1.48v-5A1.48,1.48,0,0,0,188.37,147.59Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.69,31.92c11.27,0,35.36,6.21,42.86,13.76-67.49-68-168.83,45.68-93.48,105C72,112.83,115.5,31.92,170.69,31.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.35,98.44h-4.29a83.79,83.79,0,0,0-167.58,0H77.19a88.08,88.08,0,1,1,176.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M253.35,94.46h-4.29a83.79,83.79,0,0,0-167.58,0H77.19a88.08,88.08,0,1,1,176.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M243.55,121.77c-6.93,18.64-29.13,31.37-53.7,32.58v-2.19c23.18-1,44.3-13,51.27-30.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.72,117.05a163.88,163.88,0,0,1-96.23,0,3.54,3.54,0,0,1-3.54-3.54V86.71a3.53,3.53,0,0,1,3.54-3.54h96.23a3.53,3.53,0,0,1,3.54,3.54v26.8A3.54,3.54,0,0,1,211.72,117.05Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.61,128a171,171,0,0,1-48.76-7.25,7.31,7.31,0,0,1-6.65-7.26V86.71a7.3,7.3,0,0,1,7.29-7.29h96.23A7.3,7.3,0,0,1,219,86.71v26.8a7.31,7.31,0,0,1-6.65,7.26A171,171,0,0,1,163.61,128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M108.38,86.71a7.05,7.05,0,0,1,2.31-5.18,7.65,7.65,0,0,1,5-1.94h96a7.11,7.11,0,0,1,5.95,3.27,7.58,7.58,0,0,1,1.16,4v26.52a7.47,7.47,0,0,1-.85,3.46,7.11,7.11,0,0,1-5.65,3.75,170.81,170.81,0,0,1-48.72,7.25,170.82,170.82,0,0,1-48.73-7.25,7.09,7.09,0,0,1-5.29-3.16,7.62,7.62,0,0,1-1.21-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M108.55,86.71a6.85,6.85,0,0,1,2.38-5.1A8.14,8.14,0,0,1,116,79.77h95.73a6.94,6.94,0,0,1,5.83,3.28,8,8,0,0,1,1.11,4v26.22a7.88,7.88,0,0,1-.82,3.43,6.93,6.93,0,0,1-5.54,3.75,170.59,170.59,0,0,1-48.69,7.24,170.66,170.66,0,0,1-48.7-7.24,6.94,6.94,0,0,1-5.2-3.18,8.12,8.12,0,0,1-1.16-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M108.73,86.71a6.65,6.65,0,0,1,2.44-5A8.68,8.68,0,0,1,116.24,80h95.48a6.74,6.74,0,0,1,5.71,3.29,8.33,8.33,0,0,1,1,3.94v25.93a8.38,8.38,0,0,1-.77,3.4,6.76,6.76,0,0,1-5.44,3.73,170.39,170.39,0,0,1-48.66,7.24,170.4,170.4,0,0,1-48.67-7.24,6.7,6.7,0,0,1-5.11-3.2,8.59,8.59,0,0,1-1.1-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M108.91,86.71a6.47,6.47,0,0,1,2.5-4.94,9.39,9.39,0,0,1,5.08-1.64h95.23a6.58,6.58,0,0,1,5.59,3.3,8.84,8.84,0,0,1,1,3.91V113a8.76,8.76,0,0,1-.73,3.36,6.54,6.54,0,0,1-5.33,3.72,170.24,170.24,0,0,1-48.63,7.24A170.25,170.25,0,0,1,115,120.06a6.49,6.49,0,0,1-5-3.22,9,9,0,0,1-1-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M109.09,86.71a6.3,6.3,0,0,1,2.56-4.86,10.18,10.18,0,0,1,5.09-1.54h95a6.39,6.39,0,0,1,5.47,3.32,9.34,9.34,0,0,1,.93,3.86v25.36a9.36,9.36,0,0,1-.68,3.32,6.37,6.37,0,0,1-5.23,3.71,170.05,170.05,0,0,1-48.6,7.25A170.07,170.07,0,0,1,115,119.88a6.31,6.31,0,0,1-4.93-3.23,9.69,9.69,0,0,1-1-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M109.27,86.71a6.08,6.08,0,0,1,2.62-4.77,10.89,10.89,0,0,1,5.1-1.45h94.73a6.22,6.22,0,0,1,5.35,3.33,9.9,9.9,0,0,1,.87,3.83v25.06a10,10,0,0,1-.64,3.3,6.22,6.22,0,0,1-5.12,3.7A169.78,169.78,0,0,1,163.61,127,169.8,169.8,0,0,1,115,119.71a6.17,6.17,0,0,1-4.85-3.26,10.46,10.46,0,0,1-.91-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M109.45,86.71A5.93,5.93,0,0,1,112.13,82a12,12,0,0,1,5.11-1.35h94.48A6.07,6.07,0,0,1,217,84a10.79,10.79,0,0,1,.81,3.8v24.77a10.58,10.58,0,0,1-.59,3.26,6,6,0,0,1-5,3.69,169.63,169.63,0,0,1-48.54,7.24,169.65,169.65,0,0,1-48.55-7.24,6,6,0,0,1-4.76-3.27,11.48,11.48,0,0,1-.85-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M109.63,86.71a5.76,5.76,0,0,1,2.74-4.61,13.31,13.31,0,0,1,5.12-1.26h94.23a5.91,5.91,0,0,1,5.11,3.36,11.65,11.65,0,0,1,.75,3.76v24.49a11.38,11.38,0,0,1-.55,3.22,5.86,5.86,0,0,1-4.91,3.68,169.43,169.43,0,0,1-48.51,7.24,169.45,169.45,0,0,1-48.52-7.24,5.81,5.81,0,0,1-4.67-3.29,12.41,12.41,0,0,1-.79-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M109.8,86.71a5.62,5.62,0,0,1,2.81-4.53A14.86,14.86,0,0,1,117.74,81h94a5.75,5.75,0,0,1,5,3.38,12.59,12.59,0,0,1,.7,3.72v24.2a12.37,12.37,0,0,1-.52,3.19,5.7,5.7,0,0,1-4.8,3.67,169.21,169.21,0,0,1-48.48,7.23,169.23,169.23,0,0,1-48.49-7.23,5.65,5.65,0,0,1-4.58-3.32,13.49,13.49,0,0,1-.74-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M110,86.71a4.82,4.82,0,0,1,2.87-4.45c.68-.65,4.11-1.06,5.14-1.06h93.73a5.56,5.56,0,0,1,4.87,3.39,13.91,13.91,0,0,1,.64,3.69v23.9a13.54,13.54,0,0,1-.47,3.16,5.54,5.54,0,0,1-4.7,3.66,169,169,0,0,1-48.45,7.23A169,169,0,0,1,115.15,119a5.49,5.49,0,0,1-4.5-3.33,15.4,15.4,0,0,1-.67-3.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M110.16,86.71a4.64,4.64,0,0,1,2.93-4.36c.62-.6,4.22-1,5.15-1h93.48a5.42,5.42,0,0,1,4.75,3.4,15.63,15.63,0,0,1,.58,3.66v23.61a15.14,15.14,0,0,1-.43,3.12,5.37,5.37,0,0,1-4.59,3.65,168.83,168.83,0,0,1-48.42,7.24,168.89,168.89,0,0,1-48.43-7.24,5.34,5.34,0,0,1-4.41-3.35,17.25,17.25,0,0,1-.61-3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M110.34,86.71a4.5,4.5,0,0,1,3-4.28c.56-.54,4.32-.87,5.16-.87h93.23A5.27,5.27,0,0,1,216.35,85a17.18,17.18,0,0,1,.52,3.62v23.33a17.41,17.41,0,0,1-.38,3.09,5.22,5.22,0,0,1-4.49,3.63,168.28,168.28,0,0,1-48.39,7.24,168.29,168.29,0,0,1-48.4-7.24c-2.07-.08-3.5-1.61-4.32-3.37a19,19,0,0,1-.55-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M110.52,86.71a4.36,4.36,0,0,1,3-4.2c.5-.48,4.42-.77,5.17-.77h93c2.18,0,3.68,1.58,4.51,3.43a19.8,19.8,0,0,1,.46,3.58v23a19,19,0,0,1-.34,3,5.08,5.08,0,0,1-4.38,3.63,168.41,168.41,0,0,1-48.36,7.23,168.42,168.42,0,0,1-48.37-7.23,4.53,4.53,0,0,1-4.23-3.39,15.82,15.82,0,0,1-.49-3.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M110.7,86.71a4.21,4.21,0,0,1,3.11-4.12c.43-.42,4.52-.67,5.18-.67h92.73a4.48,4.48,0,0,1,4.39,3.44,16.36,16.36,0,0,1,.4,3.55v22.74a21.16,21.16,0,0,1-.3,3c-.68,1.92-2.14,3.55-4.27,3.62a168.26,168.26,0,0,1-48.33,7.23,168.27,168.27,0,0,1-48.34-7.23,4.39,4.39,0,0,1-4.15-3.41,17.91,17.91,0,0,1-.42-3.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M110.88,86.71a4.1,4.1,0,0,1,3.17-4c.37-.36,4.63-.58,5.19-.58h92.48A4.33,4.33,0,0,1,216,85.55a17.51,17.51,0,0,1,.35,3.52v22.45a26.59,26.59,0,0,1-.25,3c-.66,1.9-2.07,3.54-4.17,3.6a168,168,0,0,1-48.3,7.23,168,168,0,0,1-48.31-7.23,4.23,4.23,0,0,1-4.06-3.42,21,21,0,0,1-.36-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M111.05,86.71a4,4,0,0,1,3.24-3.95c.31-.3,4.73-.49,5.2-.49h92.23a4.18,4.18,0,0,1,4.14,3.47,20.86,20.86,0,0,1,.3,3.48v22.17a20.38,20.38,0,0,1-.22,3,4.19,4.19,0,0,1-4.06,3.59,167.51,167.51,0,0,1-48.27,7.23,167.41,167.41,0,0,1-48.27-7.23,4.1,4.1,0,0,1-4-3.44,25.16,25.16,0,0,1-.31-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M111.23,86.71a3.88,3.88,0,0,1,3.3-3.87,36.57,36.57,0,0,1,5.21-.39h92a4,4,0,0,1,4,3.49,25.8,25.8,0,0,1,.24,3.44v21.88a25.14,25.14,0,0,1-.17,2.91,4.07,4.07,0,0,1-4,3.59A167.52,167.52,0,0,1,163.61,125a167.54,167.54,0,0,1-48.24-7.22,4,4,0,0,1-3.89-3.47,29.61,29.61,0,0,1-.25-3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M111.41,86.71a3.78,3.78,0,0,1,3.36-3.79,49.31,49.31,0,0,1,5.21-.29h91.74a3.89,3.89,0,0,1,3.9,3.5c.11.16.18,3.19.18,3.41v21.58c0,.19-.05,2.74-.13,2.89a3.92,3.92,0,0,1-3.86,3.57,167.29,167.29,0,0,1-48.2,7.23,167.35,167.35,0,0,1-48.21-7.23,3.88,3.88,0,0,1-3.81-3.48c-.11-.17-.18-3.58-.18-3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M111.59,86.71A3.71,3.71,0,0,1,115,83c.12-.12,5-.19,5.22-.19h91.49a3.78,3.78,0,0,1,3.78,3.51c.08.11.12,3.23.12,3.38V111c0,.12,0,2.75-.08,2.85a3.79,3.79,0,0,1-3.76,3.56,166.79,166.79,0,0,1-48.17,7.23,166.81,166.81,0,0,1-48.18-7.23,3.75,3.75,0,0,1-3.72-3.5c-.08-.11-.12-3.63-.12-3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M111.77,86.71a3.63,3.63,0,0,1,3.48-3.63c.06-.06,5.14-.09,5.23-.09h91.24a3.65,3.65,0,0,1,3.66,3.52c0,.06.06,3.27.06,3.34v21c0,.06,0,2.76,0,2.81a3.67,3.67,0,0,1-3.65,3.56,166.92,166.92,0,0,1-48.14,7.22,166.94,166.94,0,0,1-48.15-7.22,3.65,3.65,0,0,1-3.63-3.53s-.06-3.68-.06-3.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.72,117.05a163.88,163.88,0,0,1-96.23,0,3.54,3.54,0,0,1-3.54-3.54V86.71a3.53,3.53,0,0,1,3.54-3.54h96.23a3.53,3.53,0,0,1,3.54,3.54v26.8A3.54,3.54,0,0,1,211.72,117.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.4,100.71a6.25,6.25,0,1,1-6.24-6.25A6.24,6.24,0,0,1,142.4,100.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 136.16,
    cy: 100.71,
    r: 5.23,
    transform: "translate(-33.19 102.67) rotate(-37.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M197.63,100.71a6.25,6.25,0,1,1-6.25-6.25A6.25,6.25,0,0,1,197.63,100.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 191.38,
    cy: 100.71,
    r: 5.23,
    transform: "translate(49.25 263.71) rotate(-76.67)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.64,
    y: 75.67,
    width: 22.77,
    height: 46.1,
    rx: 8.83,
    transform: "translate(496.05 197.44) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M257,114.67V84.53c0-3.7-2.7-6.69-6-6.69h-7.32a5.52,5.52,0,0,0-2.42.57,5.63,5.63,0,0,1,3.83-1.53h7.32c3.33,0,6,3,6,6.68v30.15a6.76,6.76,0,0,1-3.6,6.12A7,7,0,0,0,257,114.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 259.41,
    y: 81.59,
    width: 6.11,
    height: 33.7,
    rx: 2.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M264.25,112.72V85.21a2.44,2.44,0,0,0-2.35-2.52h-.8a2.25,2.25,0,0,0-1,.26,2.27,2.27,0,0,1,1.66-.73h.79a2.44,2.44,0,0,1,2.35,2.52v27.51a2.54,2.54,0,0,1-1.31,2.25A2.61,2.61,0,0,0,264.25,112.72Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.52,
    y: 89,
    width: 4.07,
    height: 19.72,
    rx: 1.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M268.48,107.53V91.84a1.5,1.5,0,0,0-1.42-1.56h-.7a1.34,1.34,0,0,0-.44.1,1.39,1.39,0,0,1,1.16-.72h.71a1.49,1.49,0,0,1,1.41,1.56v15.69a1.53,1.53,0,0,1-1,1.46A1.6,1.6,0,0,0,268.48,107.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.7,
    y: 192.04,
    width: 22.4,
    height: 22.4,
    transform: "translate(449.59 466.44) rotate(-164.81)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M285.46,216.2a11.4,11.4,0,0,1-.75,1.07,13.86,13.86,0,0,1-1.1,1.31,15,15,0,0,1-10.84,4.61,15,15,0,0,1-13.88-9.34,15.11,15.11,0,0,1-1.11-5.67,15,15,0,0,1,15-15,14.71,14.71,0,0,1,5.08.9c.27.09.54.2.81.32a14,14,0,0,1,2.1,1.1,14.9,14.9,0,0,1,4.2,4,15.22,15.22,0,0,1,1.81,3.37l.1.28A15,15,0,0,1,285.46,216.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M280.67,200.14h0a10.41,10.41,0,0,1,0,14.71h0a10.4,10.4,0,0,1-4.38,2.62,10.4,10.4,0,1,0-3.51-20.36A10.38,10.38,0,0,1,280.67,200.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M257.24,205.62,219.87,347.75a16.16,16.16,0,0,1-15.62,12h-80a15.53,15.53,0,0,1-2.47-.19c-.21,0-.43-.07-.64-.11s-.43-.08-.65-.14l-.15,0a15.84,15.84,0,0,1-4.13-1.67c-.24-.13-.49-.29-.73-.44a16.12,16.12,0,0,1-6.81-9.28L72.82,217.47c-2.45-8.92-6-16.4-2.3-22.73a16.11,16.11,0,0,1,14.66-9.37H241.63A16.13,16.13,0,0,1,257.24,205.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 186.15,
    y: 149.01,
    width: 3.7,
    height: 7.92,
    rx: 1.44,
    transform: "translate(376 305.94) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 149.35,
    y: 144.64,
    width: 38.18,
    height: 15.18,
    rx: 5.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.46,145.39H156.41a6.13,6.13,0,0,0-6.31,6v.88a6.14,6.14,0,0,1,6.31-6h24.05a6.15,6.15,0,0,1,6.32,6v-.88A6.14,6.14,0,0,0,180.46,145.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.41,159.48h24.05c3.49,0,6.32-2.47,6.32-5.51v-.82c0,3-2.83,5.51-6.32,5.51H156.41c-3.49,0-6.31-2.46-6.31-5.51V154C150.1,157,152.92,159.48,156.41,159.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.4,284.36h0A9.94,9.94,0,0,1,269,295.52h0a10,10,0,0,1-11.17,8.56h0a9.94,9.94,0,0,1-8.55-11.17h0A9.94,9.94,0,0,1,260.4,284.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M266.07,294.25h0a8.14,8.14,0,0,1-9.14,7h0a8.17,8.17,0,0,1-3.71-1.48,8.14,8.14,0,1,0,11-11.86A8.12,8.12,0,0,1,266.07,294.25Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.21,343.58a16.25,16.25,0,0,1-15.62-11.91L87.46,222.07a16.19,16.19,0,0,1,15.62-20.49H223.73A16.19,16.19,0,0,1,239.4,221.9L210.57,331.5a16.21,16.21,0,0,1-15.67,12.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M90.24,208a16.12,16.12,0,0,1,12.89-6.36H223.68a16.2,16.2,0,0,1,15.7,20.28l-1.67,6.39L210.56,331.5a16.21,16.21,0,0,1-15.67,12.07H133.22a16.24,16.24,0,0,1-15.62-11.9L89.23,228.45s-1.76-6.4-1.76-6.41A16,16,0,0,1,90.24,208Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M90.29,207.94a16.17,16.17,0,0,1,12.88-6.34H223.63a16.22,16.22,0,0,1,15.74,20.24s-1.67,6.38-1.67,6.4L210.54,331.49a16.2,16.2,0,0,1-15.66,12.06H133.23a16.15,16.15,0,0,1-15.61-11.88L89.23,228.42S87.48,222,87.49,222A16.06,16.06,0,0,1,90.29,207.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M90.34,207.93a16.23,16.23,0,0,1,12.88-6.31H223.59a16.27,16.27,0,0,1,12.82,6.23,16.06,16.06,0,0,1,2.94,14s-1.65,6.37-1.66,6.4L210.53,331.49a16.21,16.21,0,0,1-15.66,12.05H133.25a16.25,16.25,0,0,1-15.62-11.88L89.24,228.39S87.49,222,87.5,222A16,16,0,0,1,90.34,207.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M90.39,207.92a16.31,16.31,0,0,1,12.88-6.29H223.54a16.33,16.33,0,0,1,12.82,6.21,16.08,16.08,0,0,1,3,13.93s-1.65,6.37-1.66,6.41l-27.17,103.3a16.16,16.16,0,0,1-12.46,11.73,16.83,16.83,0,0,1-3.19.31h-61.6a16.16,16.16,0,0,1-15.61-11.86l-28.4-103.3S87.5,222,87.51,222A16.06,16.06,0,0,1,90.39,207.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M90.44,207.9a16.38,16.38,0,0,1,12.87-6.25H223.49a16.38,16.38,0,0,1,12.82,6.18,16.08,16.08,0,0,1,3,13.91s-1.63,6.36-1.64,6.41L210.5,331.48a16.21,16.21,0,0,1-15.66,12H133.27a17,17,0,0,1-3.13-.3,16.18,16.18,0,0,1-12.48-11.56L89.25,228.34c0-.05-1.73-6.38-1.72-6.42A16.05,16.05,0,0,1,90.44,207.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M90.5,207.89a16.4,16.4,0,0,1,12.86-6.23H223.45a16.43,16.43,0,0,1,12.81,6.16,16,16,0,0,1,3.05,13.89s-1.63,6.35-1.64,6.41L210.49,331.48A16.16,16.16,0,0,1,198,343.18a16.94,16.94,0,0,1-3.2.31H133.28a16.17,16.17,0,0,1-15.61-11.84L89.26,228.31c0-.06-1.73-6.37-1.72-6.42A16,16,0,0,1,90.5,207.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M90.55,207.88a16.46,16.46,0,0,1,12.86-6.2h120a16.49,16.49,0,0,1,12.81,6.13,16,16,0,0,1,3.08,13.87c0,.06-1.61,6.35-1.63,6.41L210.47,331.47A16.14,16.14,0,0,1,198,343.17a17,17,0,0,1-3.2.31H133.29a16.92,16.92,0,0,1-3.12-.3,16.17,16.17,0,0,1-12.48-11.53L89.27,228.28c0-.07-1.73-6.37-1.71-6.43A16,16,0,0,1,90.55,207.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M90.6,207.87a16.51,16.51,0,0,1,12.85-6.18h119.9a16.54,16.54,0,0,1,12.81,6.11,16.07,16.07,0,0,1,3.12,13.85c0,.07-1.61,6.34-1.63,6.41L210.46,331.47A16.1,16.1,0,0,1,198,343.15a16.75,16.75,0,0,1-3.19.31H133.3a17,17,0,0,1-3.12-.29,16.17,16.17,0,0,1-12.48-11.53L89.28,228.25c0-.08-1.73-6.36-1.71-6.43A16,16,0,0,1,90.6,207.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M90.65,207.86a16.56,16.56,0,0,1,12.85-6.15H223.31a16.6,16.6,0,0,1,12.8,6.08,16,16,0,0,1,3.15,13.83c0,.08-1.59,6.33-1.61,6.41L210.44,331.47A16.09,16.09,0,0,1,198,343.14a16.83,16.83,0,0,1-3.19.31H133.31a16.92,16.92,0,0,1-3.12-.3,16.13,16.13,0,0,1-12.47-11.51L89.28,228.22c0-.09-1.72-6.35-1.69-6.43A16,16,0,0,1,90.65,207.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M90.7,207.85a16.64,16.64,0,0,1,12.85-6.13H223.26a16.64,16.64,0,0,1,12.8,6.06,16,16,0,0,1,3.19,13.81c0,.08-1.59,6.32-1.61,6.42L210.43,331.46A16.09,16.09,0,0,1,198,343.13a17.69,17.69,0,0,1-3.19.3H133.32a17,17,0,0,1-3.12-.29,16.14,16.14,0,0,1-12.47-11.5L89.29,228.19c0-.09-1.71-6.34-1.69-6.43A16,16,0,0,1,90.7,207.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M90.75,207.84a16.67,16.67,0,0,1,12.84-6.1H223.21a16.71,16.71,0,0,1,12.79,6,16,16,0,0,1,3.23,13.79c0,.09-1.57,6.31-1.6,6.42L210.41,331.46A16.06,16.06,0,0,1,198,343.11a16.91,16.91,0,0,1-3.19.31H133.34a16.92,16.92,0,0,1-3.12-.3,16.08,16.08,0,0,1-12.47-11.49L89.3,228.16c0-.1-1.71-6.34-1.68-6.43A16,16,0,0,1,90.75,207.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M90.8,207.83a16.74,16.74,0,0,1,12.84-6.08H223.17a16.76,16.76,0,0,1,12.78,6,16,16,0,0,1,3.27,13.77c0,.1-1.57,6.3-1.6,6.42L210.4,331.45A16.07,16.07,0,0,1,198,343.1a16.72,16.72,0,0,1-3.18.3H133.35a16.92,16.92,0,0,1-3.12-.29,16.1,16.1,0,0,1-12.47-11.48L89.31,228.13c0-.11-1.71-6.33-1.68-6.43A16,16,0,0,1,90.8,207.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M90.85,207.82a16.79,16.79,0,0,1,12.84-6H223.12a16.82,16.82,0,0,1,12.78,6,16,16,0,0,1,3.3,13.75c0,.11-1.55,6.3-1.59,6.42L210.39,331.45a16.07,16.07,0,0,1-12.45,11.64,17.69,17.69,0,0,1-3.19.3H133.36a17.92,17.92,0,0,1-3.12-.29,16.1,16.1,0,0,1-12.47-11.48L89.31,228.1c0-.12-1.7-6.32-1.66-6.43A15.93,15.93,0,0,1,90.85,207.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M90.9,207.81a16.87,16.87,0,0,1,12.83-6H223.07a16.88,16.88,0,0,1,12.78,6,16,16,0,0,1,3.34,13.72c0,.12-1.55,6.3-1.58,6.43L210.37,331.45a16,16,0,0,1-12.44,11.62,16.83,16.83,0,0,1-3.19.3H133.37a17,17,0,0,1-3.12-.29,16,16,0,0,1-12.46-11.46L89.32,228.07c0-.13-1.7-6.32-1.66-6.43A16,16,0,0,1,90.9,207.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M91,207.8a16.91,16.91,0,0,1,12.83-6H223a17,17,0,0,1,12.77,5.93,15.93,15.93,0,0,1,3.37,13.7c0,.13-1.53,6.29-1.57,6.43L210.36,331.44a16,16,0,0,1-12.44,11.62,17.69,17.69,0,0,1-3.19.3H133.38a17,17,0,0,1-3.12-.29,16.08,16.08,0,0,1-12.46-11.45L89.33,228.05c0-.15-1.69-6.32-1.66-6.45A15.94,15.94,0,0,1,91,207.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M91,207.79a17,17,0,0,1,12.83-6H223a17,17,0,0,1,12.77,5.91,15.92,15.92,0,0,1,3.41,13.68c0,.14-1.53,6.28-1.57,6.43L210.34,331.44a16,16,0,0,1-12.44,11.61,17.58,17.58,0,0,1-3.18.3H133.39a17.72,17.72,0,0,1-3.11-.29,16,16,0,0,1-12.46-11.45L89.33,228c0-.15-1.68-6.31-1.64-6.45A15.91,15.91,0,0,1,91,207.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M91.05,207.78a17.07,17.07,0,0,1,12.82-5.95H222.93a17.05,17.05,0,0,1,12.77,5.88,15.92,15.92,0,0,1,3.44,13.66c.05.15-1.51,6.27-1.56,6.43L210.33,331.44A16,16,0,0,1,197.89,343a17.58,17.58,0,0,1-3.18.3H133.4a16.9,16.9,0,0,1-3.11-.29,16,16,0,0,1-12.46-11.43L89.34,228c0-.16-1.68-6.3-1.64-6.45A15.94,15.94,0,0,1,91.05,207.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M91.1,207.77a17.12,17.12,0,0,1,12.82-5.93h119a17.13,17.13,0,0,1,12.76,5.86,15.93,15.93,0,0,1,3.48,13.64c.05.15-1.51,6.27-1.55,6.43L210.32,331.43A16,16,0,0,1,197.88,343a17.66,17.66,0,0,1-3.18.3H133.41a17.81,17.81,0,0,1-3.11-.29,16.05,16.05,0,0,1-12.46-11.43L89.35,228c0-.17-1.68-6.3-1.63-6.45A15.91,15.91,0,0,1,91.1,207.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M91.15,207.76A17.2,17.2,0,0,1,104,201.85H222.84a17.18,17.18,0,0,1,12.76,5.84,15.89,15.89,0,0,1,3.51,13.62c0,.16-1.49,6.26-1.54,6.44L210.3,331.43A16,16,0,0,1,197.87,343a18.62,18.62,0,0,1-3.18.29H133.42a17.9,17.9,0,0,1-3.11-.28,16,16,0,0,1-12.45-11.42L89.36,227.93c0-.18-1.68-6.29-1.63-6.45A15.91,15.91,0,0,1,91.15,207.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M91.2,207.75A17.26,17.26,0,0,1,104,201.87H222.79a17.26,17.26,0,0,1,12.76,5.81,15.93,15.93,0,0,1,3.55,13.6c.05.17-1.49,6.25-1.54,6.44l-27.27,103.7A16,16,0,0,1,197.85,343a17.58,17.58,0,0,1-3.18.3H133.44a17.72,17.72,0,0,1-3.11-.29,16,16,0,0,1-12.46-11.4L89.36,227.9c0-.19-1.67-6.28-1.61-6.45A15.88,15.88,0,0,1,91.2,207.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M91.25,207.74a17.33,17.33,0,0,1,12.81-5.86H222.75a17.32,17.32,0,0,1,12.75,5.79,15.89,15.89,0,0,1,3.58,13.58c.06.18-1.47,6.24-1.53,6.44L210.27,331.42A16,16,0,0,1,197.84,343a18.53,18.53,0,0,1-3.18.29H133.45a17.72,17.72,0,0,1-3.11-.28,16,16,0,0,1-12.45-11.4L89.37,227.87c-.05-.2-1.66-6.27-1.61-6.45A15.9,15.9,0,0,1,91.25,207.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M91.3,207.73a17.39,17.39,0,0,1,12.81-5.83H222.7a17.39,17.39,0,0,1,12.75,5.76,15.91,15.91,0,0,1,3.62,13.56c.06.18-1.47,6.23-1.52,6.44L210.26,331.42A16,16,0,0,1,197.83,343a18.53,18.53,0,0,1-3.18.29H133.46a18.73,18.73,0,0,1-3.11-.28,16,16,0,0,1-12.45-11.39L89.38,227.84c-.06-.21-1.66-6.27-1.6-6.45A15.87,15.87,0,0,1,91.3,207.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M91.35,207.72a17.47,17.47,0,0,1,12.81-5.81H222.65a17.46,17.46,0,0,1,12.75,5.74,15.9,15.9,0,0,1,3.65,13.54c.07.19-1.45,6.22-1.51,6.44l-27.3,103.78A15.9,15.9,0,0,1,197.82,343a18.62,18.62,0,0,1-3.18.29H133.47a17.81,17.81,0,0,1-3.11-.28,15.94,15.94,0,0,1-12.44-11.38L89.39,227.81c-.06-.21-1.66-6.26-1.6-6.46A15.86,15.86,0,0,1,91.35,207.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M91.4,207.71a17.51,17.51,0,0,1,12.8-5.78H222.61a17.52,17.52,0,0,1,12.74,5.71A15.86,15.86,0,0,1,239,221.15c.06.21-1.45,6.23-1.51,6.45l-27.3,103.81a15.91,15.91,0,0,1-12.43,11.53,18.41,18.41,0,0,1-3.17.29H133.48a18.83,18.83,0,0,1-3.11-.28,15.94,15.94,0,0,1-12.44-11.37L89.39,227.78c-.06-.22-1.65-6.25-1.58-6.46A15.86,15.86,0,0,1,91.4,207.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M91.46,207.7a17.55,17.55,0,0,1,12.79-5.76H222.56a17.63,17.63,0,0,1,12.74,5.69A15.85,15.85,0,0,1,239,221.12c.07.22-1.43,6.22-1.5,6.45l-27.3,103.84a15.92,15.92,0,0,1-12.43,11.52,18.5,18.5,0,0,1-3.17.28H133.49a18.71,18.71,0,0,1-3.1-.27,16,16,0,0,1-12.45-11.36L89.4,227.76c-.07-.24-1.65-6.26-1.58-6.47A15.81,15.81,0,0,1,91.46,207.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M91.51,207.69A17.63,17.63,0,0,1,104.3,202H222.51a17.69,17.69,0,0,1,12.74,5.66A15.89,15.89,0,0,1,239,221.09c.07.22-1.43,6.21-1.49,6.45L210.2,331.4a15.88,15.88,0,0,1-12.42,11.51,18.5,18.5,0,0,1-3.17.29H133.5a17.78,17.78,0,0,1-3.1-.28A15.92,15.92,0,0,1,118,331.57L89.41,227.73c-.07-.25-1.64-6.25-1.58-6.47A15.84,15.84,0,0,1,91.51,207.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M91.56,207.68A17.68,17.68,0,0,1,104.34,202H222.47a17.75,17.75,0,0,1,12.73,5.64A15.83,15.83,0,0,1,239,221.06c.08.23-1.42,6.2-1.48,6.46L210.19,331.4a15.9,15.9,0,0,1-12.42,11.5,18.61,18.61,0,0,1-3.18.28H133.51a18.71,18.71,0,0,1-3.1-.27A15.92,15.92,0,0,1,118,331.57L89.41,227.7c-.07-.26-1.63-6.24-1.56-6.47A15.81,15.81,0,0,1,91.56,207.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M91.61,207.67A17.76,17.76,0,0,1,104.39,202h118a17.83,17.83,0,0,1,12.73,5.61A15.86,15.86,0,0,1,239,221c.07.24-1.41,6.19-1.48,6.46L210.17,331.4a15.84,15.84,0,0,1-12.42,11.48,18.41,18.41,0,0,1-3.17.29H133.53a18.83,18.83,0,0,1-3.11-.27A15.9,15.9,0,0,1,118,331.57L89.42,227.67c-.07-.27-1.63-6.23-1.56-6.47A15.8,15.8,0,0,1,91.61,207.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M91.66,207.66A17.84,17.84,0,0,1,104.44,202H222.38a17.91,17.91,0,0,1,12.72,5.59A15.83,15.83,0,0,1,239,221c.08.25-1.4,6.18-1.47,6.46L210.16,331.39a15.86,15.86,0,0,1-12.42,11.48,18.41,18.41,0,0,1-3.17.28h-61a18.61,18.61,0,0,1-3.1-.27A15.88,15.88,0,0,1,118,331.56L89.43,227.64c-.08-.27-1.63-6.23-1.55-6.47A15.8,15.8,0,0,1,91.66,207.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M91.71,207.65A17.9,17.9,0,0,1,104.48,202H222.33a18,18,0,0,1,12.72,5.56A15.84,15.84,0,0,1,239,221c.08.25-1.39,6.18-1.46,6.46l-27.35,104a15.83,15.83,0,0,1-12.41,11.47,19.56,19.56,0,0,1-3.17.28h-61a18.71,18.71,0,0,1-3.1-.27A15.86,15.86,0,0,1,118,331.56L89.44,227.61c-.08-.28-1.63-6.22-1.55-6.47A15.81,15.81,0,0,1,91.71,207.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M91.76,207.64c2.91-3.41,8.29-5.61,12.77-5.61H222.28c4.45,0,9.81,2.18,12.72,5.54a15.84,15.84,0,0,1,3.93,13.37c.09.26-1.38,6.17-1.45,6.46l-27.35,104a15.81,15.81,0,0,1-12.41,11.46,18.5,18.5,0,0,1-3.17.28h-61a18.71,18.71,0,0,1-3.1-.27A15.86,15.86,0,0,1,118,331.55l-28.59-104c-.08-.29-1.61-6.21-1.53-6.48A15.76,15.76,0,0,1,91.76,207.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M91.81,207.63c2.9-3.39,8.31-5.58,12.77-5.58H222.24c4.42,0,9.81,2.17,12.71,5.51a15.81,15.81,0,0,1,4,13.35c.09.27-1.37,6.16-1.45,6.46l-27.35,104a15.82,15.82,0,0,1-12.42,11.45,19.44,19.44,0,0,1-3.16.28h-61a18.8,18.8,0,0,1-3.1-.27A15.85,15.85,0,0,1,118,331.55l-28.59-104c-.08-.3-1.61-6.2-1.53-6.48A15.77,15.77,0,0,1,91.81,207.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M91.86,207.62c2.9-3.37,8.33-5.56,12.76-5.56H222.19c4.41,0,9.81,2.17,12.71,5.49a15.81,15.81,0,0,1,4,13.33c.09.28-1.36,6.15-1.44,6.46l-27.36,104a15.8,15.8,0,0,1-12.41,11.44,19.44,19.44,0,0,1-3.16.28H133.58a19.61,19.61,0,0,1-3.09-.27,15.82,15.82,0,0,1-12.43-11.28l-28.6-104c-.09-.31-1.61-6.2-1.52-6.48A15.77,15.77,0,0,1,91.86,207.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M91.91,207.61c2.89-3.35,8.34-5.53,12.76-5.53H222.14c4.39,0,9.82,2.16,12.71,5.46a15.84,15.84,0,0,1,4,13.31c.09.28-1.35,6.14-1.44,6.46L210.09,331.37a15.77,15.77,0,0,1-12.41,11.43,19.56,19.56,0,0,1-3.17.28H133.59a18.59,18.59,0,0,1-3.09-.27,15.81,15.81,0,0,1-12.43-11.27l-28.61-104c-.08-.32-1.6-6.19-1.51-6.48A15.78,15.78,0,0,1,91.91,207.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M92,207.6c2.88-3.33,8.36-5.51,12.76-5.51H222.1c4.36,0,9.82,2.16,12.7,5.44a15.76,15.76,0,0,1,4.07,13.28c.1.3-1.34,6.15-1.42,6.47L210.07,331.37a15.76,15.76,0,0,1-12.41,11.42,19.24,19.24,0,0,1-3.16.28H133.6a19.72,19.72,0,0,1-3.09-.27,15.8,15.8,0,0,1-12.42-11.26L89.47,227.46c-.09-.33-1.6-6.18-1.5-6.48A15.74,15.74,0,0,1,92,207.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M92,207.58c2.88-3.3,8.38-5.48,12.75-5.48H222.05c4.35,0,9.82,2.16,12.7,5.42a15.81,15.81,0,0,1,4.11,13.26c.1.31-1.33,6.14-1.42,6.48L210.06,331.37a15.76,15.76,0,0,1-12.41,11.41,19.34,19.34,0,0,1-3.16.27H133.61a19.82,19.82,0,0,1-3.09-.26,15.81,15.81,0,0,1-12.42-11.26L89.48,227.44c-.09-.34-1.59-6.19-1.5-6.49A15.78,15.78,0,0,1,92,207.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M92.06,207.57c2.87-3.28,8.39-5.45,12.75-5.45H222c4.33,0,9.83,2.15,12.7,5.39,3.23,3.66,5,8.34,4.15,13.24.1.32-1.33,6.13-1.42,6.48L210.05,331.36a15.75,15.75,0,0,1-12.41,11.4,19.44,19.44,0,0,1-3.16.28H133.63a19.85,19.85,0,0,1-3.1-.27,15.79,15.79,0,0,1-12.42-11.24L89.49,227.41c-.1-.35-1.59-6.18-1.49-6.49C87.06,216,88.83,211.27,92.06,207.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M92.11,207.56c2.87-3.26,8.41-5.43,12.75-5.43H222c4.3,0,9.83,2.15,12.69,5.37,3.23,3.65,5,8.32,4.18,13.22.1.32-1.31,6.12-1.41,6.48L210,331.36a15.74,15.74,0,0,1-12.4,11.39,19.44,19.44,0,0,1-3.16.27H133.64a19.72,19.72,0,0,1-3.09-.26,15.76,15.76,0,0,1-12.42-11.23L89.49,227.38c-.09-.36-1.58-6.17-1.48-6.49C87.09,216,88.88,211.25,92.11,207.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M92.16,207.55c2.86-3.24,8.43-5.4,12.74-5.4h117c4.29,0,9.83,2.14,12.69,5.34,3.23,3.64,5.06,8.3,4.22,13.2.1.33-1.31,6.11-1.4,6.48L210,331.35a15.74,15.74,0,0,1-12.41,11.39,20.49,20.49,0,0,1-3.15.27H133.65a19.62,19.62,0,0,1-3.09-.26,15.76,15.76,0,0,1-12.42-11.23L89.5,227.35c-.1-.37-1.58-6.16-1.48-6.5C87.12,215.93,88.92,211.23,92.16,207.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M92.21,207.54c2.85-3.22,8.44-5.38,12.74-5.38H221.86c4.27,0,9.84,2.14,12.69,5.32,3.24,3.63,5.09,8.28,4.25,13.18.11.34-1.29,6.1-1.39,6.48L210,331.35a15.7,15.7,0,0,1-12.4,11.37,19.31,19.31,0,0,1-3.15.27H133.66a19.72,19.72,0,0,1-3.09-.26,15.73,15.73,0,0,1-12.41-11.21L89.51,227.32c-.11-.38-1.58-6.16-1.47-6.5C87.14,215.9,89,211.21,92.21,207.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M92.26,207.53c2.85-3.2,8.46-5.35,12.74-5.35H221.82c4.25,0,9.84,2.13,12.68,5.29,3.24,3.62,5.11,8.26,4.29,13.16.11.35-1.29,6.1-1.39,6.48L210,331.35a15.7,15.7,0,0,1-12.4,11.36,20.6,20.6,0,0,1-3.15.27H133.67a19.82,19.82,0,0,1-3.09-.26,15.73,15.73,0,0,1-12.41-11.21L89.52,227.29c-.11-.39-1.57-6.15-1.47-6.5C87.17,215.86,89,211.19,92.26,207.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M92.31,207.52c2.84-3.18,8.48-5.33,12.74-5.33H221.77c4.23,0,9.84,2.13,12.67,5.27,3.26,3.61,5.15,8.24,4.33,13.14.11.35-1.27,6.09-1.38,6.48L210,331.34a15.69,15.69,0,0,1-12.39,11.36,20.52,20.52,0,0,1-3.16.26H133.68a20.87,20.87,0,0,1-3.08-.25,15.7,15.7,0,0,1-12.41-11.2L89.52,227.26c-.11-.39-1.56-6.14-1.45-6.5C87.19,215.83,89.06,211.17,92.31,207.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M92.36,207.51c2.83-3.16,8.49-5.3,12.73-5.3H221.72c4.21,0,9.85,2.12,12.67,5.24,3.26,3.6,5.17,8.21,4.37,13.12.11.36-1.27,6.08-1.37,6.48L210,331.34a15.67,15.67,0,0,1-12.4,11.34,20.38,20.38,0,0,1-3.15.27H133.69a19.69,19.69,0,0,1-3.08-.26,15.69,15.69,0,0,1-12.41-11.18L89.53,227.23c-.11-.4-1.56-6.13-1.45-6.5C87.22,215.8,89.11,211.15,92.36,207.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M92.42,207.5c2.82-3.14,8.5-5.28,12.72-5.28H221.68c4.19,0,9.85,2.12,12.66,5.22,3.26,3.59,5.19,8.19,4.4,13.1.12.37-1.25,6.07-1.36,6.49L210,331.34a15.67,15.67,0,0,1-12.4,11.33,20.49,20.49,0,0,1-3.15.26H133.7a21,21,0,0,1-3.08-.25,15.71,15.71,0,0,1-12.41-11.18L89.54,227.2a65.51,65.51,0,0,1-1.44-6.5C87.25,215.77,89.15,211.13,92.42,207.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M92.47,207.49c2.81-3.12,8.52-5.25,12.72-5.25H221.63c4.17,0,9.86,2.11,12.66,5.19,3.27,3.59,5.22,8.17,4.44,13.07.12.39-1.25,6.07-1.36,6.5L209.93,331.33a15.64,15.64,0,0,1-12.39,11.33,21.82,21.82,0,0,1-3.15.26H133.72a21,21,0,0,1-3.09-.25,15.68,15.68,0,0,1-12.4-11.17L89.54,227.17c-.11-.42-1.55-6.12-1.43-6.5C87.27,215.74,89.2,211.11,92.47,207.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M92.52,207.48c2.8-3.1,8.53-5.23,12.71-5.23H221.58c4.15,0,9.86,2.11,12.66,5.17,3.27,3.58,5.24,8.15,4.47,13.05a62.65,62.65,0,0,1-1.35,6.5L209.92,331.33a15.63,15.63,0,0,1-12.39,11.31,20.6,20.6,0,0,1-3.15.26H133.73a20.76,20.76,0,0,1-3.08-.25,15.67,15.67,0,0,1-12.41-11.16L89.55,227.15a63.39,63.39,0,0,1-1.42-6.51C87.3,215.71,89.24,211.09,92.52,207.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M92.57,207.47c2.79-3.08,8.55-5.2,12.71-5.2H221.54c4.13,0,9.86,2.1,12.65,5.14,3.28,3.57,5.27,8.13,4.51,13,.12.4-1.23,6.06-1.34,6.5L209.9,331.32a15.62,15.62,0,0,1-12.39,11.31,20.36,20.36,0,0,1-3.14.26H133.74a20.87,20.87,0,0,1-3.08-.25,15.64,15.64,0,0,1-12.4-11.15L89.56,227.12a66.33,66.33,0,0,1-1.42-6.52C87.32,215.68,89.29,211.08,92.57,207.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M92.62,207.46c2.79-3.06,8.57-5.18,12.71-5.18H221.49c4.11,0,9.87,2.1,12.65,5.12,3.28,3.56,5.29,8.11,4.54,13a62,62,0,0,1-1.33,6.5L209.89,331.32a15.62,15.62,0,0,1-12.39,11.3,21.8,21.8,0,0,1-3.14.25H133.75a22.32,22.32,0,0,1-3.08-.24,15.66,15.66,0,0,1-12.4-11.14l-28.7-104.4a60.94,60.94,0,0,1-1.41-6.52C87.35,215.64,89.34,211.06,92.62,207.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M92.67,207.45c2.78-3,8.58-5.15,12.7-5.15H221.44c4.09,0,9.87,2.09,12.65,5.09,3.29,3.55,5.31,8.09,4.58,13a62,62,0,0,1-1.33,6.5L209.87,331.32a15.59,15.59,0,0,1-12.38,11.28,20.39,20.39,0,0,1-3.15.26H133.76a21,21,0,0,1-3.08-.25,15.65,15.65,0,0,1-12.4-11.13L89.57,227.06a62.84,62.84,0,0,1-1.4-6.52C87.38,215.61,89.38,211,92.67,207.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M92.72,207.44c2.77-3,8.6-5.13,12.7-5.13h116c4.07,0,9.87,2.09,12.64,5.07,3.29,3.54,5.34,8.07,4.61,13a57.63,57.63,0,0,1-1.32,6.5L209.86,331.31a15.58,15.58,0,0,1-12.38,11.28,21.82,21.82,0,0,1-3.15.26H133.77a21,21,0,0,1-3.08-.25,15.61,15.61,0,0,1-12.39-11.12L89.58,227a60.34,60.34,0,0,1-1.4-6.52C87.4,215.58,89.43,211,92.72,207.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M92.77,207.43c2.77-3,8.62-5.1,12.7-5.1H221.35c4.05,0,9.88,2.08,12.64,5,3.3,3.53,5.36,8,4.65,12.95a62.35,62.35,0,0,1-1.31,6.5L209.85,331.31a15.6,15.6,0,0,1-12.39,11.27,21.69,21.69,0,0,1-3.14.25H133.78a20.73,20.73,0,0,1-3.07-.25,15.6,15.6,0,0,1-12.4-11.1L89.59,227a58.45,58.45,0,0,1-1.39-6.52C87.43,215.55,89.47,211,92.77,207.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M92.82,207.42c2.76-3,8.63-5.08,12.69-5.08H221.3c4,0,9.89,2.08,12.64,5,3.3,3.53,5.38,8,4.68,12.93a57.05,57.05,0,0,1-1.3,6.5L209.83,331.31a15.56,15.56,0,0,1-12.38,11.25,21.69,21.69,0,0,1-3.14.26H133.79a20.73,20.73,0,0,1-3.07-.25,15.57,15.57,0,0,1-12.39-11.1L89.6,227a58.45,58.45,0,0,1-1.39-6.52C87.45,215.52,89.52,211,92.82,207.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M92.87,207.41c2.75-3,8.65-5.06,12.69-5.06h115.7c4,0,9.88,2.08,12.63,5,3.3,3.52,5.41,8,4.72,12.91a57.65,57.65,0,0,1-1.3,6.51L209.82,331.3a15.55,15.55,0,0,1-12.38,11.25,21.8,21.8,0,0,1-3.14.25H133.8a22.3,22.3,0,0,1-3.07-.24,15.58,15.58,0,0,1-12.39-11.09L89.6,226.94c-.13-.5-1.51-6.07-1.37-6.52C87.48,215.49,89.56,211,92.87,207.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M92.92,207.4c2.74-2.94,8.67-5,12.69-5h115.6c4,0,9.89,2.07,12.63,5,3.31,3.51,5.43,8,4.75,12.89.15.45-1.15,6-1.29,6.51L209.8,331.3a15.54,15.54,0,0,1-12.37,11.24,23.33,23.33,0,0,1-3.14.25H133.82a21,21,0,0,1-3.08-.25,15.55,15.55,0,0,1-12.38-11.08L89.61,226.91a56.14,56.14,0,0,1-1.37-6.52C87.51,215.46,89.61,210.94,92.92,207.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M93,207.39c2.74-2.92,8.69-5,12.68-5H221.16c4,0,9.9,2.07,12.63,5,3.31,3.5,5.46,8,4.79,12.86.15.47-1.15,6-1.29,6.52l-27.5,104.58a15.51,15.51,0,0,1-12.38,11.23,21.55,21.55,0,0,1-3.13.25H133.83a22.18,22.18,0,0,1-3.07-.24,15.55,15.55,0,0,1-12.39-11.07L89.62,226.88c-.15-.51-1.51-6.06-1.36-6.53C87.53,215.42,89.66,210.92,93,207.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M93,207.38c2.73-2.9,8.7-5,12.68-5H221.12c3.95,0,9.9,2.06,12.62,4.92,3.32,3.49,5.48,7.94,4.82,12.84.15.48-1.13,6-1.27,6.52L209.77,331.29a15.49,15.49,0,0,1-12.37,11.22,23.07,23.07,0,0,1-3.14.25H133.84a22.3,22.3,0,0,1-3.07-.24,15.56,15.56,0,0,1-12.39-11.06L89.62,226.86c-.14-.53-1.5-6.06-1.35-6.54C87.56,215.39,89.7,210.91,93,207.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M93.07,207.37c2.72-2.88,8.72-5,12.68-5H221.07c3.93,0,9.91,2.06,12.62,4.9,3.32,3.48,5.5,7.92,4.86,12.82.15.48-1.13,6-1.27,6.52L209.76,331.29a15.49,15.49,0,0,1-12.37,11.2,21.69,21.69,0,0,1-3.14.25h-60.4a22.18,22.18,0,0,1-3.07-.24,15.53,15.53,0,0,1-12.38-11.05L89.63,226.83c-.15-.54-1.49-6.05-1.34-6.54C87.58,215.36,89.75,210.89,93.07,207.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M93.12,207.36c2.71-2.86,8.74-4.93,12.67-4.93H221c3.92,0,9.91,2,12.62,4.87,3.33,3.48,5.53,7.9,4.89,12.8.16.49-1.11,6-1.26,6.52L209.75,331.28a15.48,15.48,0,0,1-12.37,11.2,21.69,21.69,0,0,1-3.14.25H133.86a22.3,22.3,0,0,1-3.07-.24,15.52,15.52,0,0,1-12.38-11L89.64,226.8c-.15-.55-1.49-6.05-1.34-6.54C87.61,215.33,89.79,210.87,93.12,207.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M93.17,207.35c2.71-2.84,8.75-4.91,12.67-4.91H221c3.89,0,9.91,2.05,12.61,4.85,3.33,3.47,5.55,7.88,4.93,12.78.16.5-1.11,6-1.26,6.52L209.73,331.28a15.47,15.47,0,0,1-12.37,11.19,23.05,23.05,0,0,1-3.13.24H133.87a22.3,22.3,0,0,1-3.07-.23,15.49,15.49,0,0,1-12.37-11L89.65,226.77c-.16-.56-1.49-6-1.33-6.54C87.63,215.3,89.84,210.85,93.17,207.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M93.22,207.34c2.7-2.82,8.77-4.88,12.67-4.88h115c3.87,0,9.92,2,12.61,4.82,3.34,3.46,5.58,7.85,5,12.76.17.51-1.09,6-1.24,6.52L209.72,331.28a15.47,15.47,0,0,1-12.37,11.17,21.66,21.66,0,0,1-3.13.25H133.88a22.15,22.15,0,0,1-3.06-.24,15.48,15.48,0,0,1-12.38-11L89.65,226.74c-.15-.57-1.48-6-1.32-6.54C87.66,215.27,89.88,210.83,93.22,207.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M93.27,207.33c2.69-2.8,8.79-4.86,12.67-4.86H220.88c3.86,0,9.93,2,12.61,4.8,3.34,3.45,5.6,7.83,5,12.74.16.51-1.09,6-1.24,6.53L209.7,331.27a15.43,15.43,0,0,1-12.36,11.17,23.18,23.18,0,0,1-3.13.24H133.89a22.15,22.15,0,0,1-3.06-.23,15.48,15.48,0,0,1-12.38-11L89.66,226.71c-.16-.58-1.48-6-1.31-6.54C87.69,215.23,89.93,210.81,93.27,207.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M93.33,207.32c2.67-2.78,8.79-4.83,12.65-4.83H220.84c3.83,0,9.93,2,12.6,4.77,3.35,3.44,5.62,7.81,5,12.72.17.52-1.08,5.94-1.23,6.53L209.69,331.27a15.46,15.46,0,0,1-12.36,11.16,23.18,23.18,0,0,1-3.13.24H133.9a24,24,0,0,1-3.06-.23,15.48,15.48,0,0,1-12.37-11L89.67,226.68c-.16-.58-1.47-6-1.31-6.54C87.71,215.2,90,210.8,93.33,207.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M93.38,207.31c2.66-2.76,8.81-4.81,12.65-4.81H220.79c3.81,0,9.93,2,12.6,4.75,3.35,3.44,5.65,7.79,5.07,12.7.17.53-1.07,5.93-1.23,6.53L209.68,331.26a15.42,15.42,0,0,1-12.37,11.15,22.91,22.91,0,0,1-3.12.24H133.92a22.18,22.18,0,0,1-3.07-.23,15.45,15.45,0,0,1-12.37-11L89.68,226.65c-.17-.59-1.47-6-1.31-6.55C87.74,215.17,90,210.78,93.38,207.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.43,207.3c2.66-2.74,8.83-4.78,12.65-4.78H220.74c3.8,0,9.94,2,12.6,4.72,3.36,3.43,5.67,7.77,5.1,12.68.18.54-1.06,5.93-1.21,6.53L209.66,331.26A15.4,15.4,0,0,1,197.3,342.4a23.05,23.05,0,0,1-3.13.24H133.93a23.69,23.69,0,0,1-3.06-.23,15.43,15.43,0,0,1-12.37-11L89.68,226.62c-.16-.6-1.46-6-1.29-6.55C87.76,215.14,90.06,210.76,93.43,207.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M93.48,207.29c2.65-2.72,8.84-4.76,12.64-4.76H220.7c3.77,0,9.94,2,12.59,4.7,3.36,3.42,5.69,7.75,5.14,12.66.17.54-1.05,5.92-1.21,6.53L209.65,331.26a15.43,15.43,0,0,1-12.36,11.13,24.79,24.79,0,0,1-3.13.23H133.94a23.7,23.7,0,0,1-3.06-.22,15.45,15.45,0,0,1-12.37-11L89.69,226.59c-.17-.61-1.46-6-1.29-6.55C87.79,215.11,90.11,210.74,93.48,207.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M93.53,207.28c2.64-2.71,8.86-4.73,12.64-4.73H220.65c3.75,0,9.95,2,12.59,4.67,3.37,3.41,5.72,7.73,5.17,12.63.18.56-1,5.92-1.2,6.54L209.63,331.25a15.36,15.36,0,0,1-12.35,11.12,23.18,23.18,0,0,1-3.13.24H134a23.82,23.82,0,0,1-3.06-.23,15.4,15.4,0,0,1-12.36-11L89.7,226.56c-.17-.62-1.46-6-1.28-6.55C87.82,215.08,90.15,210.72,93.53,207.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M93.58,207.26c2.63-2.68,8.88-4.7,12.64-4.7H220.6c3.74,0,10,2,12.59,4.65,3.37,3.4,5.74,7.71,5.21,12.61.18.57-1,5.91-1.2,6.54L209.62,331.25a15.38,15.38,0,0,1-12.36,11.11,23,23,0,0,1-3.12.24H134a23.82,23.82,0,0,1-3.06-.23,15.4,15.4,0,0,1-12.36-11L89.7,226.54c-.17-.64-1.44-6-1.27-6.56C87.84,215.05,90.2,210.7,93.58,207.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M93.63,207.25c2.62-2.66,8.89-4.67,12.63-4.67h114.3c3.71,0,10,2,12.58,4.62,3.38,3.4,5.77,7.69,5.24,12.59.19.58-1,5.9-1.18,6.54L209.6,331.25a15.35,15.35,0,0,1-12.35,11.1,24.77,24.77,0,0,1-3.12.23H134a23.67,23.67,0,0,1-3.05-.22,15.42,15.42,0,0,1-12.37-10.95L89.71,226.51c-.17-.64-1.44-6-1.26-6.56C87.87,215,90.24,210.69,93.63,207.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M93.68,207.24c2.62-2.64,8.91-4.65,12.63-4.65h114.2c3.69,0,10,2,12.58,4.6,3.38,3.39,5.79,7.66,5.28,12.57.19.58-1,5.9-1.18,6.54l-27.6,104.94a15.33,15.33,0,0,1-12.35,11.09,23,23,0,0,1-3.12.24H134a23.67,23.67,0,0,1-3-.23,15.37,15.37,0,0,1-12.36-10.93L89.72,226.48c-.18-.65-1.44-6-1.26-6.56C87.89,215,90.29,210.67,93.68,207.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M93.73,207.23c2.61-2.62,8.93-4.63,12.63-4.63h114.1c3.68,0,10,2,12.58,4.58,3.39,3.38,5.81,7.64,5.31,12.55.19.59-1,5.89-1.17,6.55l-27.6,105a15.34,15.34,0,0,1-12.35,11.08,24.77,24.77,0,0,1-3.12.23H134a23.67,23.67,0,0,1-3.05-.22,15.38,15.38,0,0,1-12.36-10.93L89.73,226.45c-.18-.66-1.44-6-1.25-6.56C87.92,215,90.33,210.65,93.73,207.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M93.78,207.22c2.6-2.6,8.94-4.6,12.62-4.6h114c3.65,0,10,2,12.57,4.55,3.39,3.37,5.84,7.62,5.35,12.53.19.6-1,5.88-1.17,6.55l-27.61,105a15.33,15.33,0,0,1-12.35,11.08,24.63,24.63,0,0,1-3.12.23H134a23.82,23.82,0,0,1-3.06-.23A15.33,15.33,0,0,1,118.6,331.4l-28.87-105c-.18-.67-1.43-6-1.24-6.57C88,214.92,90.38,210.63,93.78,207.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M93.83,207.21c2.59-2.58,9-4.58,12.62-4.58H220.37c3.64,0,10,2,12.57,4.53,3.4,3.37,5.86,7.6,5.38,12.51.2.61-1,5.87-1.15,6.55l-27.62,105a15.32,15.32,0,0,1-12.35,11.06,24.63,24.63,0,0,1-3.12.23H134a23.82,23.82,0,0,1-3.06-.22,15.33,15.33,0,0,1-12.35-10.91l-28.87-105c-.19-.68-1.42-5.95-1.23-6.57C88,214.89,90.42,210.61,93.83,207.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M93.88,207.2c2.58-2.56,9-4.55,12.62-4.55H220.33c3.61,0,10,2,12.55,4.5,3.41,3.36,5.9,7.58,5.43,12.49.2.61-1,5.86-1.15,6.55l-27.63,105a15.3,15.3,0,0,1-12.34,11,24.77,24.77,0,0,1-3.12.23H134a25.6,25.6,0,0,1-3.05-.22,15.33,15.33,0,0,1-12.36-10.9l-28.87-105c-.19-.69-1.42-6-1.23-6.57C88,214.86,90.47,210.6,93.88,207.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M93.93,207.19c2.57-2.54,9-4.53,12.61-4.53H220.28c3.59,0,10,2,12.55,4.48,3.42,3.35,5.92,7.56,5.46,12.47.2.62-1,5.85-1.14,6.55L209.52,331.22a15.31,15.31,0,0,1-12.35,11,26.62,26.62,0,0,1-3.11.22H134a23.67,23.67,0,0,1-3-.22,15.31,15.31,0,0,1-12.35-10.88L89.76,226.33c-.2-.7-1.42-5.94-1.23-6.57C88,214.82,90.51,210.58,93.93,207.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M94,207.18c2.56-2.52,9-4.5,12.61-4.5H220.23c3.58,0,10,1.95,12.55,4.45,3.42,3.34,5.94,7.54,5.5,12.45.2.63-.95,5.85-1.14,6.55L209.5,331.22a15.26,15.26,0,0,1-12.34,11,24.61,24.61,0,0,1-3.11.23h-60a25.6,25.6,0,0,1-3.05-.22,15.31,15.31,0,0,1-12.35-10.88L89.76,226.3c-.19-.7-1.41-5.93-1.21-6.57C88.05,214.79,90.56,210.56,94,207.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M94,207.17c2.56-2.51,9-4.48,12.61-4.48H220.19c3.55,0,10,1.95,12.54,4.43,3.43,3.34,6,7.52,5.53,12.42.21.65-.94,5.85-1.13,6.56L209.49,331.22a15.26,15.26,0,0,1-12.34,11,24.61,24.61,0,0,1-3.11.22h-60a25.61,25.61,0,0,1-3.05-.21,15.3,15.3,0,0,1-12.34-10.87L89.77,226.27c-.2-.71-1.41-5.92-1.21-6.57C88.08,214.76,90.6,210.54,94,207.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M94.08,207.16c2.55-2.49,9-4.45,12.6-4.45H220.14c3.53,0,10,1.94,12.54,4.4,3.43,3.33,6,7.5,5.57,12.4.21.65-.93,5.84-1.12,6.56L209.48,331.21a15.28,15.28,0,0,1-12.34,11,26.62,26.62,0,0,1-3.11.22h-60a25.44,25.44,0,0,1-3-.22,15.27,15.27,0,0,1-12.35-10.86L89.78,226.25c-.2-.73-1.41-5.93-1.2-6.58C88.1,214.73,90.65,210.52,94.08,207.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M94.13,207.15c2.54-2.47,9.06-4.43,12.6-4.43H220.09c3.52,0,10,1.94,12.54,4.38,3.44,3.32,6,7.47,5.6,12.38.22.66-.92,5.83-1.11,6.57L209.46,331.21a15.21,15.21,0,0,1-12.34,11,24.48,24.48,0,0,1-3.11.22H134.08a25.44,25.44,0,0,1-3-.21,15.25,15.25,0,0,1-12.34-10.85L89.78,226.22c-.2-.74-1.39-5.92-1.19-6.58C88.13,214.7,90.69,210.51,94.13,207.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M94.18,207.14c2.53-2.45,9.08-4.4,12.6-4.4H220.05c3.49,0,10,1.93,12.53,4.35,3.45,3.31,6,7.45,5.64,12.36.21.67-.91,5.82-1.11,6.57L209.45,331.2a15.24,15.24,0,0,1-12.34,11,26.47,26.47,0,0,1-3.11.22H134.09a25.58,25.58,0,0,1-3-.21,15.26,15.26,0,0,1-12.34-10.84L89.79,226.19c-.2-.75-1.39-5.91-1.18-6.59C88.15,214.67,90.74,210.49,94.18,207.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M94.23,207.13c2.52-2.43,9.1-4.38,12.59-4.38H220c3.47,0,10,1.93,12.53,4.33,3.45,3.31,6.06,7.43,5.67,12.34.22.68-.9,5.81-1.1,6.57L209.43,331.2a15.22,15.22,0,0,1-12.33,11,26.62,26.62,0,0,1-3.11.21H134.11a25.61,25.61,0,0,1-3.05-.21,15.24,15.24,0,0,1-12.34-10.83L89.8,226.16c-.21-.76-1.39-5.91-1.18-6.59C88.18,214.64,90.78,210.47,94.23,207.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M94.29,207.12c2.5-2.41,9.1-4.35,12.58-4.35H220c3.46,0,10,1.92,12.53,4.3,3.46,3.3,6.09,7.41,5.71,12.32.22.68-.89,5.81-1.09,6.57L209.42,331.2a15.18,15.18,0,0,1-12.33,11,26.62,26.62,0,0,1-3.11.22H134.12a25.29,25.29,0,0,1-3-.21,15.21,15.21,0,0,1-12.34-10.82L89.81,226.13c-.21-.76-1.39-5.9-1.17-6.59C88.21,214.6,90.82,210.45,94.29,207.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M94.34,207.11c2.49-2.39,9.12-4.33,12.58-4.33h113c3.43,0,10,1.91,12.52,4.28,3.46,3.29,6.11,7.39,5.75,12.3.22.69-.89,5.8-1.09,6.57L209.41,331.19a15.22,15.22,0,0,1-12.34,11,26.31,26.31,0,0,1-3.1.21H134.13a27.71,27.71,0,0,1-3-.2,15.23,15.23,0,0,1-12.34-10.82L89.81,226.1c-.21-.77-1.38-5.89-1.16-6.59C88.23,214.57,90.87,210.44,94.34,207.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M94.39,207.1c2.48-2.38,9.14-4.3,12.58-4.3H219.86c3.41,0,10,1.9,12.52,4.25,3.47,3.28,6.13,7.37,5.78,12.28.22.7-.87,5.79-1.08,6.57L209.39,331.19a15.16,15.16,0,0,1-12.33,10.95,26.45,26.45,0,0,1-3.1.22H134.14a25.44,25.44,0,0,1-3-.21,15.18,15.18,0,0,1-12.33-10.8L89.82,226.07c-.21-.78-1.37-5.88-1.15-6.59C88.26,214.54,90.91,210.42,94.39,207.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M94.44,207.09c2.47-2.36,9.15-4.28,12.57-4.28h112.8c3.4,0,10.05,1.9,12.52,4.23,3.47,3.28,6.16,7.35,5.82,12.26.22.71-.87,5.78-1.08,6.57L209.38,331.19a15.19,15.19,0,0,1-12.33,10.94,26.45,26.45,0,0,1-3.1.22h-59.8a27.88,27.88,0,0,1-3-.21,15.2,15.2,0,0,1-12.33-10.79L89.83,226c-.22-.79-1.37-5.88-1.15-6.59C88.28,214.51,91,210.4,94.44,207.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M94.49,207.08c2.46-2.34,9.17-4.25,12.57-4.25H219.77c3.37,0,10,1.89,12.51,4.2,3.48,3.27,6.18,7.33,5.85,12.24.23.71-.85,5.77-1.06,6.57L209.36,331.18A15.16,15.16,0,0,1,197,342.12a26.62,26.62,0,0,1-3.11.21H134.16a27.87,27.87,0,0,1-3-.2,15.21,15.21,0,0,1-12.33-10.79L89.84,226c-.22-.8-1.37-5.87-1.15-6.59C88.31,214.48,91,210.38,94.49,207.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M94.54,207.07c2.45-2.32,9.19-4.23,12.57-4.23H219.72c3.36,0,10.06,1.89,12.51,4.18,3.49,3.26,6.21,7.31,5.89,12.21.23.73-.85,5.78-1.06,6.59L209.35,331.18A15.12,15.12,0,0,1,197,342.1a26.3,26.3,0,0,1-3.1.22H134.17a25.42,25.42,0,0,1-3-.21,15.16,15.16,0,0,1-12.33-10.77L89.84,226c-.22-.81-1.36-5.86-1.13-6.59C88.34,214.45,91.05,210.37,94.54,207.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M94.59,207.06c2.45-2.3,9.2-4.21,12.56-4.21H219.67c3.34,0,10.07,1.89,12.51,4.16,3.49,3.26,6.23,7.28,5.92,12.19.24.74-.83,5.77-1,6.59L209.33,331.17A15.12,15.12,0,0,1,197,342.09a26.45,26.45,0,0,1-3.1.21H134.18a27.53,27.53,0,0,1-3-.2,15.16,15.16,0,0,1-12.33-10.76L89.85,226c-.23-.83-1.36-5.86-1.13-6.61C88.36,214.42,91.09,210.35,94.59,207.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M94.64,207.05c2.44-2.28,9.22-4.18,12.56-4.18H219.63c3.31,0,10.07,1.87,12.5,4.13,3.5,3.25,6.25,7.26,6,12.17.23.75-.83,5.76-1.05,6.59L209.32,331.17A15.11,15.11,0,0,1,197,342.08a28.81,28.81,0,0,1-3.1.21H134.2a27.71,27.71,0,0,1-3-.2,15.15,15.15,0,0,1-12.32-10.76l-29-105.4c-.23-.83-1.35-5.86-1.12-6.61C88.39,214.38,91.13,210.33,94.64,207.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M94.69,207c2.43-2.27,9.24-4.16,12.56-4.16H219.58c3.3,0,10.08,1.87,12.5,4.11,3.5,3.24,6.28,7.24,6,12.15.24.75-.81,5.75-1,6.59L209.31,331.17A15.09,15.09,0,0,1,197,342.06a26.45,26.45,0,0,1-3.1.21H134.21a27.71,27.71,0,0,1-3-.2,15.12,15.12,0,0,1-12.32-10.74l-29-105.43c-.23-.84-1.34-5.85-1.11-6.61C88.41,214.35,91.18,210.31,94.69,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M94.74,207c2.42-2.25,9.25-4.13,12.55-4.13H219.53c3.28,0,10.09,1.86,12.5,4.08,3.51,3.23,6.3,7.22,6,12.13.24.76-.81,5.74-1,6.59L209.29,331.16A15.09,15.09,0,0,1,197,342.05a28.62,28.62,0,0,1-3.09.21H134.22a27.53,27.53,0,0,1-3-.2,15.1,15.1,0,0,1-12.32-10.74l-29-105.45c-.23-.85-1.34-5.84-1.1-6.61C88.44,214.32,91.22,210.3,94.74,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M94.79,207c2.41-2.23,9.27-4.11,12.55-4.11H219.49c3.25,0,10.09,1.86,12.49,4.06,3.52,3.23,6.33,7.2,6.06,12.11.25.77-.79,5.73-1,6.59L209.28,331.16A15.08,15.08,0,0,1,197,342a28.63,28.63,0,0,1-3.09.2H134.23a30.23,30.23,0,0,1-3-.19,15.1,15.1,0,0,1-12.32-10.73l-29-105.48c-.24-.86-1.34-5.84-1.1-6.61C88.46,214.29,91.27,210.28,94.79,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M94.84,207c2.4-2.21,9.29-4.08,12.55-4.08H219.44c3.24,0,10.1,1.85,12.49,4,3.52,3.22,6.35,7.18,6.1,12.09.25.78-.79,5.73-1,6.59L209.26,331.16A15,15,0,0,1,197,342a26.43,26.43,0,0,1-3.09.21H134.24a27.69,27.69,0,0,1-3-.2,15.09,15.09,0,0,1-12.32-10.71l-29-105.51c-.24-.87-1.34-5.83-1.09-6.61C88.49,214.26,91.31,210.26,94.84,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M94.89,207c2-2.58,9.3-4.06,12.54-4.06h112c3.22,0,10.52,1.46,12.49,4A13.44,13.44,0,0,1,238,219c.25.78-.77,5.72-1,6.59L209.25,331.15A15.06,15.06,0,0,1,196.94,342a28.82,28.82,0,0,1-3.1.2H134.25a30.23,30.23,0,0,1-3-.19,15.08,15.08,0,0,1-12.31-10.71l-29-105.53c-.24-.88-1.32-5.82-1.08-6.61A13.41,13.41,0,0,1,94.89,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M94.94,207c2-2.56,9.32-4,12.54-4H219.35c3.19,0,10.53,1.45,12.48,4A13.42,13.42,0,0,1,238,219c.25.79-.77,5.71-1,6.59L209.23,331.15A15,15,0,0,1,196.92,342a28.63,28.63,0,0,1-3.09.2H134.26a27.69,27.69,0,0,1-3-.2,15.07,15.07,0,0,1-12.31-10.69l-29-105.56c-.24-.88-1.32-5.81-1.07-6.61A13.36,13.36,0,0,1,94.94,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M95,207c1.94-2.55,9.34-4,12.54-4H219.3c3.18,0,10.54,1.44,12.48,4a13.4,13.4,0,0,1,6.2,12c.26.8-.76,5.7-1,6.6L209.22,331.14A15,15,0,0,1,196.91,342a28.63,28.63,0,0,1-3.09.2H134.27a27.35,27.35,0,0,1-3-.19,15,15,0,0,1-12.31-10.69l-29-105.58c-.25-.89-1.32-5.81-1.07-6.62A13.35,13.35,0,0,1,95,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M95,207c1.93-2.53,9.36-4,12.53-4H219.25c3.16,0,10.55,1.43,12.48,3.93a13.38,13.38,0,0,1,6.24,12c.26.82-.75,5.7-1,6.61L209.21,331.14A15,15,0,0,1,196.9,342a28.63,28.63,0,0,1-3.09.2H134.28a30.22,30.22,0,0,1-3-.19A15.06,15.06,0,0,1,119,331.3l-29-105.61c-.25-.9-1.32-5.8-1.06-6.62A13.3,13.3,0,0,1,95,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M95.09,207c1.92-2.52,9.37-4,12.53-4H219.21c3.13,0,10.55,1.43,12.47,3.91a13.34,13.34,0,0,1,6.27,12c.26.82-.74,5.69-1,6.61L209.19,331.14A15,15,0,0,1,196.89,342c-.65.1-2.42.19-3.09.19H134.3a27.69,27.69,0,0,1-3-.19A15,15,0,0,1,119,331.3l-29-105.63c-.25-.92-1.31-5.8-1-6.63A13.31,13.31,0,0,1,95.09,207Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M95.14,206.94c1.91-2.49,9.39-3.92,12.53-3.92H219.16c3.12,0,10.56,1.41,12.47,3.88a13.34,13.34,0,0,1,6.31,12c.26.83-.73,5.69-1,6.61L209.18,331.13a15,15,0,0,1-12.31,10.81,28.45,28.45,0,0,1-3.08.2H134.31a30.23,30.23,0,0,1-3-.19A15,15,0,0,1,119,331.29l-29-105.65c-.25-.93-1.3-5.79-1.05-6.63A13.34,13.34,0,0,1,95.14,206.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M95.19,206.93c1.9-2.48,9.41-3.9,12.52-3.9h111.4c3.1,0,10.58,1.41,12.47,3.86a13.29,13.29,0,0,1,6.34,11.94c.27.84-.72,5.68-1,6.61l-27.8,105.69a15,15,0,0,1-12.3,10.8c-.64.1-2.42.19-3.08.19H134.32a30,30,0,0,1-3-.18A15,15,0,0,1,119,331.29l-29-105.68c-.26-.94-1.3-5.79-1-6.63A13.29,13.29,0,0,1,95.19,206.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M95.25,206.92c1.87-2.46,9.41-3.87,12.51-3.87H219.07c3.07,0,10.58,1.39,12.46,3.83a13.3,13.3,0,0,1,6.38,11.92c.27.85-.71,5.67-1,6.61l-27.8,105.72a15,15,0,0,1-12.3,10.79c-.64.1-2.42.19-3.09.19H134.33a30,30,0,0,1-3-.19A15,15,0,0,1,119,331.28L89.94,225.58c-.25-1-1.29-5.78-1-6.63A13.28,13.28,0,0,1,95.25,206.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M95.3,206.91c1.86-2.44,9.43-3.85,12.51-3.85H219c3.06,0,10.59,1.39,12.46,3.81a13.27,13.27,0,0,1,6.41,11.9c.28.85-.7,5.66-.95,6.61L209.13,331.12a14.93,14.93,0,0,1-12.29,10.78,28.8,28.8,0,0,1-3.09.2H134.34a30.22,30.22,0,0,1-3-.19A15,15,0,0,1,119,331.28L90,225.55c-.26-1-1.29-5.77-1-6.63A13.23,13.23,0,0,1,95.3,206.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M95.35,206.9c1.85-2.43,9.45-3.82,12.51-3.82H219c3,0,10.6,1.37,12.46,3.78a13.26,13.26,0,0,1,6.45,11.88c.27.86-.69,5.65-.94,6.61L209.12,331.12a14.94,14.94,0,0,1-12.3,10.77c-.62.1-2.42.19-3.08.19H134.35c-.64,0-2.4-.09-3-.18A15,15,0,0,1,119,331.28L90,225.52c-.27-1-1.29-5.77-1-6.63A13.24,13.24,0,0,1,95.35,206.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M95.4,206.89c1.84-2.41,9.46-3.8,12.5-3.8h111c3,0,10.6,1.37,12.45,3.76a13.23,13.23,0,0,1,6.48,11.86c.28.87-.68,5.65-.93,6.62L209.11,331.11a14.93,14.93,0,0,1-12.3,10.77c-.62.1-2.43.19-3.08.19H134.36a30,30,0,0,1-3-.19,15,15,0,0,1-12.3-10.61L90,225.49c-.27-1-1.29-5.76-1-6.64A13.2,13.2,0,0,1,95.4,206.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M95.45,206.88c1.83-2.4,9.48-3.78,12.5-3.78H218.88c3,0,10.61,1.37,12.44,3.74a13.21,13.21,0,0,1,6.53,11.84c.28.88-.67,5.64-.93,6.62L209.09,331.11a14.91,14.91,0,0,1-12.29,10.75c-.62.1-2.43.19-3.08.19H134.37a29.85,29.85,0,0,1-3-.18,14.94,14.94,0,0,1-12.3-10.6L90,225.46c-.27-1-1.27-5.75-1-6.64A13.18,13.18,0,0,1,95.45,206.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M95.5,206.87c1.82-2.38,9.5-3.75,12.5-3.75H218.83c3,0,10.63,1.35,12.44,3.71a13.17,13.17,0,0,1,6.56,11.82c.29.88-.66,5.63-.92,6.62L209.08,331.11a14.92,14.92,0,0,1-12.29,10.74c-.62.1-2.44.19-3.08.19H134.39c-.63,0-2.42-.09-3-.18a14.94,14.94,0,0,1-12.29-10.6L90,225.43c-.27-1-1.27-5.74-1-6.64A13.16,13.16,0,0,1,95.5,206.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M95.55,206.86c1.8-2.37,9.51-3.73,12.49-3.73H218.79c3,0,10.63,1.35,12.43,3.69a13.17,13.17,0,0,1,6.6,11.8c.28.89-.65,5.62-.91,6.62L209.06,331.1a14.9,14.9,0,0,1-12.29,10.74c-.61.09-2.44.18-3.07.18H134.4a30,30,0,0,1-3-.18,14.92,14.92,0,0,1-12.29-10.58L90,225.4c-.28-1-1.27-5.74-1-6.64A13.14,13.14,0,0,1,95.55,206.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M95.6,206.85c1.79-2.35,9.53-3.7,12.49-3.7H218.74c2.94,0,10.64,1.33,12.43,3.66a13.13,13.13,0,0,1,6.63,11.77c.29.91-.64,5.62-.9,6.63L209.05,331.1a14.89,14.89,0,0,1-12.29,10.72c-.61.1-2.44.19-3.08.19H134.41c-.62,0-2.42-.09-3-.18a14.9,14.9,0,0,1-12.28-10.57L90,225.37c-.28-1-1.27-5.73-1-6.64A13.13,13.13,0,0,1,95.6,206.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M95.65,206.84c1.78-2.34,9.55-3.68,12.49-3.68H218.69c2.92,0,10.65,1.33,12.43,3.64a13.13,13.13,0,0,1,6.67,11.75c.29.92-.63,5.61-.9,6.63L209,331.1a14.88,14.88,0,0,1-12.29,10.71c-.61.1-2.45.18-3.08.18H134.42c-.62,0-2.42-.08-3-.17a14.91,14.91,0,0,1-12.29-10.57L90,225.35c-.28-1-1.26-5.73-1-6.65A13.12,13.12,0,0,1,95.65,206.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M95.7,206.83c1.77-2.32,9.56-3.65,12.48-3.65H218.65c2.9,0,10.65,1.31,12.42,3.61a13.12,13.12,0,0,1,6.7,11.73c.3.92-.62,5.61-.89,6.63L209,331.09a14.86,14.86,0,0,1-12.28,10.71c-.6.09-2.45.18-3.08.18H134.43c-.61,0-2.42-.09-3-.18a14.86,14.86,0,0,1-12.28-10.55L90,225.32c-.28-1-1.25-5.72-1-6.65A13.1,13.1,0,0,1,95.7,206.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M95.75,206.82c1.76-2.3,9.58-3.63,12.48-3.63H218.6c2.88,0,10.67,1.31,12.42,3.59a13.1,13.1,0,0,1,6.74,11.71c.3.93-.61,5.6-.88,6.63L209,331.09a14.85,14.85,0,0,1-12.29,10.69c-.59.1-2.45.18-3.07.18H134.44c-.61,0-2.43-.08-3-.17a14.88,14.88,0,0,1-12.28-10.54L90,225.29c-.29-1-1.25-5.72-1-6.65A13.08,13.08,0,0,1,95.75,206.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M95.8,206.81c1.75-2.29,9.6-3.6,12.48-3.6H218.55c2.86,0,10.68,1.3,12.42,3.56a13.07,13.07,0,0,1,6.77,11.69c.3.94-.6,5.59-.87,6.63L209,331.08a14.82,14.82,0,0,1-12.28,10.69c-.59.09-2.45.18-3.07.18H134.45c-.6,0-2.43-.08-3-.17a14.88,14.88,0,0,1-12.28-10.54L90,225.26c-.28-1-1.24-5.71-1-6.66A13.06,13.06,0,0,1,95.8,206.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M95.85,206.8c1.74-2.27,9.61-3.58,12.47-3.58H218.51c2.84,0,10.68,1.29,12.41,3.54a13.06,13.06,0,0,1,6.81,11.67c.3.95-.59,5.58-.87,6.64L209,331.08a14.82,14.82,0,0,1-12.28,10.67c-.59.1-2.46.18-3.07.18H134.46c-.59,0-2.43-.08-3-.17a14.82,14.82,0,0,1-12.28-10.52L90,225.23c-.29-1.06-1.24-5.7-.94-6.66A13,13,0,0,1,95.85,206.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M95.9,206.79c1.72-2.26,9.63-3.55,12.47-3.55H218.46c2.82,0,10.69,1.28,12.41,3.51a13,13,0,0,1,6.84,11.65c.31.95-.58,5.57-.86,6.64L209,331.08a14.8,14.8,0,0,1-12.27,10.66c-.59.09-2.47.18-3.07.18H134.47c-.59,0-2.43-.08-3-.17a14.86,14.86,0,0,1-12.28-10.52L90,225.2c-.29-1.07-1.24-5.7-.94-6.66A13,13,0,0,1,95.9,206.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M96,206.78c1.71-2.24,9.65-3.53,12.47-3.53h110c2.8,0,10.7,1.27,12.41,3.49a13,13,0,0,1,6.88,11.63c.31,1-.57,5.56-.86,6.64L209,331.07a14.8,14.8,0,0,1-12.28,10.66c-.58.09-2.46.17-3.06.17H134.49c-.59,0-2.44-.08-3-.17a14.81,14.81,0,0,1-12.27-10.5L90.05,225.17c-.3-1.07-1.23-5.69-.93-6.66A13,13,0,0,1,96,206.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M96,206.77c1.7-2.23,9.66-3.5,12.46-3.5H218.37c2.78,0,10.7,1.26,12.4,3.46a13,13,0,0,1,6.91,11.61c.32,1-.56,5.56-.84,6.64l-27.9,106.09a14.8,14.8,0,0,1-12.28,10.64c-.58.09-2.47.18-3.07.18H134.5c-.59,0-2.44-.08-3-.17a14.8,14.8,0,0,1-12.27-10.49L90.05,225.14c-.29-1.08-1.22-5.68-.92-6.66A13,13,0,0,1,96,206.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M96.05,206.76c1.69-2.21,9.68-3.48,12.46-3.48H218.32c2.76,0,10.72,1.25,12.4,3.44a13,13,0,0,1,6.95,11.59c.31,1-.55,5.55-.84,6.64L208.92,331.07a14.76,14.76,0,0,1-12.27,10.63c-.57.09-2.47.17-3.07.17H134.51c-.58,0-2.45-.08-3-.16a14.82,14.82,0,0,1-12.28-10.49L90.06,225.11c-.3-1.09-1.22-5.67-.91-6.66A13,13,0,0,1,96.05,206.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M96.1,206.75c1.68-2.2,9.7-3.45,12.46-3.45H218.28c2.74,0,10.72,1.24,12.39,3.41a13,13,0,0,1,7,11.56c.32,1-.54,5.55-.83,6.65L208.91,331.06a14.78,14.78,0,0,1-12.28,10.63c-.56.09-2.47.17-3.06.17h-59c-.58,0-2.45-.08-3-.17a14.76,14.76,0,0,1-12.27-10.47L90.07,225.08c-.31-1.1-1.22-5.67-.91-6.66A13,13,0,0,1,96.1,206.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M96.16,206.74c1.66-2.18,9.71-3.43,12.44-3.43H218.23c2.72,0,10.73,1.24,12.39,3.39a13,13,0,0,1,7,11.54c.32,1-.53,5.54-.83,6.65L208.89,331.06a14.74,14.74,0,0,1-12.27,10.61c-.56.09-2.47.18-3.06.18h-59c-.57,0-2.45-.08-3-.17a14.76,14.76,0,0,1-12.27-10.47L90.08,225.06c-.31-1.12-1.22-5.67-.9-6.67A12.93,12.93,0,0,1,96.16,206.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M96.21,206.73c1.64-2.16,9.72-3.4,12.44-3.4H218.18c2.7,0,10.74,1.22,12.39,3.36a12.94,12.94,0,0,1,7.05,11.52c.33,1-.52,5.53-.81,6.65L208.88,331.05a14.73,14.73,0,0,1-12.27,10.61c-.56.09-2.48.17-3.06.17h-59c-.57,0-2.45-.08-3-.16a14.76,14.76,0,0,1-12.26-10.46L90.08,225c-.31-1.13-1.2-5.66-.89-6.67A12.91,12.91,0,0,1,96.21,206.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M96.26,206.72c1.63-2.15,9.74-3.38,12.44-3.38H218.14c2.68,0,10.74,1.22,12.38,3.34a12.92,12.92,0,0,1,7.09,11.5c.32,1-.51,5.53-.81,6.66L208.86,331.05a14.73,14.73,0,0,1-12.26,10.6c-.56.08-2.49.17-3.06.17h-59c-.56,0-2.45-.08-3-.17a14.73,14.73,0,0,1-12.26-10.44L90.09,225c-.31-1.13-1.2-5.65-.89-6.68A12.91,12.91,0,0,1,96.26,206.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M96.31,206.71c1.62-2.13,9.76-3.36,12.44-3.36H218.09c2.66,0,10.75,1.21,12.38,3.32a12.91,12.91,0,0,1,7.12,11.48c.33,1-.5,5.52-.8,6.66L208.85,331.05a14.7,14.7,0,0,1-12.27,10.58c-.55.09-2.48.17-3.05.17h-59c-.56,0-2.45-.08-3-.16a14.73,14.73,0,0,1-12.26-10.44L90.1,225c-.32-1.14-1.2-5.65-.88-6.68A12.88,12.88,0,0,1,96.31,206.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M96.36,206.7c1.61-2.12,9.77-3.33,12.43-3.33H218c2.64,0,10.77,1.2,12.38,3.29a12.88,12.88,0,0,1,7.16,11.46c.33,1-.49,5.51-.8,6.66L208.84,331a14.7,14.7,0,0,1-12.27,10.58c-.54.08-2.49.17-3.06.17H134.58c-.56,0-2.47-.08-3-.16a14.73,14.73,0,0,1-12.26-10.43L90.1,224.94c-.31-1.15-1.19-5.64-.87-6.68A12.89,12.89,0,0,1,96.36,206.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M96.41,206.69c1.6-2.1,9.79-3.31,12.43-3.31H218c2.62,0,10.77,1.19,12.37,3.27a12.87,12.87,0,0,1,7.19,11.44c.34,1-.48,5.5-.78,6.66L208.82,331a14.7,14.7,0,0,1-12.26,10.57c-.54.08-2.49.16-3.06.16H134.59c-.56,0-2.47-.08-3-.16a14.71,14.71,0,0,1-12.26-10.42L90.11,224.91c-.32-1.16-1.19-5.63-.86-6.68A12.87,12.87,0,0,1,96.41,206.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M96.46,206.68c1.59-2.09,9.81-3.28,12.43-3.28H218c2.6,0,10.78,1.18,12.37,3.24a12.87,12.87,0,0,1,7.23,11.42c.34,1.05-.47,5.49-.78,6.66L208.81,331a14.66,14.66,0,0,1-12.26,10.55c-.54.09-2.5.17-3.06.17H134.6c-.55,0-2.47-.08-3-.16a14.71,14.71,0,0,1-12.25-10.41L90.12,224.88c-.32-1.17-1.18-5.63-.86-6.68A12.85,12.85,0,0,1,96.46,206.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M96.51,206.67c1.57-2.07,9.82-3.26,12.42-3.26h109c2.58,0,10.79,1.18,12.37,3.22a12.83,12.83,0,0,1,7.26,11.4c.34,1.05-.46,5.48-.77,6.66L208.79,331a14.66,14.66,0,0,1-12.26,10.55c-.53.08-2.49.16-3.05.16H134.61c-.54,0-2.47-.08-3-.15a14.7,14.7,0,0,1-12.26-10.4L90.13,224.85c-.33-1.18-1.18-5.62-.85-6.68A12.83,12.83,0,0,1,96.51,206.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M96.56,206.66c1.56-2.06,9.84-3.23,12.42-3.23H217.86c2.56,0,10.79,1.16,12.36,3.19a12.84,12.84,0,0,1,7.3,11.38c.34,1.06-.45,5.48-.77,6.66L208.78,331a14.67,14.67,0,0,1-12.26,10.54c-.53.08-2.5.16-3.05.16H134.62c-.54,0-2.47-.08-3-.16a14.65,14.65,0,0,1-12.25-10.39L90.13,224.82c-.32-1.19-1.17-5.61-.84-6.68A12.83,12.83,0,0,1,96.56,206.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M96.61,206.65c1.55-2,9.86-3.21,12.42-3.21H217.81c2.54,0,10.81,1.16,12.36,3.17A12.84,12.84,0,0,1,237.51,218c.34,1.08-.45,5.48-.76,6.67L208.77,331a14.64,14.64,0,0,1-12.26,10.53c-.53.08-2.5.16-3,.16H134.63c-.53,0-2.47-.07-3-.15a14.68,14.68,0,0,1-12.25-10.38L90.14,224.79c-.33-1.19-1.17-5.6-.83-6.68A12.8,12.8,0,0,1,96.61,206.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M96.66,206.64c1.54-2,9.87-3.18,12.41-3.18H217.76c2.52,0,10.82,1.14,12.36,3.14a12.81,12.81,0,0,1,7.37,11.33c.35,1.09-.43,5.47-.75,6.67L208.75,331a14.63,14.63,0,0,1-12.25,10.52c-.53.08-2.51.16-3.05.16H134.64c-.53,0-2.48-.08-3-.15a14.67,14.67,0,0,1-12.25-10.37L90.15,224.77c-.33-1.21-1.17-5.61-.83-6.7A12.77,12.77,0,0,1,96.66,206.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M96.71,206.62c1.53-2,9.89-3.15,12.41-3.15h108.6c2.5,0,10.82,1.14,12.35,3.12a12.81,12.81,0,0,1,7.41,11.31c.34,1.09-.43,5.46-.75,6.68L208.74,331a14.63,14.63,0,0,1-12.26,10.51c-.51.07-2.51.15-3,.15H134.65c-.52,0-2.48-.07-3-.15a14.62,14.62,0,0,1-12.24-10.36L90.16,224.74c-.34-1.22-1.16-5.6-.82-6.7A12.78,12.78,0,0,1,96.71,206.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M96.76,206.61c1.52-2,9.91-3.12,12.41-3.12h108.5c2.48,0,10.83,1.12,12.35,3.09a12.78,12.78,0,0,1,7.44,11.29c.35,1.1-.42,5.45-.74,6.68L208.72,331a14.6,14.6,0,0,1-12.25,10.5c-.51.08-2.51.16-3.05.16H134.66c-.52,0-2.48-.08-3-.15a14.63,14.63,0,0,1-12.25-10.35L90.16,224.71c-.33-1.23-1.15-5.59-.81-6.7A12.79,12.79,0,0,1,96.76,206.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M96.81,206.6c1.51-2,9.92-3.1,12.4-3.1H217.62c2.46,0,10.84,1.12,12.35,3.07a12.77,12.77,0,0,1,7.48,11.27c.35,1.11-.41,5.44-.73,6.68L208.71,331a14.6,14.6,0,0,1-12.25,10.49c-.51.08-2.52.15-3.05.15H134.68c-.52,0-2.49-.07-3-.14a14.6,14.6,0,0,1-12.24-10.35L90.17,224.68c-.34-1.24-1.15-5.58-.8-6.7A12.76,12.76,0,0,1,96.81,206.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M96.86,206.59c1.49-2,9.94-3.07,12.4-3.07H217.58c2.44,0,10.84,1.11,12.34,3a12.75,12.75,0,0,1,7.51,11.25c.36,1.12-.4,5.44-.72,6.68L208.69,331a14.58,14.58,0,0,1-12.24,10.48c-.51.07-2.52.15-3,.15H134.69c-.52,0-2.49-.08-3-.15a14.61,14.61,0,0,1-12.24-10.33L90.18,224.65c-.35-1.25-1.15-5.58-.8-6.7A12.76,12.76,0,0,1,96.86,206.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M96.91,206.58c1.48-1.94,10-3.05,12.4-3.05H217.53c2.42,0,10.86,1.1,12.34,3a12.75,12.75,0,0,1,7.55,11.23c.36,1.12-.39,5.43-.72,6.68L208.68,331a14.56,14.56,0,0,1-12.25,10.47c-.5.08-2.52.16-3,.16H134.7c-.51,0-2.49-.08-3-.15a14.59,14.59,0,0,1-12.23-10.32L90.18,224.62c-.34-1.25-1.14-5.57-.79-6.7A12.74,12.74,0,0,1,96.91,206.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M97,206.57c1.47-1.92,10-3,12.39-3H217.48c2.41,0,10.87,1.09,12.34,3a12.72,12.72,0,0,1,7.58,11.21c.36,1.13-.38,5.42-.71,6.68L208.67,331a14.57,14.57,0,0,1-12.25,10.46c-.5.07-2.52.15-3,.15H134.71c-.51,0-2.5-.07-3-.15a14.56,14.56,0,0,1-12.24-10.31L90.19,224.59c-.35-1.26-1.14-5.56-.78-6.7A12.72,12.72,0,0,1,97,206.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M97,206.56c1.46-1.91,10-3,12.39-3h108c2.38,0,10.87,1.08,12.33,3a12.72,12.72,0,0,1,7.62,11.19c.36,1.14-.37,5.41-.71,6.68L208.65,331a14.55,14.55,0,0,1-12.24,10.46c-.49.07-2.53.15-3,.15H134.72c-.5,0-2.5-.08-3-.15a14.58,14.58,0,0,1-12.24-10.3L90.2,224.56c-.35-1.27-1.13-5.56-.78-6.7A12.72,12.72,0,0,1,97,206.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M97.06,206.55c1.45-1.89,10-3,12.39-3H217.39c2.36,0,10.88,1.08,12.32,3a12.69,12.69,0,0,1,7.66,11.17c.37,1.15-.36,5.4-.69,6.68L208.64,331c-1.51,5.75-6.48,9.58-12.24,10.44-.49.07-2.54.15-3,.15H134.73c-.5,0-2.5-.07-3-.14a14.55,14.55,0,0,1-12.23-10.3L90.21,224.53c-.36-1.28-1.13-5.55-.77-6.71A12.68,12.68,0,0,1,97.06,206.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M97.12,206.54c1.43-1.87,10-2.95,12.37-2.95H217.34c2.35,0,10.89,1.06,12.32,2.92a12.69,12.69,0,0,1,7.7,11.15c.37,1.15-.35,5.4-.69,6.69L208.62,331c-1.51,5.74-6.47,9.57-12.24,10.43-.48.07-2.53.15-3,.15h-58.6c-.49,0-2.5-.08-3-.15a14.53,14.53,0,0,1-12.23-10.28L90.21,224.5c-.35-1.29-1.12-5.54-.76-6.71A12.69,12.69,0,0,1,97.12,206.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M97.17,206.53c1.41-1.86,10-2.93,12.37-2.93H217.3c2.32,0,10.9,1.06,12.31,2.9a12.66,12.66,0,0,1,7.73,11.12c.38,1.17-.34,5.4-.68,6.7L208.61,331c-1.51,5.74-6.48,9.57-12.24,10.43-.48.07-2.54.14-3,.14H134.75c-.49,0-2.5-.07-3-.14a14.52,14.52,0,0,1-12.23-10.27L90.22,224.47c-.36-1.3-1.12-5.53-.75-6.71A12.65,12.65,0,0,1,97.17,206.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M97.22,206.52c1.4-1.84,10-2.9,12.37-2.9H217.25c2.3,0,10.91,1,12.31,2.87a12.67,12.67,0,0,1,7.77,11.1c.37,1.18-.33,5.39-.68,6.7L208.59,331c-1.5,5.74-6.47,9.56-12.23,10.41-.48.07-2.54.15-3,.15H134.77c-.49,0-2.52-.08-3-.14a14.52,14.52,0,0,1-12.23-10.27L90.23,224.45c-.36-1.32-1.12-5.54-.75-6.72A12.66,12.66,0,0,1,97.22,206.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M97.27,206.51c1.39-1.83,10.07-2.88,12.36-2.88H217.2c2.29,0,10.92,1,12.31,2.85a12.64,12.64,0,0,1,7.8,11.08c.38,1.19-.32,5.38-.66,6.7L208.58,331c-1.51,5.73-6.47,9.55-12.23,10.4-.48.07-2.55.14-3,.14H134.78c-.48,0-2.52-.07-3-.14a14.5,14.5,0,0,1-12.23-10.25L90.24,224.42c-.37-1.32-1.11-5.53-.74-6.72A12.64,12.64,0,0,1,97.27,206.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M97.32,206.5c1.38-1.81,10.08-2.85,12.36-2.85H217.16c2.26,0,10.92,1,12.3,2.82a12.63,12.63,0,0,1,7.84,11.06c.38,1.19-.31,5.37-.66,6.7L208.57,331c-1.51,5.74-6.48,9.55-12.24,10.39-.47.07-2.54.15-3,.15H134.79c-.48,0-2.52-.07-3-.14a14.48,14.48,0,0,1-12.22-10.25L90.24,224.39c-.36-1.33-1.1-5.52-.73-6.72A12.62,12.62,0,0,1,97.32,206.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M97.37,206.49c1.37-1.8,10.1-2.83,12.36-2.83H217.11c2.24,0,10.93,1,12.3,2.8a12.62,12.62,0,0,1,7.87,11c.39,1.2-.3,5.36-.65,6.7L208.55,331c-1.51,5.73-6.47,9.54-12.23,10.38-.46.07-2.55.14-3,.14H134.8c-.47,0-2.52-.07-3-.13-5.71-.83-10.66-4.58-12.22-10.24L90.25,224.36c-.37-1.34-1.1-5.51-.72-6.72A12.61,12.61,0,0,1,97.37,206.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M97.42,206.48c1.36-1.78,10.12-2.8,12.36-2.8H217.06c2.23,0,10.94,1,12.3,2.77a12.61,12.61,0,0,1,7.91,11c.38,1.21-.29,5.36-.65,6.7L208.54,331c-1.51,5.73-6.48,9.54-12.23,10.38-.46.07-2.56.14-3,.14H134.81c-.47,0-2.52-.07-3-.14-5.71-.82-10.67-4.56-12.22-10.22L90.26,224.33c-.37-1.35-1.1-5.51-.72-6.72A12.6,12.6,0,0,1,97.42,206.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M97.47,206.47c1.34-1.76,10.13-2.78,12.35-2.78H217c2.2,0,10.95,1,12.29,2.75a12.59,12.59,0,0,1,7.94,11c.39,1.22-.28,5.35-.63,6.7L208.52,331c-1.5,5.73-6.47,9.53-12.22,10.36-.46.07-2.56.14-3,.14H134.82c-.46,0-2.52-.07-3-.13-5.71-.82-10.66-4.56-12.22-10.22L90.26,224.3c-.37-1.36-1.09-5.5-.71-6.73A12.61,12.61,0,0,1,97.47,206.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M97.52,206.46c1.33-1.75,10.15-2.75,12.35-2.75H217c2.18,0,11,1,12.29,2.72a12.6,12.6,0,0,1,8,11c.39,1.22-.27,5.34-.63,6.7L208.51,331c-1.51,5.72-6.47,9.52-12.23,10.35-.45.07-2.56.14-3,.14H134.83c-.46,0-2.53-.07-3-.13-5.71-.82-10.66-4.56-12.21-10.21L90.27,224.27c-.37-1.37-1.08-5.49-.7-6.73A12.59,12.59,0,0,1,97.52,206.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M97.57,206.45c1.32-1.73,10.17-2.73,12.35-2.73h107c2.17,0,11,1,12.29,2.7a12.57,12.57,0,0,1,8,11c.4,1.23-.26,5.33-.62,6.71L208.5,331c-1.51,5.73-6.48,9.51-12.23,10.35-.45.06-2.56.13-3,.13h-58.4c-.45,0-2.53-.06-3-.13-5.7-.81-10.66-4.54-12.21-10.2L90.28,224.24c-.38-1.37-1.08-5.49-.7-6.73A12.58,12.58,0,0,1,97.57,206.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M97.62,206.44c1.31-1.72,10.18-2.7,12.34-2.7H216.88c2.14,0,11,1,12.28,2.67a12.58,12.58,0,0,1,8.05,10.94c.4,1.24-.25,5.32-.62,6.71L208.48,331c-1.5,5.72-6.47,9.5-12.22,10.33-.45.07-2.57.14-3,.14H134.85c-.45,0-2.53-.07-3-.13-5.71-.81-10.66-4.54-12.22-10.19L90.29,224.21c-.39-1.38-1.08-5.48-.69-6.73A12.55,12.55,0,0,1,97.62,206.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M97.67,206.43c1.3-1.7,10.2-2.68,12.34-2.68H216.83c2.13,0,11,1,12.28,2.65a12.54,12.54,0,0,1,8.08,10.91c.4,1.26-.24,5.32-.6,6.72L208.47,331c-1.51,5.71-6.48,9.49-12.22,10.32-.44.06-2.57.13-3,.13H134.87c-.45,0-2.54-.06-3-.12-5.71-.81-10.66-4.54-12.21-10.18L90.29,224.18c-.38-1.39-1.07-5.47-.68-6.73A12.54,12.54,0,0,1,97.67,206.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M97.72,206.42c1.29-1.69,10.22-2.65,12.34-2.65H216.78c2.11,0,11,.95,12.28,2.62a12.56,12.56,0,0,1,8.12,10.89c.4,1.26-.23,5.32-.6,6.72L208.45,330.94c-1.5,5.72-6.47,9.49-12.22,10.32-.43.06-2.57.13-3,.13H134.88c-.45,0-2.54-.07-3-.13-5.7-.8-10.66-4.52-12.21-10.17L90.3,224.16c-.39-1.41-1.07-5.47-.67-6.74A12.52,12.52,0,0,1,97.72,206.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M97.77,206.41c1.27-1.67,10.23-2.63,12.33-2.63H216.74c2.08,0,11,.95,12.27,2.6a12.54,12.54,0,0,1,8.15,10.87c.41,1.27-.22,5.31-.59,6.72l-28.13,107c-1.5,5.71-6.47,9.48-12.22,10.3-.43.07-2.57.14-3,.14H134.89c-.44,0-2.54-.07-3-.13-5.7-.8-10.65-4.52-12.2-10.16l-29.41-107c-.39-1.42-1.06-5.47-.67-6.74A12.54,12.54,0,0,1,97.77,206.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M97.82,206.4c1.26-1.66,10.25-2.6,12.33-2.6H216.69c2.07,0,11,.93,12.27,2.57a12.53,12.53,0,0,1,8.19,10.85c.41,1.28-.21,5.3-.59,6.72l-28.14,107c-1.5,5.72-6.47,9.48-12.21,10.3-.43.06-2.58.13-3,.13H134.9c-.44,0-2.55-.07-3-.12-5.7-.81-10.65-4.51-12.2-10.15l-29.41-107c-.4-1.43-1.06-5.46-.66-6.74A12.5,12.5,0,0,1,97.82,206.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M97.87,206.39c1.25-1.64,10.27-2.58,12.33-2.58H216.64c2.05,0,11,.93,12.27,2.55a12.52,12.52,0,0,1,8.22,10.83c.41,1.29-.2,5.29-.57,6.72l-28.15,107c-1.5,5.71-6.47,9.47-12.21,10.29-.43.06-2.59.13-3,.13H134.91c-.43,0-2.55-.07-3-.13-5.7-.8-10.65-4.5-12.21-10.14l-29.42-107c-.39-1.44-1-5.45-.65-6.75A12.52,12.52,0,0,1,97.87,206.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M97.92,206.38c1.24-1.62,10.28-2.56,12.32-2.56H216.6c2,0,11,.92,12.26,2.53a12.51,12.51,0,0,1,8.26,10.81c.41,1.29-.19,5.28-.57,6.72L208.4,330.93c-1.51,5.7-6.47,9.46-12.22,10.27-.42.06-2.58.13-3,.13H134.92c-.42,0-2.55-.06-3-.12-5.7-.8-10.65-4.5-12.2-10.13L90.33,224c-.4-1.44-1-5.44-.64-6.75A12.48,12.48,0,0,1,97.92,206.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M98,206.37c1.23-1.61,10.3-2.53,12.32-2.53H216.55c2,0,11,.91,12.26,2.5a12.5,12.5,0,0,1,8.29,10.79c.42,1.3-.18,5.28-.56,6.73L208.38,330.92c-1.5,5.71-6.47,9.46-12.21,10.27-.42.06-2.59.13-3,.13H134.93c-.42,0-2.55-.07-3-.13-5.69-.79-10.65-4.48-12.2-10.12L90.34,224c-.4-1.45-1-5.44-.64-6.75A12.48,12.48,0,0,1,98,206.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M98,206.36c1.22-1.59,10.32-2.51,12.32-2.51H216.5c2,0,11.05.91,12.26,2.48a12.51,12.51,0,0,1,8.33,10.77c.42,1.31-.17,5.27-.56,6.73L208.37,330.92c-1.5,5.7-6.47,9.45-12.21,10.26-.41.05-2.59.12-3,.12h-58.2c-.41,0-2.55-.06-3-.12-5.69-.79-10.64-4.48-12.19-10.11L90.34,224c-.4-1.46-1-5.43-.63-6.75A12.49,12.49,0,0,1,98,206.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M98.08,206.35c1.2-1.58,10.32-2.48,12.3-2.48H216.46c2,0,11,.89,12.25,2.45a12.49,12.49,0,0,1,8.36,10.75c.43,1.32-.16,5.26-.55,6.73L208.35,330.92c-1.5,5.7-6.47,9.44-12.2,10.24-.41.06-2.6.13-3,.13H135c-.42,0-2.56-.07-3-.12-5.7-.79-10.65-4.47-12.2-10.1L90.35,224c-.4-1.47-1-5.42-.62-6.75A12.45,12.45,0,0,1,98.08,206.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M98.13,206.34c1.18-1.56,10.34-2.46,12.3-2.46h106c2,0,11.06.89,12.25,2.43a12.49,12.49,0,0,1,8.4,10.73c.42,1.32-.15,5.25-.54,6.73L208.34,330.91c-1.5,5.7-6.47,9.43-12.21,10.24-.4.06-2.59.12-3,.12H135c-.41,0-2.57-.06-3-.12-5.69-.78-10.65-4.46-12.19-10.09L90.36,223.92c-.41-1.48-1-5.42-.62-6.75A12.46,12.46,0,0,1,98.13,206.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M98.18,206.33c1.17-1.55,10.36-2.43,12.3-2.43H216.36c1.93,0,11.07.87,12.25,2.4A12.46,12.46,0,0,1,237,217c.43,1.34-.14,5.25-.53,6.74L208.32,330.91c-1.49,5.69-6.46,9.42-12.2,10.23-.4.05-2.6.12-3,.12H135c-.41,0-2.57-.07-3-.12-5.69-.78-10.64-4.46-12.19-10.08L90.37,223.89c-.41-1.49-1-5.41-.61-6.75A12.44,12.44,0,0,1,98.18,206.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M98.23,206.32c1.16-1.53,10.38-2.41,12.29-2.41h105.8c1.9,0,11.07.87,12.24,2.38A12.46,12.46,0,0,1,237,217c.43,1.35-.13,5.24-.53,6.74l-28.19,107.2c-1.5,5.69-6.47,9.41-12.2,10.21-.4.06-2.61.12-3,.12H135c-.4,0-2.57-.06-3-.11-5.69-.78-10.64-4.45-12.19-10.08L90.37,223.87c-.41-1.5-1-5.41-.6-6.76A12.44,12.44,0,0,1,98.23,206.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M98.28,206.3c1.15-1.51,10.39-2.37,12.29-2.37h105.7c1.89,0,11.09.85,12.24,2.35a12.44,12.44,0,0,1,8.5,10.66c.44,1.36-.12,5.24-.52,6.74L208.3,330.9c-1.5,5.69-6.47,9.41-12.21,10.21-.39.05-2.6.12-3,.12H135c-.4,0-2.57-.06-2.95-.12-5.69-.77-10.65-4.44-12.19-10.06L90.38,223.84c-.41-1.51-1-5.4-.59-6.77A12.44,12.44,0,0,1,98.28,206.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M98.33,206.29c1.14-1.49,10.41-2.35,12.29-2.35H216.23c1.86,0,11.09.85,12.23,2.33A12.45,12.45,0,0,1,237,216.91c.43,1.36-.11,5.23-.51,6.74L208.28,330.9c-1.49,5.69-6.46,9.4-12.2,10.2-.38,0-2.61.11-3,.11H135c-.39,0-2.57-.06-2.95-.11-5.69-.78-10.64-4.44-12.19-10.05L90.39,223.81c-.42-1.52-1-5.4-.59-6.77A12.44,12.44,0,0,1,98.33,206.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M98.38,206.28c1.13-1.47,10.43-2.32,12.29-2.32H216.18c1.85,0,11.1.84,12.23,2.3A12.43,12.43,0,0,1,237,216.88c.44,1.37-.1,5.22-.5,6.74L208.27,330.89c-1.5,5.69-6.47,9.4-12.2,10.19-.38.06-2.61.12-3,.12H135c-.39,0-2.57-.06-3-.11-5.69-.78-10.64-4.43-12.18-10L90.4,223.78c-.42-1.53-1-5.39-.58-6.77A12.42,12.42,0,0,1,98.38,206.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M98.43,206.27c1.11-1.46,10.44-2.3,12.28-2.3H216.13c1.83,0,11.11.83,12.23,2.28a12.45,12.45,0,0,1,8.61,10.6c.44,1.38-.09,5.21-.5,6.75L208.25,330.89c-1.49,5.68-6.46,9.39-12.19,10.18-.38.05-2.62.11-3,.11H135c-.38,0-2.58-.06-2.95-.11-5.68-.77-10.64-4.42-12.18-10L90.4,223.75c-.42-1.54-1-5.38-.57-6.77A12.42,12.42,0,0,1,98.43,206.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-184",
    d: "M98.48,206.26c1.1-1.44,10.46-2.27,12.28-2.27H216.09c1.8,0,11.11.82,12.22,2.25A12.41,12.41,0,0,1,237,216.82c.45,1.39-.08,5.2-.49,6.75L208.24,330.89c-1.49,5.68-6.47,9.38-12.2,10.17-.37.05-2.61.11-3,.11H135c-.38,0-2.58-.06-2.95-.11-5.68-.77-10.63-4.41-12.18-10L90.41,223.72c-.43-1.55-1-5.37-.56-6.77A12.4,12.4,0,0,1,98.48,206.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-185",
    d: "M98.53,206.25C99.62,204.82,109,204,110.81,204H216c1.79,0,11.12.81,12.22,2.23a12.42,12.42,0,0,1,8.68,10.56c.45,1.39-.08,5.19-.48,6.75L208.22,330.88c-1.49,5.68-6.46,9.38-12.19,10.16-.37,0-2.62.11-3,.11h-58c-.38,0-2.59,0-2.95-.1-5.69-.77-10.64-4.41-12.18-10L90.42,223.69c-.43-1.56-1-5.37-.56-6.77A12.4,12.4,0,0,1,98.53,206.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-186",
    d: "M98.58,206.24c1.08-1.41,10.49-2.22,12.27-2.22H216c1.77,0,11.14.8,12.22,2.2a12.4,12.4,0,0,1,8.71,10.54c.45,1.4-.06,5.19-.47,6.75L208.21,330.88c-1.49,5.67-6.46,9.37-12.19,10.15-.37.05-2.63.11-3,.11H135.07c-.38,0-2.59-.06-2.95-.11-5.68-.76-10.63-4.4-12.18-10L90.42,223.66c-.43-1.56-1-5.36-.54-6.77A12.39,12.39,0,0,1,98.58,206.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-187",
    d: "M98.63,206.23c1.07-1.4,10.51-2.2,12.27-2.2H216c1.74,0,11.14.79,12.2,2.18a12.39,12.39,0,0,1,8.76,10.52c.45,1.41-.06,5.18-.47,6.75L208.2,330.88c-1.5,5.67-6.47,9.35-12.19,10.14-.37,0-2.63.11-3,.11H135.08c-.37,0-2.59-.06-3-.11-5.68-.76-10.63-4.39-12.17-10L90.43,223.63c-.43-1.57-1-5.35-.54-6.77A12.39,12.39,0,0,1,98.63,206.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M98.68,206.22c1.06-1.38,10.53-2.17,12.27-2.17h105c1.73,0,11.15.78,12.2,2.15a12.38,12.38,0,0,1,8.79,10.49c.46,1.43,0,5.18-.46,6.76L208.18,330.87c-1.49,5.67-6.46,9.35-12.19,10.13-.35.05-2.63.11-3,.11h-57.9c-.36,0-2.6-.06-3-.1-5.67-.76-10.63-4.39-12.17-10L90.44,223.6c-.44-1.58-1-5.35-.54-6.78A12.39,12.39,0,0,1,98.68,206.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-189",
    d: "M98.73,206.21c1-1.37,10.54-2.15,12.26-2.15H215.85c1.71,0,11.16.78,12.2,2.13a12.38,12.38,0,0,1,8.83,10.47c.46,1.43,0,5.17-.45,6.76L208.17,330.87c-1.49,5.67-6.46,9.34-12.19,10.12-.35.05-2.63.11-3,.11H135.1c-.36,0-2.6-.06-2.94-.11-5.68-.75-10.63-4.37-12.17-10L90.45,223.58c-.44-1.6-1-5.35-.53-6.79A12.37,12.37,0,0,1,98.73,206.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M98.78,206.2c1-1.35,10.56-2.13,12.26-2.13H215.81c1.68,0,11.16.77,12.19,2.11a12.36,12.36,0,0,1,8.86,10.45c.47,1.44,0,5.16-.44,6.76L208.15,330.86c-1.49,5.67-6.46,9.34-12.18,10.11-.35,0-2.64.11-3,.11H135.11c-.35,0-2.6-.06-2.94-.1-5.68-.76-10.63-4.37-12.17-10L90.45,223.55c-.44-1.61-1-5.34-.52-6.79A12.37,12.37,0,0,1,98.78,206.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-190",
    d: "M98.83,206.19c1-1.33,10.58-2.1,12.26-2.1H215.76c1.67,0,11.18.76,12.19,2.08a12.38,12.38,0,0,1,8.9,10.43c.46,1.45,0,5.16-.44,6.77L208.14,330.86c-1.49,5.66-6.46,9.33-12.18,10.1-.35.05-2.64.11-3,.11H135.12c-.35,0-2.6-.06-2.94-.1-5.67-.76-10.63-4.37-12.17-10L90.46,223.52c-.44-1.62-1-5.33-.51-6.79A12.36,12.36,0,0,1,98.83,206.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-191",
    d: "M98.88,206.18c1-1.32,10.59-2.08,12.25-2.08H215.71c1.65,0,11.19.75,12.19,2.06a12.37,12.37,0,0,1,8.94,10.41c.46,1.46,0,5.15-.44,6.77L208.13,330.86c-1.49,5.66-6.47,9.32-12.19,10.09-.34,0-2.64.1-3,.1H135.13c-.34,0-2.6-.05-2.94-.1-5.67-.75-10.62-4.35-12.16-9.95L90.47,223.49c-.45-1.62-1-5.33-.51-6.79A12.38,12.38,0,0,1,98.88,206.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-192",
    d: "M98.93,206.17c1-1.3,10.61-2,12.25-2H215.67c1.62,0,11.19.74,12.18,2a12.37,12.37,0,0,1,9,10.39c.47,1.46,0,5.14-.42,6.77L208.11,330.85c-1.49,5.66-6.46,9.32-12.18,10.08-.34.05-2.64.11-3,.11H135.15c-.35,0-2.61-.06-2.94-.1-5.68-.75-10.63-4.35-12.17-9.94L90.48,223.46c-.45-1.63-1-5.32-.5-6.79A12.35,12.35,0,0,1,98.93,206.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M99,206.16c1-1.29,10.62-2,12.24-2H215.62c1.61,0,11.2.73,12.18,2a12.36,12.36,0,0,1,9,10.37c.47,1.47,0,5.13-.42,6.77L208.1,330.85c-1.49,5.66-6.46,9.31-12.18,10.07-.33.05-2.65.1-3,.1H135.16c-.34,0-2.62,0-2.94-.1-5.67-.74-10.63-4.34-12.16-9.92L90.48,223.43c-.45-1.64-1-5.31-.49-6.79A12.36,12.36,0,0,1,99,206.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-194",
    d: "M99,206.15c1-1.27,10.63-2,12.23-2h104.3c1.59,0,11.21.72,12.18,2a12.36,12.36,0,0,1,9,10.35c.47,1.48,0,5.12-.41,6.77l-28.3,107.6c-1.48,5.65-6.46,9.3-12.17,10.06-.33,0-2.66.1-3,.1H135.17c-.34,0-2.62-.06-2.94-.1-5.67-.74-10.62-4.33-12.16-9.92L90.49,223.4c-.45-1.65-.95-5.3-.48-6.79A12.32,12.32,0,0,1,99,206.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M99.09,206.14c1-1.26,10.65-2,12.23-2H215.53c1.56,0,11.21.72,12.17,2a12.35,12.35,0,0,1,9.08,10.33c.47,1.49,0,5.11-.41,6.77l-28.3,107.62c-1.49,5.65-6.46,9.3-12.18,10.05-.32.05-2.65.1-3,.1H135.18c-.33,0-2.62-.05-2.94-.09-5.67-.74-10.62-4.33-12.15-9.91L90.5,223.37c-.46-1.66-.94-5.3-.48-6.8A12.34,12.34,0,0,1,99.09,206.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M99.14,206.13c.94-1.24,10.67-1.95,12.23-1.95H215.48c1.55,0,11.23.7,12.17,1.93a12.32,12.32,0,0,1,9.11,10.31c.48,1.49,0,5.11-.4,6.77L208.05,330.84c-1.48,5.65-6.45,9.29-12.17,10-.32,0-2.66.1-3,.1h-57.7c-.33,0-2.62-.05-2.94-.1-5.66-.73-10.62-4.31-12.15-9.9L90.5,223.34c-.45-1.67-.93-5.29-.46-6.8A12.33,12.33,0,0,1,99.14,206.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-197",
    d: "M99.19,206.12c.93-1.23,10.68-1.93,12.22-1.93h104c1.53,0,11.24.7,12.17,1.91a12.34,12.34,0,0,1,9.15,10.29c.48,1.5.05,5.1-.39,6.77L208,330.83c-1.49,5.65-6.46,9.28-12.17,10-.32,0-2.66.09-3,.09H135.2c-.32,0-2.62,0-2.93-.09-5.67-.73-10.62-4.31-12.16-9.89L90.51,223.31c-.46-1.68-.93-5.28-.46-6.8A12.32,12.32,0,0,1,99.19,206.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-198",
    d: "M99.24,206.11c.92-1.21,10.7-1.9,12.22-1.9H215.39c1.51,0,11.24.68,12.16,1.88a12.31,12.31,0,0,1,9.18,10.26c.49,1.52.06,5.1-.38,6.78L208,330.83c-1.49,5.65-6.46,9.27-12.17,10-.32,0-2.67.1-3,.1H135.21c-.32,0-2.62-.05-2.93-.09-5.67-.73-10.62-4.31-12.15-9.88L90.52,223.28c-.47-1.68-.93-5.28-.46-6.8A12.34,12.34,0,0,1,99.24,206.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-199",
    d: "M99.29,206.1c.91-1.19,10.72-1.88,12.22-1.88H215.34c1.49,0,11.25.68,12.16,1.86a12.34,12.34,0,0,1,9.22,10.24c.48,1.53.07,5.09-.38,6.79L208,330.83c-1.48,5.64-6.46,9.26-12.17,10-.31,0-2.66.09-3,.09H135.22c-.31,0-2.63-.05-2.93-.09-5.66-.73-10.62-4.29-12.15-9.87L90.53,223.26c-.47-1.7-.93-5.28-.45-6.81A12.31,12.31,0,0,1,99.29,206.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-200",
    d: "M99.34,206.09c.9-1.18,10.74-1.85,12.21-1.85H215.29c1.47,0,11.26.66,12.16,1.83a12.32,12.32,0,0,1,9.25,10.22c.49,1.53.08,5.08-.37,6.79L208,330.82c-1.49,5.64-6.46,9.26-12.17,10-.3,0-2.67.09-3,.09H135.23c-.3,0-2.63-.05-2.93-.09-5.66-.73-10.61-4.29-12.14-9.86L90.53,223.23c-.47-1.71-.91-5.27-.44-6.81A12.31,12.31,0,0,1,99.34,206.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M99.39,206.08c.88-1.16,10.75-1.83,12.21-1.83H215.25c1.45,0,11.26.66,12.15,1.81a12.33,12.33,0,0,1,9.29,10.2c.49,1.54.09,5.07-.36,6.79L208,330.82c-1.48,5.64-6.45,9.25-12.16,10-.3,0-2.68.09-3,.09H135.25c-.31,0-2.64,0-2.93-.08-5.67-.73-10.62-4.29-12.15-9.86L90.54,223.2c-.47-1.72-.91-5.26-.43-6.81A12.31,12.31,0,0,1,99.39,206.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M99.44,206.07c.87-1.15,10.77-1.8,12.21-1.8H215.2c1.43,0,11.28.65,12.15,1.78a12.31,12.31,0,0,1,9.32,10.18c.5,1.55.1,5.07-.35,6.79L208,330.82c-1.48,5.63-6.46,9.24-12.16,10-.3,0-2.68.09-3,.09H135.26c-.3,0-2.64-.05-2.93-.09-5.66-.72-10.61-4.27-12.15-9.84L90.55,223.17c-.48-1.73-.91-5.26-.43-6.81A12.3,12.3,0,0,1,99.44,206.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-202",
    d: "M99.49,206.06c.86-1.13,10.79-1.78,12.21-1.78H215.15c1.41,0,11.29.64,12.15,1.76a12.31,12.31,0,0,1,9.36,10.16c.49,1.56.11,5.06-.35,6.79L208,330.81c-1.48,5.64-6.45,9.24-12.16,10-.29,0-2.68.09-3,.09H135.27c-.3,0-2.64-.05-2.93-.09-5.66-.72-10.61-4.27-12.14-9.83L90.56,223.14c-.48-1.74-.91-5.25-.42-6.82A12.3,12.3,0,0,1,99.49,206.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M99.54,206.05c.85-1.12,10.8-1.75,12.2-1.75H215.11c1.39,0,11.29.63,12.14,1.73a12.29,12.29,0,0,1,9.39,10.14c.5,1.56.12,5.05-.34,6.79L207.94,330.81c-1.48,5.63-6.45,9.23-12.16,10-.29,0-2.68.09-3,.09H135.28c-.29,0-2.64-.05-2.93-.08-5.66-.72-10.61-4.26-12.14-9.83L90.56,223.11c-.48-1.74-.9-5.24-.41-6.82A12.3,12.3,0,0,1,99.54,206.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-204",
    d: "M99.59,206c.84-1.1,10.82-1.73,12.2-1.73H215.06c1.37,0,11.3.62,12.14,1.71a12.3,12.3,0,0,1,9.43,10.12c.5,1.57.13,5-.33,6.79L207.93,330.8c-1.48,5.63-6.46,9.23-12.16,10-.29,0-2.69.09-3,.09h-57.5c-.29,0-2.65-.05-2.93-.09-5.65-.71-10.6-4.25-12.13-9.81L90.57,223.08c-.48-1.75-.89-5.23-.4-6.82A12.28,12.28,0,0,1,99.59,206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M99.64,206c.83-1.08,10.84-1.71,12.2-1.71H215c1.35,0,11.31.62,12.14,1.69a12.29,12.29,0,0,1,9.46,10.1c.51,1.58.14,5-.32,6.79L207.91,330.8c-1.48,5.63-6.45,9.22-12.15,9.95-.28,0-2.69.08-3,.08H135.3c-.28,0-2.65-.05-2.92-.08-5.66-.71-10.61-4.25-12.14-9.8L90.58,223.05c-.49-1.76-.89-5.23-.4-6.82A12.29,12.29,0,0,1,99.64,206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-206",
    d: "M99.69,206c.81-1.07,10.85-1.68,12.19-1.68H215c1.33,0,11.32.6,12.13,1.66a12.3,12.3,0,0,1,9.5,10.08c.51,1.59.15,5-.32,6.8L207.9,330.8c-1.48,5.62-6.46,9.2-12.16,9.93-.27,0-2.69.09-3,.09H135.31c-.28,0-2.65-.05-2.92-.08-5.65-.71-10.61-4.24-12.13-9.8L90.58,223c-.48-1.77-.88-5.22-.38-6.82A12.26,12.26,0,0,1,99.69,206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M99.74,206c.8-1,10.87-1.66,12.19-1.66h103c1.31,0,11.33.6,12.13,1.64a12.29,12.29,0,0,1,9.53,10c.51,1.6.16,5-.31,6.81L207.88,330.79c-1.48,5.63-6.45,9.2-12.15,9.93-.27,0-2.7.08-3,.08H135.32c-.27,0-2.65,0-2.92-.08-5.65-.71-10.6-4.23-12.13-9.78L90.59,223c-.49-1.78-.88-5.21-.38-6.82A12.28,12.28,0,0,1,99.74,206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-208",
    d: "M99.79,206c.79-1,10.89-1.63,12.19-1.63H214.87c1.29,0,11.34.59,12.13,1.61a12.29,12.29,0,0,1,9.57,10c.51,1.61.17,5-.3,6.81l-28.4,108c-1.48,5.62-6.45,9.19-12.15,9.92-.27,0-2.7.08-3,.08H135.33c-.27,0-2.65-.05-2.92-.08-5.65-.71-10.6-4.22-12.13-9.78L90.6,223c-.49-1.8-.88-5.22-.38-6.83A12.28,12.28,0,0,1,99.79,206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M99.84,206c.78-1,10.9-1.61,12.18-1.61H214.83c1.27,0,11.34.58,12.12,1.59a12.28,12.28,0,0,1,9.6,10c.52,1.62.18,5-.29,6.81l-28.4,108c-1.48,5.61-6.46,9.18-12.15,9.9-.27,0-2.71.08-3,.08H135.35c-.27,0-2.67,0-2.92-.07-5.65-.71-10.61-4.22-12.13-9.77l-29.69-108c-.5-1.81-.88-5.21-.37-6.83A12.27,12.27,0,0,1,99.84,206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-210",
    d: "M99.89,206c.77-1,10.92-1.57,12.18-1.57H214.78c1.25,0,11.35.57,12.12,1.56a12.29,12.29,0,0,1,9.64,10c.52,1.63.19,5-.29,6.81l-28.41,108c-1.48,5.62-6.45,9.18-12.15,9.9-.26,0-2.7.08-3,.08H135.36c-.27,0-2.67-.05-2.92-.08-5.65-.7-10.6-4.21-12.13-9.75l-29.7-108c-.49-1.81-.86-5.2-.36-6.84A12.3,12.3,0,0,1,99.89,206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-211",
    d: "M100,206c.75-1,10.93-1.55,12.17-1.55H214.73c1.24,0,11.36.56,12.12,1.54a12.26,12.26,0,0,1,9.67,10c.53,1.63.2,5-.28,6.81l-28.41,108c-1.48,5.61-6.45,9.17-12.15,9.89-.26,0-2.71.07-3,.07H135.37c-.26,0-2.67,0-2.92-.07-5.65-.7-10.6-4.2-12.12-9.75l-29.71-108c-.5-1.82-.86-5.19-.35-6.84A12.29,12.29,0,0,1,100,206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M100,206c.74-1,10.94-1.52,12.16-1.52H214.69c1.21,0,11.37.55,12.11,1.51a12.28,12.28,0,0,1,9.71,9.95c.52,1.64.21,5-.28,6.81L207.81,330.77c-1.47,5.62-6.45,9.17-12.14,9.88-.25,0-2.71.08-3,.08H135.38c-.26,0-2.67,0-2.92-.08-5.64-.69-10.6-4.19-12.12-9.73L90.63,222.85c-.51-1.83-.86-5.19-.35-6.84A12.28,12.28,0,0,1,100,206Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M100.05,205.94c.72-.95,11-1.5,12.16-1.5H214.64c1.19,0,11.38.54,12.11,1.49a12.26,12.26,0,0,1,9.74,9.93c.53,1.65.22,5-.26,6.81L207.8,330.77c-1.48,5.61-6.45,9.16-12.14,9.87-.25,0-2.72.07-3,.07H135.39c-.25,0-2.67,0-2.91-.07-5.65-.69-10.6-4.19-12.13-9.73L90.64,222.82c-.51-1.84-.86-5.18-.34-6.84A12.27,12.27,0,0,1,100.05,205.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-213",
    d: "M100.1,205.93c.71-.93,11-1.47,12.16-1.47H214.59c1.18,0,11.39.53,12.11,1.46a12.27,12.27,0,0,1,9.78,9.91c.53,1.66.23,5-.26,6.82L207.78,330.77c-1.47,5.6-6.45,9.15-12.14,9.86-.24,0-2.71.07-3,.07H135.4c-.24,0-2.67,0-2.91-.07-5.65-.69-10.6-4.18-12.12-9.72L90.64,222.79c-.51-1.85-.85-5.17-.33-6.84A12.28,12.28,0,0,1,100.1,205.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-214",
    d: "M100.15,205.92c.7-.92,11-1.45,12.15-1.45H214.55c1.15,0,11.39.52,12.1,1.44a12.25,12.25,0,0,1,9.81,9.89c.54,1.66.24,5-.25,6.82L207.77,330.76c-1.47,5.61-6.45,9.15-12.14,9.85-.24,0-2.72.07-3,.07H135.41c-.24,0-2.68,0-2.91-.07-5.64-.68-10.59-4.17-12.12-9.7L90.65,222.76c-.51-1.86-.84-5.16-.32-6.84A12.27,12.27,0,0,1,100.15,205.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M100.2,205.91c.69-.9,11-1.42,12.15-1.42H214.5c1.13,0,11.4.51,12.09,1.41a12.26,12.26,0,0,1,9.86,9.87c.53,1.67.24,4.95-.25,6.82L207.76,330.76c-1.48,5.6-6.45,9.14-12.14,9.84-.24,0-2.73.07-3,.07H135.42c-.23,0-2.68,0-2.91-.07-5.64-.68-10.59-4.16-12.11-9.7L90.66,222.73c-.52-1.86-.84-5.16-.32-6.84A12.28,12.28,0,0,1,100.2,205.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M100.25,205.9c.68-.89,11-1.4,12.15-1.4h102c1.12,0,11.42.51,12.09,1.39a12.26,12.26,0,0,1,9.89,9.84c.54,1.69.26,5-.23,6.83l-28.46,108.2c-1.47,5.6-6.45,9.12-12.13,9.82-.24,0-2.73.07-3,.07h-57.2c-.24,0-2.69,0-2.92-.06-5.64-.69-10.59-4.16-12.11-9.69L90.66,222.7c-.51-1.87-.83-5.15-.3-6.84A12.26,12.26,0,0,1,100.25,205.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M100.3,205.89c.67-.87,11-1.37,12.14-1.37h102c1.09,0,11.42.49,12.08,1.36a12.26,12.26,0,0,1,9.93,9.82,15.4,15.4,0,0,1-.23,6.83L207.73,330.75c-1.48,5.6-6.45,9.12-12.14,9.82-.22,0-2.73.07-3,.07H135.45c-.23,0-2.69,0-2.91-.07-5.64-.68-10.59-4.15-12.11-9.68L90.67,222.68c-.52-1.89-.83-5.15-.3-6.86A12.28,12.28,0,0,1,100.3,205.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-218",
    d: "M100.35,205.88c.65-.86,11.06-1.35,12.14-1.35H214.36c1.07,0,11.43.49,12.08,1.34a12.26,12.26,0,0,1,10,9.8,15.11,15.11,0,0,1-.22,6.83L207.71,330.75c-1.47,5.59-6.44,9.11-12.13,9.81-.22,0-2.73.07-3,.07H135.46c-.23,0-2.69,0-2.91-.07-5.64-.68-10.59-4.14-12.11-9.67L90.68,222.65c-.52-1.9-.83-5.15-.29-6.86A12.25,12.25,0,0,1,100.35,205.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M100.4,205.87c.64-.84,11.08-1.32,12.14-1.32H214.31c1.06,0,11.44.47,12.08,1.31a12.26,12.26,0,0,1,10,9.78,15.11,15.11,0,0,1-.22,6.83L207.7,330.74c-1.47,5.6-6.45,9.11-12.13,9.8-.22,0-2.74.07-3,.07H135.47c-.22,0-2.69,0-2.91-.06-5.64-.68-10.59-4.14-12.11-9.66L90.69,222.62a15.14,15.14,0,0,1-.29-6.86A12.25,12.25,0,0,1,100.4,205.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M100.45,205.86c.63-.83,11.1-1.3,12.14-1.3H214.27c1,0,11.44.47,12.07,1.29a12.24,12.24,0,0,1,10,9.76,15.09,15.09,0,0,1-.2,6.83l-28.49,108.3c-1.47,5.59-6.44,9.1-12.13,9.79-.21,0-2.73.07-3,.07H135.48c-.22,0-2.7,0-2.91-.07-5.63-.67-10.58-4.12-12.1-9.65L90.69,222.59a15.27,15.27,0,0,1-.28-6.86A12.27,12.27,0,0,1,100.45,205.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-221",
    d: "M100.5,205.85c.62-.81,11.11-1.28,12.13-1.28H214.22c1,0,11.45.46,12.07,1.27a12.26,12.26,0,0,1,10.07,9.74,15.09,15.09,0,0,1-.2,6.83L207.67,330.74c-1.47,5.59-6.45,9.09-12.13,9.78-.21,0-2.74.06-3,.06H135.49c-.21,0-2.7,0-2.9-.06-5.64-.67-10.59-4.12-12.11-9.64L90.7,222.56a15,15,0,0,1-.27-6.86A12.26,12.26,0,0,1,100.5,205.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-222",
    d: "M100.55,205.84c.61-.79,11.13-1.25,12.13-1.25H214.17c1,0,11.47.45,12.07,1.24a12.24,12.24,0,0,1,10.1,9.72,14.86,14.86,0,0,1-.19,6.84L207.66,330.73c-1.47,5.59-6.45,9.09-12.13,9.77-.21,0-2.75.07-3,.07H135.5c-.21,0-2.7,0-2.9-.06-5.64-.67-10.59-4.12-12.1-9.64L90.71,222.53a15,15,0,0,1-.27-6.86A12.27,12.27,0,0,1,100.55,205.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M100.6,205.83c.6-.78,11.15-1.23,12.13-1.23h101.4c1,0,11.47.45,12.06,1.22a12.26,12.26,0,0,1,10.14,9.7,14.86,14.86,0,0,1-.19,6.84l-28.5,108.37c-1.47,5.58-6.44,9.08-12.12,9.76-.21,0-2.75.06-3,.06H135.51c-.2,0-2.7,0-2.9-.06-5.63-.66-10.58-4.1-12.1-9.62L90.72,222.5a14.71,14.71,0,0,1-.26-6.86A12.26,12.26,0,0,1,100.6,205.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-223",
    d: "M100.65,205.82c.58-.76,11.16-1.2,12.12-1.2H214.08c.95,0,11.48.43,12.06,1.19a12.25,12.25,0,0,1,10.17,9.68,14.85,14.85,0,0,1-.17,6.84l-28.51,108.4c-1.47,5.58-6.45,9.07-12.13,9.75-.19,0-2.75.06-2.95.06h-57c-.2,0-2.7,0-2.9-.06-5.63-.66-10.58-4.1-12.1-9.61l-29.8-108.4a15,15,0,0,1-.25-6.86A12.25,12.25,0,0,1,100.65,205.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M100.7,205.81c.57-.75,11.18-1.18,12.12-1.18H214c.93,0,11.48.43,12.05,1.17a12.26,12.26,0,0,1,10.21,9.66,14.85,14.85,0,0,1-.17,6.84L207.61,330.72c-1.46,5.58-6.44,9.07-12.12,9.74-.19,0-2.75.06-3,.06h-57c-.2,0-2.71,0-2.9,0-5.64-.67-10.59-4.1-12.1-9.61L90.73,222.44a14.74,14.74,0,0,1-.24-6.87A12.25,12.25,0,0,1,100.7,205.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-225",
    d: "M100.75,205.8c.56-.73,11.2-1.15,12.12-1.15H214c.91,0,11.49.41,12,1.14a12.25,12.25,0,0,1,10.24,9.64,14.58,14.58,0,0,1-.16,6.84L207.6,330.72c-1.47,5.58-6.44,9-12.12,9.73-.19,0-2.76.06-3,.06h-57c-.2,0-2.72,0-2.9-.06-5.63-.66-10.58-4.08-12.1-9.59L90.74,222.41a14.61,14.61,0,0,1-.24-6.87A12.26,12.26,0,0,1,100.75,205.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-226",
    d: "M100.8,205.79c.55-.72,11.21-1.13,12.11-1.13h101c.9,0,11.51.41,12.05,1.12a12.25,12.25,0,0,1,10.28,9.61,14.62,14.62,0,0,1-.16,6.85L207.58,330.71c-1.46,5.58-6.44,9.05-12.11,9.73-.19,0-2.76.05-3,.05H135.56c-.19,0-2.72,0-2.9-.05-5.63-.66-10.58-4.08-12.09-9.58L90.74,222.38a14.6,14.6,0,0,1-.22-6.87A12.24,12.24,0,0,1,100.8,205.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-227",
    d: "M100.85,205.78c.54-.7,11.23-1.1,12.11-1.1H213.9c.87,0,11.51.39,12,1.09a12.25,12.25,0,0,1,10.31,9.59,14.48,14.48,0,0,1-.14,6.85l-28.54,108.5c-1.46,5.57-6.44,9-12.12,9.71-.18,0-2.76.06-2.95.06H135.57c-.18,0-2.72,0-2.9-.05-5.62-.66-10.58-4.07-12.09-9.58L90.75,222.36a14.51,14.51,0,0,1-.22-6.88A12.27,12.27,0,0,1,100.85,205.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M100.91,205.77c.52-.69,11.24-1.08,12.1-1.08H213.85c.85,0,11.52.39,12,1.07a12.27,12.27,0,0,1,10.35,9.57,14.61,14.61,0,0,1-.14,6.85L207.56,330.71c-1.47,5.57-6.44,9-12.12,9.7-.18,0-2.77,0-2.95,0H135.58c-.18,0-2.72,0-2.9,0-5.62-.65-10.57-4.06-12.08-9.56L90.76,222.33a14.51,14.51,0,0,1-.21-6.88A12.24,12.24,0,0,1,100.91,205.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M101,205.76c.51-.67,11.25-1,12.09-1H213.8c.84,0,11.53.38,12,1a12.26,12.26,0,0,1,10.38,9.55,14.39,14.39,0,0,1-.13,6.86L207.54,330.7c-1.46,5.57-6.44,9-12.11,9.7-.17,0-2.77.05-3,.05H135.59c-.17,0-2.72,0-2.89-.05-5.63-.65-10.58-4.06-12.09-9.56L90.77,222.3a14.38,14.38,0,0,1-.21-6.88A12.27,12.27,0,0,1,101,205.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-230",
    d: "M101,205.75c.49-.65,11.27-1,12.09-1H213.76c.81,0,11.53.37,12,1a12.27,12.27,0,0,1,10.42,9.53,14.39,14.39,0,0,1-.13,6.86L207.53,330.7c-1.47,5.57-6.44,9-12.11,9.68-.17,0-2.78.05-2.95.05H135.6c-.17,0-2.73,0-2.89-.05-5.62-.64-10.57-4-12.09-9.54L90.77,222.27a14.51,14.51,0,0,1-.2-6.88A12.27,12.27,0,0,1,101,205.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-231",
    d: "M101.06,205.74c.48-.64,11.29-1,12.09-1H213.71c.79,0,11.54.36,12,1a12.27,12.27,0,0,1,10.45,9.51,14.14,14.14,0,0,1-.12,6.86L207.51,330.7c-1.46,5.56-6.44,9-12.11,9.67-.16,0-2.77.05-2.94.05H135.61c-.16,0-2.73,0-2.89-.05-5.62-.64-10.57-4-12.08-9.53L90.78,222.24a14.25,14.25,0,0,1-.19-6.88A12.25,12.25,0,0,1,101.06,205.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M101.11,205.73c.47-.62,11.3-1,12.08-1H213.66c.78,0,11.56.35,12,1a12.27,12.27,0,0,1,10.49,9.49,14.25,14.25,0,0,1-.11,6.86L207.5,330.69c-1.46,5.56-6.44,9-12.11,9.67l-2.94,0H135.63c-.17,0-2.74,0-2.9,0-5.62-.64-10.57-4-12.08-9.53L90.79,222.21a14.29,14.29,0,0,1-.19-6.89A12.27,12.27,0,0,1,101.11,205.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M101.16,205.72c.46-.61,11.32-.95,12.08-.95H213.62c.75,0,11.56.34,12,.94a12.29,12.29,0,0,1,10.53,9.47,14.25,14.25,0,0,1-.11,6.86L207.49,330.69c-1.47,5.56-6.44,9-12.11,9.65-.16,0-2.78.05-2.95.05H135.64c-.16,0-2.74,0-2.89-.05-5.62-.64-10.57-4-12.08-9.51L90.79,222.18a14.16,14.16,0,0,1-.17-6.89A12.25,12.25,0,0,1,101.16,205.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-234",
    d: "M101.21,205.71c.45-.59,11.34-.93,12.08-.93H213.57c.73,0,11.57.33,12,.92a12.28,12.28,0,0,1,10.56,9.45,14.13,14.13,0,0,1-.1,6.86L207.47,330.68c-1.46,5.56-6.44,9-12.1,9.65-.16,0-2.79.05-3,.05H135.65c-.16,0-2.74,0-2.89-.05-5.62-.64-10.57-4-12.08-9.51L90.8,222.15a14.28,14.28,0,0,1-.17-6.89A12.27,12.27,0,0,1,101.21,205.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M101.26,205.7c.44-.58,11.35-.9,12.07-.9H213.52c.72,0,11.58.32,12,.89a12.29,12.29,0,0,1,10.6,9.43A14,14,0,0,1,236,222l-28.58,108.7c-1.46,5.55-6.44,9-12.11,9.64l-2.94,0H135.66l-2.89,0c-5.62-.64-10.57-4-12.08-9.5L90.81,222.12a14,14,0,0,1-.16-6.89A12.27,12.27,0,0,1,101.26,205.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M101.31,205.69c.42-.56,11.37-.88,12.07-.88h100.1c.69,0,11.58.32,12,.87a12.28,12.28,0,0,1,10.63,9.4A14,14,0,0,1,236,222l-28.6,108.73c-1.46,5.55-6.43,9-12.1,9.62-.14,0-2.79.05-2.94.05H135.67c-.15,0-2.75,0-2.89-.05-5.61-.63-10.56-4-12.07-9.48L90.82,222.09a14,14,0,0,1-.16-6.89A12.26,12.26,0,0,1,101.31,205.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M101.36,205.68c.41-.55,11.39-.86,12.07-.86h100c.67,0,11.6.31,12,.85a12.28,12.28,0,0,1,10.67,9.38,14,14,0,0,1-.08,6.87l-28.6,108.75c-1.46,5.55-6.44,9-12.1,9.62l-2.94,0H135.68c-.14,0-2.75,0-2.89,0-5.61-.63-10.56-4-12.07-9.48L90.82,222.07a14,14,0,0,1-.14-6.9A12.26,12.26,0,0,1,101.36,205.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M101.41,205.67c.4-.53,11.41-.83,12.06-.83h99.91c.66,0,11.61.3,12,.82a12.27,12.27,0,0,1,10.7,9.36,14,14,0,0,1-.07,6.88L207.41,330.67c-1.45,5.55-6.43,9-12.09,9.61l-2.94,0H135.69l-2.88,0c-5.62-.63-10.57-4-12.07-9.47L90.83,222a14,14,0,0,1-.14-6.9A12.26,12.26,0,0,1,101.41,205.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M101.46,205.65c.39-.5,11.42-.8,12.06-.8h99.82c.63,0,11.61.29,12,.8A12.29,12.29,0,0,1,236.08,215a13.84,13.84,0,0,1-.07,6.88L207.4,330.67c-1.46,5.54-6.43,8.95-12.1,9.59-.13,0-2.8,0-2.93,0H135.7c-.13,0-2.75,0-2.88,0-5.61-.62-10.56-4-12.07-9.46L90.84,222a13.83,13.83,0,0,1-.13-6.9A12.29,12.29,0,0,1,101.46,205.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M101.51,205.64c.38-.49,11.44-.77,12.06-.77h99.72c.62,0,11.62.28,12,.77A12.28,12.28,0,0,1,236.06,215a13.83,13.83,0,0,1-.05,6.88L207.39,330.66c-1.46,5.54-6.44,8.95-12.1,9.59l-2.94,0H135.71l-2.88,0c-5.61-.62-10.56-4-12.06-9.45L90.85,222a13.75,13.75,0,0,1-.13-6.91A12.32,12.32,0,0,1,101.51,205.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M101.56,205.63c.37-.47,11.46-.75,12.06-.75h99.62c.6,0,11.63.27,12,.75a12.31,12.31,0,0,1,10.81,9.3,13.72,13.72,0,0,1-.05,6.88L207.37,330.66c-1.46,5.54-6.43,8.94-12.09,9.57-.13,0-2.81,0-2.94,0H135.73l-2.89,0c-5.61-.62-10.56-4-12.06-9.44L90.85,222a13.86,13.86,0,0,1-.12-6.91A12.32,12.32,0,0,1,101.56,205.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M101.61,205.62c.35-.46,11.47-.72,12-.72H213.2c.57,0,11.63.26,12,.72A12.29,12.29,0,0,1,236,214.9a13.71,13.71,0,0,1,0,6.88L207.36,330.65c-1.46,5.54-6.44,8.94-12.09,9.57l-2.94,0H135.74c-.12,0-2.77,0-2.88,0-5.61-.61-10.56-4-12.07-9.43L90.86,221.92a13.63,13.63,0,0,1-.11-6.91A12.31,12.31,0,0,1,101.61,205.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-242",
    d: "M101.66,205.61c.34-.44,11.49-.7,12-.7h99.44c.56,0,11.65.26,12,.7A12.31,12.31,0,0,1,236,214.87a13.6,13.6,0,0,1,0,6.88l-28.64,108.9c-1.45,5.54-6.43,8.93-12.09,9.56l-2.93,0H135.75l-2.88,0c-5.61-.62-10.56-3.95-12.06-9.42L90.87,221.89a13.63,13.63,0,0,1-.11-6.91A12.31,12.31,0,0,1,101.66,205.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M101.71,205.6c.33-.43,11.51-.67,12.05-.67H213.1c.54,0,11.66.24,12,.67A12.29,12.29,0,0,1,236,214.84a13.59,13.59,0,0,1,0,6.88L207.33,330.65c-1.46,5.53-6.43,8.92-12.09,9.54-.11,0-2.82,0-2.93,0H135.76l-2.88,0c-5.61-.62-10.55-3.95-12.06-9.41L90.87,221.86a13.62,13.62,0,0,1-.09-6.91A12.3,12.3,0,0,1,101.71,205.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M101.76,205.59c.32-.41,11.52-.65,12-.65h99.26c.51,0,11.66.24,12,.65a12.3,12.3,0,0,1,11,9.22,13.48,13.48,0,0,1,0,6.88l-28.66,109c-1.45,5.53-6.43,8.91-12.08,9.54l-2.93,0H135.77l-2.88,0c-5.6-.61-10.55-3.93-12-9.4l-30-108.95a13.62,13.62,0,0,1-.09-6.91A12.32,12.32,0,0,1,101.76,205.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M101.82,205.58c.3-.39,11.53-.62,12-.62H213c.5,0,11.67.22,12,.62a12.3,12.3,0,0,1,11,9.19,13.56,13.56,0,0,1,0,6.9l-28.66,109c-1.45,5.53-6.43,8.9-12.08,9.53l-2.93,0H135.78l-2.87,0c-5.61-.61-10.56-3.93-12.06-9.39l-30-109a13.4,13.4,0,0,1-.08-6.91A12.31,12.31,0,0,1,101.82,205.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M101.87,205.57c.29-.38,11.55-.6,12-.6H213c.48,0,11.68.22,12,.6a12.31,12.31,0,0,1,11,9.17,13.45,13.45,0,0,1,0,6.9l-28.66,109c-1.46,5.52-6.43,8.89-12.09,9.51-.1,0-2.82,0-2.93,0H135.79l-2.87,0c-5.61-.61-10.55-3.93-12.06-9.39l-30-109a13.44,13.44,0,0,1-.08-6.92A12.33,12.33,0,0,1,101.87,205.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M101.92,205.56c.27-.36,11.56-.57,12-.57h99c.45,0,11.69.2,12,.57a12.31,12.31,0,0,1,11.06,9.15,13.44,13.44,0,0,1,0,6.9l-28.68,109c-1.45,5.53-6.43,8.89-12.08,9.51l-2.93,0H135.8l-2.87,0c-5.6-.6-10.55-3.91-12.05-9.37l-30-109a13.36,13.36,0,0,1-.06-6.93A12.32,12.32,0,0,1,101.92,205.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M102,205.55c.26-.35,11.58-.55,12-.55h98.88c.44,0,11.7.2,12,.55a12.33,12.33,0,0,1,11.1,9.13,13.44,13.44,0,0,1,0,6.9l-28.68,109c-1.45,5.52-6.43,8.88-12.08,9.5l-2.93,0H135.82l-2.88,0c-5.6-.6-10.55-3.91-12-9.36l-30-109a13.47,13.47,0,0,1-.06-6.93A12.34,12.34,0,0,1,102,205.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M102,205.54c.25-.33,11.6-.52,12-.52h98.78c.42,0,11.71.19,12,.52a12.32,12.32,0,0,1,11.13,9.11,13.22,13.22,0,0,1,0,6.9L207.24,330.62c-1.45,5.52-6.42,8.88-12.07,9.49l-2.93,0H135.83l-2.88,0c-5.6-.59-10.54-3.9-12-9.35l-30-109.07a13.26,13.26,0,0,1,0-6.93A12.32,12.32,0,0,1,102,205.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-249",
    d: "M102.07,205.53c.24-.32,11.61-.5,12-.5h98.7c.39,0,11.71.18,11.95.5a12.34,12.34,0,0,1,11.17,9.09,13.33,13.33,0,0,1,0,6.9l-28.69,109.1c-1.45,5.52-6.43,8.87-12.08,9.48l-2.92,0H135.84l-2.87,0c-5.6-.59-10.55-3.89-12-9.34l-30-109.1a13.26,13.26,0,0,1-.05-6.93A12.34,12.34,0,0,1,102.07,205.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-250",
    d: "M102.12,205.52c.23-.3,11.63-.47,12-.47h98.6c.38,0,11.72.17,12,.47a12.32,12.32,0,0,1,11.2,9.07,13.12,13.12,0,0,1,0,6.9L207.22,330.62c-1.46,5.51-6.43,8.86-12.08,9.47l-2.92,0H135.85l-2.87,0c-5.6-.6-10.55-3.89-12-9.34l-30-109.12a13.15,13.15,0,0,1,0-6.93A12.33,12.33,0,0,1,102.12,205.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M102.17,205.51c.22-.29,11.65-.45,12-.45h98.5c.36,0,11.73.16,11.95.45a12.35,12.35,0,0,1,11.24,9.05,13.22,13.22,0,0,1,0,6.9L207.2,330.61c-1.45,5.52-6.42,8.86-12.07,9.46l-2.92,0H135.86l-2.87,0c-5.6-.59-10.54-3.87-12-9.32l-30-109.15a13.15,13.15,0,0,1,0-6.93A12.34,12.34,0,0,1,102.17,205.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-252",
    d: "M102.22,205.5c.21-.27,11.66-.43,12-.43h98.42c.33,0,11.74.16,11.94.43a12.33,12.33,0,0,1,11.27,9,13,13,0,0,1,.05,6.9L207.19,330.61c-1.45,5.51-6.43,8.85-12.07,9.45l-2.92,0H135.87l-2.87,0c-5.59-.59-10.54-3.87-12-9.31L91,221.57a13.15,13.15,0,0,1,0-6.93A12.36,12.36,0,0,1,102.22,205.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M102.27,205.49c.19-.25,11.68-.4,12-.4h98.32c.32,0,11.75.14,11.94.4a12.34,12.34,0,0,1,11.31,9,13.15,13.15,0,0,1,0,6.91l-28.72,109.2c-1.45,5.5-6.42,8.84-12.07,9.44l-2.92,0h-56.3l-2.86,0c-5.6-.59-10.55-3.87-12-9.31L91,221.54a13.14,13.14,0,0,1,0-6.93A12.34,12.34,0,0,1,102.27,205.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-254",
    d: "M102.32,205.48c.18-.24,11.7-.38,12-.38h98.22c.3,0,11.76.14,11.94.38a12.34,12.34,0,0,1,11.34,9,12.94,12.94,0,0,1,.06,6.91L207.16,330.6c-1.45,5.51-6.43,8.83-12.07,9.43l-2.92,0H135.89L133,340c-5.6-.58-10.54-3.85-12-9.29L91,221.51a13.07,13.07,0,0,1,0-6.94A12.36,12.36,0,0,1,102.32,205.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M102.37,205.47c.17-.22,11.71-.35,12-.35H212.5c.28,0,11.76.12,11.93.35a12.36,12.36,0,0,1,11.38,9,13.08,13.08,0,0,1,.07,6.92L207.14,330.6c-1.44,5.5-6.42,8.82-12.06,9.42l-2.92,0H135.9L133,340c-5.59-.58-10.54-3.85-12-9.29L91,221.49a12.91,12.91,0,0,1,0-7A12.35,12.35,0,0,1,102.37,205.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-256",
    d: "M102.42,205.46c.16-.21,11.73-.33,12-.33h98c.26,0,11.77.12,11.93.33a12.35,12.35,0,0,1,11.41,8.94,12.87,12.87,0,0,1,.08,6.92L207.13,330.59c-1.45,5.51-6.42,8.82-12.06,9.42h-62c-5.59-.58-10.53-3.84-12-9.28L91,221.46a12.91,12.91,0,0,1,0-7A12.37,12.37,0,0,1,102.42,205.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M102.47,205.45c.15-.19,11.75-.3,12-.3H212.4c.24,0,11.78.11,11.93.29a12.39,12.39,0,0,1,11.45,8.93,12.87,12.87,0,0,1,.08,6.92l-28.74,109.3c-1.45,5.5-6.43,8.81-12.07,9.4l-2.91,0H135.93l-2.86,0c-5.6-.57-10.54-3.83-12-9.26L91,221.43a12.9,12.9,0,0,1,0-7A12.37,12.37,0,0,1,102.47,205.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M102.52,205.44c.14-.18,11.77-.28,12-.28h97.85c.22,0,11.79.1,11.92.27a12.39,12.39,0,0,1,11.48,8.91,12.77,12.77,0,0,1,.09,6.92L207.1,330.59c-1.44,5.49-6.42,8.8-12.06,9.39h-62c-5.59-.57-10.54-3.83-12-9.26L91,221.4a12.9,12.9,0,0,1,0-7A12.37,12.37,0,0,1,102.52,205.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-258",
    d: "M102.57,205.43c.12-.16,11.78-.25,12-.25h97.76c.2,0,11.8.09,11.92.24a12.4,12.4,0,0,1,11.52,8.89,12.87,12.87,0,0,1,.1,6.92L207.09,330.58c-1.45,5.5-6.42,8.8-12.06,9.39H133.09c-5.59-.58-10.53-3.82-12-9.25L91,221.37a12.71,12.71,0,0,1,0-7A12.38,12.38,0,0,1,102.57,205.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-259",
    d: "M102.62,205.42c.11-.15,11.8-.23,12-.23h97.66c.18,0,11.81.08,11.92.22a12.41,12.41,0,0,1,11.55,8.87,12.67,12.67,0,0,1,.11,6.92L207.07,330.58c-1.44,5.49-6.42,8.79-12.06,9.37H133.1c-5.59-.57-10.53-3.81-12-9.23L91,221.34a12.71,12.71,0,0,1,0-7A12.39,12.39,0,0,1,102.62,205.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-260",
    d: "M102.67,205.41c.1-.13,11.82-.2,12-.2h97.57c.16,0,11.81.07,11.91.19a12.4,12.4,0,0,1,11.59,8.85,12.71,12.71,0,0,1,.11,6.93l-28.77,109.4c-1.45,5.49-6.42,8.78-12.06,9.36H133.11c-5.58-.57-10.53-3.81-12-9.23L91,221.31a12.61,12.61,0,0,1,0-6.95A12.37,12.37,0,0,1,102.67,205.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M102.72,205.4c.09-.11,11.83-.18,12-.18h97.48c.14,0,11.82.06,11.91.17a12.51,12.51,0,0,1,11.74,15.76L207,330.57c-1.44,5.49-6.41,8.78-12,9.36H133.13c-5.59-.57-10.53-3.8-12-9.22L91,221.28a12.64,12.64,0,0,1,0-7A12.4,12.4,0,0,1,102.72,205.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M102.78,205.39c.07-.1,11.84-.15,12-.15h97.38c.12,0,11.84,0,11.91.14a12.42,12.42,0,0,1,11.66,8.81,12.7,12.7,0,0,1,.13,6.93L207,330.57c-1.44,5.48-6.42,8.77-12.05,9.34H133.14c-5.59-.56-10.53-3.79-12-9.21L91,221.25a12.64,12.64,0,0,1,0-7A12.41,12.41,0,0,1,102.78,205.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-263",
    d: "M102.83,205.38c.06-.08,11.86-.13,12-.13h97.29c.1,0,11.84.05,11.9.12a12.5,12.5,0,0,1,11.83,15.72L207,330.56c-1.45,5.49-6.42,8.76-12.06,9.34H133.15c-5.58-.56-10.53-3.78-12-9.2L91,221.22a12.64,12.64,0,0,1,.07-7A12.41,12.41,0,0,1,102.83,205.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M102.88,205.37c0-.07,11.87-.1,12-.1H212c.08,0,11.85,0,11.9.09a12.47,12.47,0,0,1,11.87,15.7L207,330.56c-1.44,5.48-6.41,8.75-12.05,9.33H133.16c-5.58-.56-10.52-3.78-12-9.19L91,221.19a12.46,12.46,0,0,1,11.84-15.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-265",
    d: "M102.93,205.36c0-.05,11.89-.08,11.95-.08H212s11.85,0,11.89.07A12.47,12.47,0,0,1,235.79,221L207,330.56c-1.44,5.48-6.42,8.74-12.05,9.31H133.18c-5.59-.55-10.53-3.77-12-9.18L91.05,221.17a12.46,12.46,0,0,1,11.88-15.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-266",
    d: "M103,205.35s11.91,0,12,0h97s11.86,0,11.89,0a12.47,12.47,0,0,1,12,15.66L207,330.55c-1.44,5.48-6.41,8.74-12,9.31H133.19c-5.58-.55-10.53-3.76-12-9.17L91.06,221.14A12.44,12.44,0,0,1,103,205.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M103,205.33l11.94,0h96.92l11.89,0a12.46,12.46,0,0,1,12,15.64L207,330.55c-1.44,5.47-6.41,8.73-12.05,9.29,0,0-2.89,0-2.9,0h-56s-2.85,0-2.85,0c-5.58-.55-10.52-3.75-12-9.16L91.06,221.11a12.47,12.47,0,0,1,12-15.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.9,339.83H133.21a12.44,12.44,0,0,1-12-9.15L91.07,221.08a12.46,12.46,0,0,1,12-15.76H223.73a12.45,12.45,0,0,1,12,15.62L207,330.55A12.46,12.46,0,0,1,194.9,339.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M194.9,339.83H133.21a12.44,12.44,0,0,1-12-9.15L91.07,221.08a12.46,12.46,0,0,1,12-15.76H223.73a12.45,12.45,0,0,1,12,15.62L207,330.55A12.46,12.46,0,0,1,194.9,339.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M283.61,218.58a15,15,0,0,1-10.84,4.61,15,15,0,0,1-13.88-9.34,4,4,0,0,1,1.2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M296.3,231.76l-1.3,3.9-16.12,48.61c-1,3.07-3.54,5-6,4.49l-20.26-4a5,5,0,0,1-3.66-4.17,8.56,8.56,0,0,1-.13-2.39l4.85-55c.36-4,3.37-7.07,6.38-6.47l32.83,6.54C296,223.82,297.58,227.89,296.3,231.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M137.78,350.21l-9.41,6.42a4.12,4.12,0,0,1-5.71-1.09h0a4.12,4.12,0,0,1,1.08-5.7l9.42-6.41a4.11,4.11,0,0,1,5.71,1.08h0A4.11,4.11,0,0,1,137.78,350.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M199.94,363.07l-11.29,1.56a4.12,4.12,0,0,1-4.63-3.5h0a4.12,4.12,0,0,1,3.51-4.63l11.28-1.56a4.11,4.11,0,0,1,4.63,3.5h0A4.12,4.12,0,0,1,199.94,363.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-269",
    d: "M179.31,359.79H165.42l10.2-1.41A4.11,4.11,0,0,1,179.31,359.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M295,235.66l-16.12,48.61c-1,3.07-3.54,5-6,4.49l-20.26-4a5,5,0,0,1-3.66-4.17l30.39-46.18c1.84-2.79,4.87-4,7.16-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.34,243.09h0a8.71,8.71,0,0,1-6.5-10.44h0a8.69,8.69,0,0,1,10.44-6.5h0a8.69,8.69,0,0,1,6.5,10.44h0A8.7,8.7,0,0,1,297.34,243.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M293.25,234h0a7.12,7.12,0,0,1,8.55-5.32h0a7.13,7.13,0,0,1,3.1,1.6,7.11,7.11,0,1,0-10.55,9.39A7.11,7.11,0,0,1,293.25,234Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M287.68,235.3l18.53,9.14c2.25,1.11,3.09,4.23,2,7.32l-18.92,51.88c-1.38,3.78-5.08,5.95-7.84,4.59l-30-14.8c-2.79-1.38-3.3-5.72-1.06-9.12l30.41-46.22C282.53,235.39,285.46,234.21,287.68,235.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M286.8,202.46a4.17,4.17,0,0,1-7.49-1.35l-1.43-7a14.84,14.84,0,0,1,8.92,8.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M286.9,203.13a4,4,0,0,1-2.12,1.13,1.57,1.57,0,0,1-.3.05,3.87,3.87,0,0,1-.48,0,4.12,4.12,0,0,1-4-3.33l-1.28-6.6-.89-4.58a4.1,4.1,0,1,1,8.06-1.56l.32,1.63,1.86,9.55A4.13,4.13,0,0,1,286.9,203.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M286.9,203.13a15,15,0,0,1-1.44,13.07,11.4,11.4,0,0,1-.75,1.07,8.25,8.25,0,0,1-1.06-4.93l.83-8,.51-4.83.81-7.83a7.91,7.91,0,0,1,.38-1.75l1.86,9.55A4.13,4.13,0,0,1,286.9,203.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.4,208.9h0a4.22,4.22,0,0,1,2-5.64h0a4.24,4.24,0,0,1,5.64,2h0a4.23,4.23,0,0,1-2,5.63h0A4.23,4.23,0,0,1,281.4,208.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M283.61,204.59h0a3.45,3.45,0,0,1,4.61,1.63h0a3.34,3.34,0,0,1,.33,1.66,3.41,3.41,0,0,0-.19-2.48,3.46,3.46,0,0,0-6.57,1.32A3.42,3.42,0,0,1,283.61,204.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,183h0a4.23,4.23,0,0,1,3.47-4.87h0a4.22,4.22,0,0,1,4.87,3.47h0a4.22,4.22,0,0,1-3.47,4.86h0A4.22,4.22,0,0,1,292,183Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M295.35,179.49h0a3.46,3.46,0,0,1,4,2.84h0a3.43,3.43,0,0,1-.14,1.69,3.4,3.4,0,0,0,.5-2.43A3.46,3.46,0,0,0,293,181,3.46,3.46,0,0,1,295.35,179.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.14,158.86h0a4.24,4.24,0,0,1,3.47-4.87h0a4.23,4.23,0,0,1,4.87,3.47h0a4.23,4.23,0,0,1-3.47,4.87h0A4.24,4.24,0,0,1,294.14,158.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M297.46,155.32h0a3.47,3.47,0,0,1,4,2.84h0a3.42,3.42,0,0,1-.14,1.69,3.39,3.39,0,0,0,.5-2.43,3.45,3.45,0,0,0-6.68-.54A3.44,3.44,0,0,1,297.46,155.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M302,164.43l-1,11.34a4.12,4.12,0,0,1-4.45,3.74h0a4.12,4.12,0,0,1-3.73-4.45l1-11.35a4.12,4.12,0,0,1,4.45-3.73h0A4.11,4.11,0,0,1,302,164.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M301.71,140.41V151.8a4.12,4.12,0,0,1-4.1,4.11h0a4.12,4.12,0,0,1-4.11-4.11V140.41a4.11,4.11,0,0,1,4.11-4.1h0A4.11,4.11,0,0,1,301.71,140.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.24,182.49h0a4.22,4.22,0,0,1,3.94-4.49h0a4.22,4.22,0,0,1,4.49,3.94h0a4.23,4.23,0,0,1-3.94,4.5h0A4.23,4.23,0,0,1,304.24,182.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M307.89,179.31h0a3.47,3.47,0,0,1,3.68,3.23h0a3.42,3.42,0,0,1-.31,1.66,3.45,3.45,0,1,0-5.85-3.58A3.45,3.45,0,0,1,307.89,179.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M316.21,164.25a4.08,4.08,0,0,1-.07.77L314,176.2a4.12,4.12,0,0,1-4.8,3.27,4,4,0,0,1-1.87-.89,4.14,4.14,0,0,1-1.47-3.15,4.88,4.88,0,0,1,.07-.76l2.13-11.19a4.11,4.11,0,0,1,3.3-3.27,4,4,0,0,1,1.51,0A4.13,4.13,0,0,1,316.21,164.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.79,164.2h0a4.23,4.23,0,0,1,3.94-4.49h0a4.23,4.23,0,0,1,4.5,3.94h0a4.24,4.24,0,0,1-3.94,4.5h0A4.24,4.24,0,0,1,307.79,164.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M311.45,161h0a3.46,3.46,0,0,1,3.67,3.23h0a3.42,3.42,0,0,1-.3,1.66,3.42,3.42,0,0,0,.74-2.37,3.46,3.46,0,0,0-6.6-1.21A3.47,3.47,0,0,1,311.45,161Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M314.56,164.58a3.88,3.88,0,0,1-.32,1.55l-4.45,10.23a4.09,4.09,0,0,1-2.45,2.22,4,4,0,0,1-1.47-3.07,4.76,4.76,0,0,1,.07-.75l2.13-10.91a4.07,4.07,0,0,1,3.3-3.19,3.68,3.68,0,0,1,.69.22A4,4,0,0,1,314.56,164.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M313.61,165.54,309.16,176a4.12,4.12,0,0,1-5.38,2.18h0a4.12,4.12,0,0,1-2.18-5.38l4.45-10.49a4.12,4.12,0,0,1,5.38-2.18h0A4.12,4.12,0,0,1,313.61,165.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.58,184.63h0a4.23,4.23,0,0,1,4.24-4.22h0a4.23,4.23,0,0,1,4.21,4.24h0a4.23,4.23,0,0,1-4.24,4.22h0A4.23,4.23,0,0,1,315.58,184.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M319.44,181.7h0a3.47,3.47,0,0,1,3.45,3.47h0a3.51,3.51,0,0,1-.42,1.65,3.46,3.46,0,1,0-5.6-4A3.47,3.47,0,0,1,319.44,181.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M329.35,167.12a4.1,4.1,0,0,1-.13,1l-2.89,11a4.11,4.11,0,0,1-8.08-1,4.19,4.19,0,0,1,.13-1l2.89-11a4.12,4.12,0,0,1,4.64-3,2.87,2.87,0,0,1,.38.08A4.12,4.12,0,0,1,329.35,167.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.15,166.62h0a4.22,4.22,0,0,1,4.23-4.22h0a4.23,4.23,0,0,1,4.22,4.24h0a4.23,4.23,0,0,1-4.24,4.21h0A4.21,4.21,0,0,1,321.15,166.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M325,163.69h0a3.47,3.47,0,0,1,3.45,3.47h0a3.63,3.63,0,0,1-.42,1.64,3.46,3.46,0,1,0-5.6-4A3.49,3.49,0,0,1,325,163.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M328,167.19a3.76,3.76,0,0,1-.33,1.53l-4.44,10.08a4.11,4.11,0,0,1-3.55,2.39,3.87,3.87,0,0,1-1.38-2.94,3.76,3.76,0,0,1,.13-1l2.89-10.59a4.13,4.13,0,0,1,4.64-2.89A3.93,3.93,0,0,1,328,167.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M326.89,167.87l-4.44,10.48a4.13,4.13,0,0,1-5.39,2.18h0a4.12,4.12,0,0,1-2.18-5.38l4.45-10.49a4.12,4.12,0,0,1,5.38-2.18h0A4.13,4.13,0,0,1,326.89,167.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M286,217.48l5.77,9.75c4,6.75,15.23,7.82,20.39,2l7.27-8.29a8.31,8.31,0,0,0,2.07-4.63l2.16-20.8c.56-5.31-4.29-10.16-10.82-10.84l-13.05-1.35c-6.53-.68-12.27,3.07-12.82,8.38l-2.15,20.69A8.26,8.26,0,0,0,286,217.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 242.18,
    y: 262.21,
    width: 59.64,
    height: 5.18,
    rx: 2.37,
    transform: "translate(-97.71 350.91) rotate(-57.34)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 290.33,
    y: 245.4,
    width: 5.18,
    height: 62,
    rx: 2.01,
    transform: "translate(118.31 -86.52) rotate(20.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 289.23,
    y: 188.09,
    width: 5.18,
    height: 26.96,
    rx: 2.01,
    transform: "translate(23.01 -29.8) rotate(6.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 315.66,
    y: 191.84,
    width: 5.18,
    height: 26.96,
    rx: 2.01,
    transform: "translate(23.57 -32.59) rotate(6.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 234.86,
    y: 239.34,
    width: 44.04,
    height: 5.18,
    rx: 2.05,
    transform: "translate(-10.93 471.71) rotate(-83.91)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 279.66,
    y: 187.68,
    width: 1.87,
    height: 14.91,
    rx: 0.72,
    transform: "translate(592.99 333.77) rotate(169.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 294.19,
    y: 161.87,
    width: 1.87,
    height: 14.91,
    rx: 0.72,
    transform: "translate(574.4 363.68) rotate(-175.01)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 304.94,
    y: 160.99,
    width: 1.87,
    height: 14.91,
    rx: 0.72,
    transform: "translate(521.71 442.94) rotate(-157.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 317.99,
    y: 163.22,
    width: 1.87,
    height: 14.91,
    rx: 0.72,
    transform: "translate(545.93 452.3) rotate(-157.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 294.49,
    y: 139.22,
    width: 1.87,
    height: 14.42,
    rx: 0.72,
    transform: "translate(590.84 292.86) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 159.56,
    y: 105.46,
    width: 5.18,
    height: 168.88,
    rx: 2.01,
    transform: "translate(-27.75 352.05) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 159.02,
    y: 119.97,
    width: 5.18,
    height: 156.66,
    rx: 2.01,
    transform: "translate(-36.69 359.9) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M228,218.19h0a16.41,16.41,0,0,1-16.36,16.37h-96a16.42,16.42,0,0,1-16.36-16.37h0a4.49,4.49,0,0,1,4.47-4.47H223.5A4.49,4.49,0,0,1,228,218.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M371.48,24.18H291.43a2.73,2.73,0,0,0-2.73,2.72V59.21c0,2.93,2.4,5.51,4,8l4.05,9.07a1.37,1.37,0,0,0,2.32,0l5.16-8.73a5,5,0,0,1,4.25-2.42h63a2.73,2.73,0,0,0,2.72-2.73V26.9A2.72,2.72,0,0,0,371.48,24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.81,45.05a3.56,3.56,0,1,1-3.55-3.56A3.55,3.55,0,0,1,318.81,45.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.51,45.05A3.56,3.56,0,1,1,334,41.49,3.55,3.55,0,0,1,337.51,45.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.21,45.05a3.56,3.56,0,1,1-3.56-3.56A3.55,3.55,0,0,1,356.21,45.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M141.88,386.82H382.5a4.53,4.53,0,0,1,4.53,4.53v1.31a0,0,0,0,1,0,0H137.35a0,0,0,0,1,0,0v-1.31A4.53,4.53,0,0,1,141.88,386.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M370.51,398.56H153.87c-3.51,0-16.52-2.64-16.52-5.9H387C387,395.92,374,398.56,370.51,398.56Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 145.66,
    y: 256.97,
    width: 232.99,
    height: 135.81,
    rx: 35.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 145.8,
    y: 257.05,
    width: 232.71,
    height: 135.73,
    rx: 34.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 145.94,
    y: 257.13,
    width: 232.43,
    height: 135.65,
    rx: 34.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 146.08,
    y: 257.21,
    width: 232.15,
    height: 135.56,
    rx: 34.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-278",
    x: 146.22,
    y: 257.29,
    width: 231.87,
    height: 135.48,
    rx: 34.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-279",
    x: 146.35,
    y: 257.37,
    width: 231.6,
    height: 135.4,
    rx: 34.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 146.49,
    y: 257.46,
    width: 231.32,
    height: 135.32,
    rx: 34.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 146.63,
    y: 257.54,
    width: 231.04,
    height: 135.24,
    rx: 34.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 146.77,
    y: 257.62,
    width: 230.76,
    height: 135.15,
    rx: 34.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 146.91,
    y: 257.7,
    width: 230.48,
    height: 135.07,
    rx: 34.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-284",
    x: 147.05,
    y: 257.78,
    width: 230.21,
    height: 134.99,
    rx: 34.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-285",
    x: 147.19,
    y: 257.86,
    width: 229.93,
    height: 134.91,
    rx: 34.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-286",
    x: 147.33,
    y: 257.94,
    width: 229.65,
    height: 134.82,
    rx: 34.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-287",
    x: 147.47,
    y: 258.02,
    width: 229.37,
    height: 134.74,
    rx: 34.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-288",
    x: 147.61,
    y: 258.1,
    width: 229.09,
    height: 134.66,
    rx: 34.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-289",
    x: 147.75,
    y: 258.18,
    width: 228.81,
    height: 134.58,
    rx: 34.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-290",
    x: 147.88,
    y: 258.27,
    width: 228.54,
    height: 134.5,
    rx: 34.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-291",
    x: 148.02,
    y: 258.35,
    width: 228.26,
    height: 134.41,
    rx: 34.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-292",
    x: 148.16,
    y: 258.43,
    width: 227.98,
    height: 134.33,
    rx: 34.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-293",
    x: 148.3,
    y: 258.51,
    width: 227.7,
    height: 134.25,
    rx: 34.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-294",
    x: 148.44,
    y: 258.59,
    width: 227.42,
    height: 134.17,
    rx: 34.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-295",
    x: 148.58,
    y: 258.67,
    width: 227.15,
    height: 134.08,
    rx: 34.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-296",
    x: 148.72,
    y: 258.75,
    width: 226.87,
    height: 134,
    rx: 34.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-297",
    x: 148.86,
    y: 258.83,
    width: 226.59,
    height: 133.92,
    rx: 34.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-298",
    x: 149,
    y: 258.91,
    width: 226.31,
    height: 133.84,
    rx: 34.26
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-299",
    x: 149.14,
    y: 259,
    width: 226.03,
    height: 133.75,
    rx: 34.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-300",
    x: 149.28,
    y: 259.08,
    width: 225.75,
    height: 133.67,
    rx: 34.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-301",
    x: 149.41,
    y: 259.16,
    width: 225.48,
    height: 133.59,
    rx: 34.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-302",
    x: 149.55,
    y: 259.24,
    width: 225.2,
    height: 133.51,
    rx: 34.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-303",
    x: 149.69,
    y: 259.32,
    width: 224.92,
    height: 133.43,
    rx: 34.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-304",
    x: 149.83,
    y: 259.4,
    width: 224.64,
    height: 133.34,
    rx: 34.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-305",
    x: 149.97,
    y: 259.48,
    width: 224.36,
    height: 133.26,
    rx: 34.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-306",
    x: 150.11,
    y: 259.56,
    width: 224.09,
    height: 133.18,
    rx: 34.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-307",
    x: 150.25,
    y: 259.64,
    width: 223.81,
    height: 133.1,
    rx: 33.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M184.33,259.73H340a33.95,33.95,0,0,1,33.95,33.95v65.12A33.94,33.94,0,0,1,340,392.74H184.33a33.95,33.95,0,0,1-33.95-33.95V293.67A33.94,33.94,0,0,1,184.33,259.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-309",
    x: 150.53,
    y: 259.81,
    width: 223.25,
    height: 132.93,
    rx: 33.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-310",
    x: 150.67,
    y: 259.89,
    width: 222.97,
    height: 132.85,
    rx: 33.88
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-311",
    x: 150.81,
    y: 259.97,
    width: 222.7,
    height: 132.77,
    rx: 33.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-312",
    x: 150.94,
    y: 260.05,
    width: 222.42,
    height: 132.69,
    rx: 33.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-313",
    x: 151.08,
    y: 260.13,
    width: 222.14,
    height: 132.6,
    rx: 33.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-314",
    x: 151.22,
    y: 260.21,
    width: 221.86,
    height: 132.52,
    rx: 33.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-315",
    x: 151.36,
    y: 260.29,
    width: 221.58,
    height: 132.44,
    rx: 33.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-316",
    x: 151.5,
    y: 260.37,
    width: 221.3,
    height: 132.36,
    rx: 33.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-317",
    x: 151.64,
    y: 260.45,
    width: 221.03,
    height: 132.27,
    rx: 33.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-318",
    x: 151.78,
    y: 260.54,
    width: 220.75,
    height: 132.19,
    rx: 33.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-319",
    x: 151.92,
    y: 260.62,
    width: 220.47,
    height: 132.11,
    rx: 33.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-320",
    x: 152.06,
    y: 260.7,
    width: 220.19,
    height: 132.03,
    rx: 33.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-321",
    x: 152.2,
    y: 260.78,
    width: 219.91,
    height: 131.95,
    rx: 33.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-322",
    x: 152.34,
    y: 260.86,
    width: 219.64,
    height: 131.86,
    rx: 33.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-323",
    x: 152.47,
    y: 260.94,
    width: 219.36,
    height: 131.78,
    rx: 33.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-324",
    x: 152.61,
    y: 261.02,
    width: 219.08,
    height: 131.7,
    rx: 33.44
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-324",
    x: 152.75,
    y: 261.1,
    width: 218.8,
    height: 131.62,
    rx: 33.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-325",
    x: 152.89,
    y: 261.18,
    width: 218.52,
    height: 131.53,
    rx: 33.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-326",
    x: 153.03,
    y: 261.27,
    width: 218.24,
    height: 131.45,
    rx: 33.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-327",
    x: 153.17,
    y: 261.35,
    width: 217.97,
    height: 131.37,
    rx: 33.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-328",
    x: 153.31,
    y: 261.43,
    width: 217.69,
    height: 131.29,
    rx: 33.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-329",
    x: 153.45,
    y: 261.51,
    width: 217.41,
    height: 131.2,
    rx: 33.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-330",
    x: 153.59,
    y: 261.59,
    width: 217.13,
    height: 131.12,
    rx: 33.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-331",
    x: 153.73,
    y: 261.67,
    width: 216.85,
    height: 131.04,
    rx: 33.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-332",
    x: 153.87,
    y: 261.75,
    width: 216.58,
    height: 130.96,
    rx: 33.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-333",
    x: 154,
    y: 261.83,
    width: 216.3,
    height: 130.88,
    rx: 33.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-334",
    x: 154.14,
    y: 261.91,
    width: 216.02,
    height: 130.79,
    rx: 33.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-335",
    x: 154.28,
    y: 262,
    width: 215.74,
    height: 130.71,
    rx: 33.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-336",
    x: 154.42,
    y: 262.08,
    width: 215.46,
    height: 130.63,
    rx: 33.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-337",
    x: 154.56,
    y: 262.16,
    width: 215.18,
    height: 130.55,
    rx: 32.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-338",
    x: 154.7,
    y: 262.24,
    width: 214.91,
    height: 130.46,
    rx: 32.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-339",
    x: 154.84,
    y: 262.32,
    width: 214.63,
    height: 130.38,
    rx: 32.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-340",
    x: 154.98,
    y: 262.4,
    width: 214.35,
    height: 130.3,
    rx: 32.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-341",
    x: 155.12,
    y: 262.48,
    width: 214.07,
    height: 130.22,
    rx: 32.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-342",
    x: 155.26,
    y: 262.56,
    width: 213.79,
    height: 130.14,
    rx: 32.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-343",
    x: 155.4,
    y: 262.64,
    width: 213.52,
    height: 130.05,
    rx: 32.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-344",
    x: 155.53,
    y: 262.72,
    width: 213.24,
    height: 129.97,
    rx: 32.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-345",
    x: 155.67,
    y: 262.81,
    width: 212.96,
    height: 129.89,
    rx: 32.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-346",
    x: 155.81,
    y: 262.89,
    width: 212.68,
    height: 129.81,
    rx: 32.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-347",
    x: 155.95,
    y: 262.97,
    width: 212.4,
    height: 129.72,
    rx: 32.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-348",
    x: 156.09,
    y: 263.05,
    width: 212.12,
    height: 129.64,
    rx: 32.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-349",
    x: 156.23,
    y: 263.13,
    width: 211.85,
    height: 129.56,
    rx: 32.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-350",
    x: 156.37,
    y: 263.21,
    width: 211.57,
    height: 129.48,
    rx: 32.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-351",
    x: 156.51,
    y: 263.29,
    width: 211.29,
    height: 129.39,
    rx: 32.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-352",
    x: 156.65,
    y: 263.37,
    width: 211.01,
    height: 129.31,
    rx: 32.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-353",
    x: 156.79,
    y: 263.45,
    width: 210.73,
    height: 129.23,
    rx: 32.49
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-354",
    x: 156.93,
    y: 263.54,
    width: 210.46,
    height: 129.15,
    rx: 32.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-355",
    x: 157.06,
    y: 263.62,
    width: 210.18,
    height: 129.07,
    rx: 32.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-356",
    x: 157.2,
    y: 263.7,
    width: 209.9,
    height: 128.98,
    rx: 32.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-357",
    x: 157.34,
    y: 263.78,
    width: 209.62,
    height: 128.9,
    rx: 32.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-358",
    x: 157.48,
    y: 263.86,
    width: 209.34,
    height: 128.82,
    rx: 32.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-359",
    x: 157.62,
    y: 263.94,
    width: 209.07,
    height: 128.74,
    rx: 32.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-360",
    x: 157.76,
    y: 264.02,
    width: 208.79,
    height: 128.65,
    rx: 32.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-361",
    x: 157.9,
    y: 264.1,
    width: 208.51,
    height: 128.57,
    rx: 32.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-362",
    x: 158.04,
    y: 264.18,
    width: 208.23,
    height: 128.49,
    rx: 32.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-363",
    x: 158.18,
    y: 264.27,
    width: 207.95,
    height: 128.41,
    rx: 32.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-364",
    x: 158.32,
    y: 264.35,
    width: 207.67,
    height: 128.33,
    rx: 32.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-365",
    x: 158.45,
    y: 264.43,
    width: 207.4,
    height: 128.24,
    rx: 32.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-366",
    x: 158.59,
    y: 264.51,
    width: 207.12,
    height: 128.16,
    rx: 32.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-367",
    x: 158.73,
    y: 264.59,
    width: 206.84,
    height: 128.08,
    rx: 32.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-368",
    x: 158.87,
    y: 264.67,
    width: 206.56,
    height: 128,
    rx: 32.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-369",
    x: 159.01,
    y: 264.75,
    width: 206.28,
    height: 127.91,
    rx: 31.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-370",
    x: 159.15,
    y: 264.83,
    width: 206.01,
    height: 127.83,
    rx: 31.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-371",
    x: 159.29,
    y: 264.91,
    width: 205.73,
    height: 127.75,
    rx: 31.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-372",
    x: 159.43,
    y: 264.99,
    width: 205.45,
    height: 127.67,
    rx: 31.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-373",
    x: 159.57,
    y: 265.08,
    width: 205.17,
    height: 127.58,
    rx: 31.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-374",
    x: 159.71,
    y: 265.16,
    width: 204.89,
    height: 127.5,
    rx: 31.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 159.85,
    y: 265.24,
    width: 204.61,
    height: 127.42,
    rx: 31.79
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 262.19,
    cy: 328.32,
    r: 20.72,
    transform: "matrix(0.23, -0.97, 0.97, 0.23, -116.97, 509.36)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 262.19,
    cy: 328.32,
    r: 20.7,
    transform: "translate(-116.96 509.36) rotate(-76.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 262.19,
    cy: 328.32,
    r: 20.68,
    transform: "translate(-116.96 509.36) rotate(-76.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 262.19,
    cy: 328.32,
    r: 20.66,
    transform: "translate(-116.96 509.37) rotate(-76.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-39",
    cx: 262.19,
    cy: 328.32,
    r: 20.64,
    transform: "translate(-116.96 509.37) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 262.19,
    cy: 328.32,
    r: 20.62,
    transform: "translate(-116.96 509.38) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 262.19,
    cy: 328.32,
    r: 20.61,
    transform: "translate(-116.96 509.38) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-42",
    cx: 262.19,
    cy: 328.32,
    r: 20.59,
    transform: "translate(-116.95 509.38) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-43",
    cx: 262.19,
    cy: 328.32,
    r: 20.57,
    transform: "translate(-116.95 509.39) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 262.19,
    cy: 328.32,
    r: 20.55,
    transform: "translate(-116.95 509.39) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-45",
    cx: 262.19,
    cy: 328.32,
    r: 20.53,
    transform: "translate(-116.95 509.4) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 262.19,
    cy: 328.32,
    r: 20.51,
    transform: "translate(-116.95 509.4) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 262.19,
    cy: 328.32,
    r: 20.49,
    transform: "translate(-116.94 509.4) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-47",
    cx: 262.19,
    cy: 328.32,
    r: 20.47,
    transform: "translate(-116.94 509.41) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-48",
    cx: 262.19,
    cy: 328.32,
    r: 20.45,
    transform: "translate(-116.94 509.41) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-49",
    cx: 262.19,
    cy: 328.32,
    r: 20.43,
    transform: "translate(-116.94 509.42) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-50",
    cx: 262.19,
    cy: 328.32,
    r: 20.41,
    transform: "matrix(0.23, -0.97, 0.97, 0.23, -116.94, 509.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-51",
    cx: 262.19,
    cy: 328.32,
    r: 20.39,
    transform: "translate(-116.93 509.43) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-52",
    cx: 262.19,
    cy: 328.32,
    r: 20.37,
    transform: "translate(-116.93 509.43) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-53",
    cx: 262.19,
    cy: 328.32,
    r: 20.35,
    transform: "translate(-116.93 509.43) rotate(-76.92)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-54",
    cx: 262.19,
    cy: 328.32,
    r: 20.33,
    transform: "translate(-116.93 509.44) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-55",
    cx: 262.19,
    cy: 328.32,
    r: 20.31,
    transform: "translate(-116.93 509.44) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-56",
    cx: 262.19,
    cy: 328.32,
    r: 20.29,
    transform: "translate(-116.92 509.45) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-57",
    cx: 262.19,
    cy: 328.32,
    r: 20.27,
    transform: "translate(-116.92 509.45) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 262.19,
    cy: 328.32,
    r: 20.25,
    transform: "translate(-116.92 509.46) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-58",
    cx: 262.19,
    cy: 328.32,
    r: 20.23,
    transform: "translate(-116.92 509.46) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-59",
    cx: 262.19,
    cy: 328.32,
    r: 20.21,
    transform: "translate(-116.91 509.47) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-60",
    cx: 262.19,
    cy: 328.32,
    r: 20.19,
    transform: "translate(-116.91 509.47) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-61",
    cx: 262.19,
    cy: 328.32,
    r: 20.17,
    transform: "translate(-116.91 509.48) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-62",
    cx: 262.19,
    cy: 328.32,
    r: 20.15,
    transform: "translate(-116.91 509.48) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-63",
    cx: 262.19,
    cy: 328.32,
    r: 20.13,
    transform: "translate(-116.91 509.49) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-64",
    cx: 262.19,
    cy: 328.32,
    r: 20.11,
    transform: "translate(-116.9 509.49) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 262.19,
    cy: 328.32,
    r: 20.09,
    transform: "translate(-116.9 509.49) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-66",
    cx: 262.19,
    cy: 328.32,
    r: 20.07,
    transform: "translate(-116.9 509.5) rotate(-76.93)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-67",
    cx: 262.19,
    cy: 328.32,
    r: 20.05,
    transform: "translate(-116.9 509.5) rotate(-76.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-68",
    cx: 262.19,
    cy: 328.32,
    r: 20.03,
    transform: "translate(-116.89 509.51) rotate(-76.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 262.19,
    cy: 328.32,
    r: 20.01,
    transform: "translate(-116.89 509.51) rotate(-76.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-69",
    cx: 262.19,
    cy: 328.32,
    r: 19.99,
    transform: "translate(-116.89 509.52) rotate(-76.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-70",
    cx: 262.19,
    cy: 328.32,
    r: 19.97,
    transform: "translate(-116.89 509.53) rotate(-76.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-71",
    cx: 262.19,
    cy: 328.32,
    r: 19.95,
    transform: "translate(-116.88 509.53) rotate(-76.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-72",
    cx: 262.19,
    cy: 328.32,
    r: 19.93,
    transform: "translate(-116.88 509.54) rotate(-76.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 262.19,
    cy: 328.32,
    r: 19.91,
    transform: "translate(-116.88 509.54) rotate(-76.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-74",
    cx: 262.19,
    cy: 328.32,
    r: 19.89,
    transform: "translate(-116.88 509.55) rotate(-76.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-75",
    cx: 262.19,
    cy: 328.32,
    r: 19.87,
    transform: "translate(-116.87 509.55) rotate(-76.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-76",
    cx: 262.19,
    cy: 328.32,
    r: 19.85,
    transform: "translate(-116.87 509.56) rotate(-76.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-77",
    cx: 262.19,
    cy: 328.32,
    r: 19.83,
    transform: "translate(-116.87 509.56) rotate(-76.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-78",
    cx: 262.19,
    cy: 328.32,
    r: 19.82,
    transform: "translate(-116.87 509.57) rotate(-76.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-79",
    cx: 262.19,
    cy: 328.32,
    r: 19.8,
    transform: "translate(-116.86 509.57) rotate(-76.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-80",
    cx: 262.19,
    cy: 328.32,
    r: 19.78,
    transform: "translate(-116.86 509.58) rotate(-76.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 262.19,
    cy: 328.32,
    r: 19.76,
    transform: "translate(-116.86 509.59) rotate(-76.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-81",
    cx: 262.19,
    cy: 328.32,
    r: 19.74,
    transform: "translate(-116.85 509.59) rotate(-76.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-82",
    cx: 262.19,
    cy: 328.32,
    r: 19.72,
    transform: "translate(-116.85 509.6) rotate(-76.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 262.19,
    cy: 328.32,
    r: 19.7,
    transform: "translate(-116.85 509.6) rotate(-76.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-84",
    cx: 262.19,
    cy: 328.32,
    r: 19.68,
    transform: "translate(-116.85 509.61) rotate(-76.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-85",
    cx: 262.19,
    cy: 328.32,
    r: 19.66,
    transform: "translate(-116.84 509.62) rotate(-76.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-86",
    cx: 262.19,
    cy: 328.32,
    r: 19.64,
    transform: "translate(-116.84 509.62) rotate(-76.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 262.19,
    cy: 328.32,
    r: 19.62,
    transform: "translate(-116.84 509.63) rotate(-76.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-88",
    cx: 262.19,
    cy: 328.32,
    r: 19.6,
    transform: "translate(-116.83 509.63) rotate(-76.95)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-89",
    cx: 262.19,
    cy: 328.32,
    r: 19.58,
    transform: "translate(-116.83 509.64) rotate(-76.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-90",
    cx: 262.19,
    cy: 328.32,
    r: 19.56,
    transform: "translate(-116.83 509.65) rotate(-76.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-91",
    cx: 262.19,
    cy: 328.32,
    r: 19.54,
    transform: "translate(-116.82 509.65) rotate(-76.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 262.19,
    cy: 328.32,
    r: 19.52,
    transform: "translate(-116.82 509.66) rotate(-76.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-92",
    cx: 262.19,
    cy: 328.32,
    r: 19.5,
    transform: "matrix(0.23, -0.97, 0.97, 0.23, -116.82, 509.67)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-93",
    cx: 262.19,
    cy: 328.32,
    r: 19.48,
    transform: "translate(-116.82 509.67) rotate(-76.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 262.19,
    cy: 328.32,
    r: 19.46,
    transform: "translate(-116.81 509.68) rotate(-76.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-94",
    cx: 262.19,
    cy: 328.32,
    r: 19.44,
    transform: "translate(-116.81 509.69) rotate(-76.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-95",
    cx: 262.19,
    cy: 328.32,
    r: 19.42,
    transform: "translate(-116.81 509.69) rotate(-76.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-96",
    cx: 262.19,
    cy: 328.32,
    r: 19.4,
    transform: "translate(-116.8 509.7) rotate(-76.96)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-97",
    cx: 262.19,
    cy: 328.32,
    r: 19.38,
    transform: "translate(-116.8 509.71) rotate(-76.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-98",
    cx: 262.19,
    cy: 328.32,
    r: 19.36,
    transform: "translate(-116.8 509.71) rotate(-76.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-99",
    cx: 262.19,
    cy: 328.32,
    r: 19.34,
    transform: "translate(-116.79 509.72) rotate(-76.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-100",
    cx: 262.19,
    cy: 328.32,
    r: 19.32,
    transform: "translate(-116.79 509.73) rotate(-76.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-101",
    cx: 262.19,
    cy: 328.32,
    r: 19.3,
    transform: "translate(-116.79 509.73) rotate(-76.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 262.19,
    cy: 328.32,
    r: 19.28,
    transform: "translate(-116.78 509.74) rotate(-76.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-102",
    cx: 262.19,
    cy: 328.32,
    r: 19.26,
    transform: "translate(-116.78 509.75) rotate(-76.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-103",
    cx: 262.19,
    cy: 328.32,
    r: 19.24,
    transform: "translate(-116.78 509.76) rotate(-76.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-104",
    cx: 262.19,
    cy: 328.32,
    r: 19.22,
    transform: "translate(-116.77 509.76) rotate(-76.97)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-105",
    cx: 262.19,
    cy: 328.32,
    r: 19.2,
    transform: "translate(-116.77 509.77) rotate(-76.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-106",
    cx: 262.19,
    cy: 328.32,
    r: 19.18,
    transform: "translate(-116.76 509.78) rotate(-76.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-107",
    cx: 262.19,
    cy: 328.32,
    r: 19.16,
    transform: "translate(-116.76 509.79) rotate(-76.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-108",
    cx: 262.19,
    cy: 328.32,
    r: 19.14,
    transform: "translate(-116.76 509.8) rotate(-76.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-109",
    cx: 262.19,
    cy: 328.32,
    r: 19.12,
    transform: "translate(-116.75 509.8) rotate(-76.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-110",
    cx: 262.19,
    cy: 328.32,
    r: 19.1,
    transform: "translate(-116.75 509.81) rotate(-76.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-111",
    cx: 262.19,
    cy: 328.32,
    r: 19.08,
    transform: "translate(-116.74 509.82) rotate(-76.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-112",
    cx: 262.19,
    cy: 328.32,
    r: 19.06,
    transform: "translate(-116.74 509.83) rotate(-76.98)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 262.19,
    cy: 328.32,
    r: 19.04,
    transform: "translate(-116.74 509.84) rotate(-76.99)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-113",
    cx: 262.19,
    cy: 328.32,
    r: 19.02,
    transform: "translate(-116.73 509.84) rotate(-76.99)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-114",
    cx: 262.19,
    cy: 328.32,
    r: 19.01,
    transform: "translate(-116.73 509.85) rotate(-76.99)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-115",
    cx: 262.19,
    cy: 328.32,
    r: 18.99,
    transform: "translate(-116.72 509.86) rotate(-76.99)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-116",
    cx: 262.19,
    cy: 328.32,
    r: 18.97,
    transform: "translate(-116.72 509.87) rotate(-76.99)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-117",
    cx: 262.19,
    cy: 328.32,
    r: 18.95,
    transform: "translate(-116.72 509.88) rotate(-76.99)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-118",
    cx: 262.19,
    cy: 328.32,
    r: 18.93,
    transform: "translate(-116.71 509.89) rotate(-76.99)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-119",
    cx: 262.19,
    cy: 328.32,
    r: 18.91,
    transform: "translate(-116.71 509.9) rotate(-76.99)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-120",
    cx: 262.19,
    cy: 328.32,
    r: 18.89,
    transform: "translate(-116.7 509.91) rotate(-77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-121",
    cx: 262.19,
    cy: 328.32,
    r: 18.87,
    transform: "translate(-116.7 509.92) rotate(-77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 262.19,
    cy: 328.32,
    r: 18.85,
    transform: "translate(-116.69 509.93) rotate(-77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-123",
    cx: 262.19,
    cy: 328.32,
    r: 18.83,
    transform: "translate(-116.69 509.94) rotate(-77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 262.19,
    cy: 328.32,
    r: 18.81,
    transform: "translate(-116.68 509.94) rotate(-77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-124",
    cx: 262.19,
    cy: 328.32,
    r: 18.79,
    transform: "translate(-116.68 509.95) rotate(-77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-125",
    cx: 262.19,
    cy: 328.32,
    r: 18.77,
    transform: "translate(-116.68 509.96) rotate(-77)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-126",
    cx: 262.19,
    cy: 328.32,
    r: 18.75,
    transform: "translate(-116.67 509.97) rotate(-77.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-127",
    cx: 262.19,
    cy: 328.32,
    r: 18.73,
    transform: "translate(-116.67 509.98) rotate(-77.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128",
    cx: 262.19,
    cy: 328.32,
    r: 18.71,
    transform: "translate(-116.66 510) rotate(-77.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-129",
    cx: 262.19,
    cy: 328.32,
    r: 18.69,
    transform: "translate(-116.66 510.01) rotate(-77.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-130",
    cx: 262.19,
    cy: 328.32,
    r: 18.67,
    transform: "translate(-116.65 510.02) rotate(-77.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-131",
    cx: 262.19,
    cy: 328.32,
    r: 18.65,
    transform: "translate(-116.65 510.03) rotate(-77.01)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-132",
    cx: 262.19,
    cy: 328.32,
    r: 18.63,
    transform: "translate(-116.64 510.04) rotate(-77.02)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-133",
    cx: 262.19,
    cy: 328.32,
    r: 18.61,
    transform: "translate(-116.64 510.05) rotate(-77.02)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-134",
    cx: 262.19,
    cy: 328.32,
    r: 18.59,
    transform: "translate(-116.63 510.06) rotate(-77.02)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 262.19,
    cy: 328.32,
    r: 18.57,
    transform: "translate(-116.62 510.07) rotate(-77.02)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-135",
    cx: 262.19,
    cy: 328.32,
    r: 18.55,
    transform: "translate(-116.62 510.08) rotate(-77.02)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-136",
    cx: 262.19,
    cy: 328.32,
    r: 18.53,
    transform: "translate(-116.61 510.09) rotate(-77.02)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-137",
    cx: 262.19,
    cy: 328.32,
    r: 18.51,
    transform: "translate(-116.61 510.11) rotate(-77.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-138",
    cx: 262.19,
    cy: 328.32,
    r: 18.49,
    transform: "translate(-116.6 510.12) rotate(-77.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-139",
    cx: 262.19,
    cy: 328.32,
    r: 18.47,
    transform: "translate(-116.6 510.13) rotate(-77.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-140",
    cx: 262.19,
    cy: 328.32,
    r: 18.45,
    transform: "translate(-116.59 510.14) rotate(-77.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-141",
    cx: 262.19,
    cy: 328.32,
    r: 18.43,
    transform: "translate(-116.58 510.15) rotate(-77.03)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-142",
    cx: 262.19,
    cy: 328.32,
    r: 18.41,
    transform: "translate(-116.58 510.17) rotate(-77.04)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-143",
    cx: 262.19,
    cy: 328.32,
    r: 18.39,
    transform: "matrix(0.22, -0.97, 0.97, 0.22, -116.57, 510.18)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-144",
    cx: 262.19,
    cy: 328.32,
    r: 18.37,
    transform: "translate(-116.57 510.19) rotate(-77.04)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-145",
    cx: 262.19,
    cy: 328.32,
    r: 18.35,
    transform: "translate(-116.56 510.21) rotate(-77.04)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 262.19,
    cy: 328.32,
    r: 18.33,
    transform: "translate(-116.55 510.22) rotate(-77.04)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-146",
    cx: 262.19,
    cy: 328.32,
    r: 18.31,
    transform: "translate(-116.55 510.23) rotate(-77.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-147",
    cx: 262.19,
    cy: 328.32,
    r: 18.29,
    transform: "translate(-116.54 510.25) rotate(-77.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-148",
    cx: 262.19,
    cy: 328.32,
    r: 18.27,
    transform: "translate(-116.53 510.26) rotate(-77.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-149",
    cx: 262.19,
    cy: 328.32,
    r: 18.25,
    transform: "translate(-116.53 510.27) rotate(-77.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-150",
    cx: 262.19,
    cy: 328.32,
    r: 18.23,
    transform: "translate(-116.52 510.29) rotate(-77.05)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-151",
    cx: 262.19,
    cy: 328.32,
    r: 18.22,
    transform: "translate(-116.51 510.3) rotate(-77.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-152",
    cx: 262.19,
    cy: 328.32,
    r: 18.2,
    transform: "translate(-116.51 510.32) rotate(-77.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-153",
    cx: 262.19,
    cy: 328.32,
    r: 18.18,
    transform: "translate(-116.5 510.33) rotate(-77.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-154",
    cx: 262.19,
    cy: 328.32,
    r: 18.16,
    transform: "translate(-116.49 510.35) rotate(-77.06)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-155",
    cx: 262.19,
    cy: 328.32,
    r: 18.14,
    transform: "translate(-116.48 510.36) rotate(-77.07)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-156",
    cx: 262.19,
    cy: 328.32,
    r: 18.12,
    transform: "translate(-116.48 510.38) rotate(-77.07)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-157",
    cx: 262.19,
    cy: 328.32,
    r: 18.1,
    transform: "translate(-116.47 510.4) rotate(-77.07)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 262.19,
    cy: 328.32,
    r: 18.08,
    transform: "translate(-116.46 510.41) rotate(-77.07)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-158",
    cx: 262.19,
    cy: 328.32,
    r: 18.06,
    transform: "translate(-116.45 510.43) rotate(-77.07)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-159",
    cx: 262.19,
    cy: 328.32,
    r: 18.04,
    transform: "translate(-116.44 510.45) rotate(-77.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-160",
    cx: 262.19,
    cy: 328.32,
    r: 18.02,
    transform: "translate(-116.44 510.46) rotate(-77.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-161",
    cx: 262.19,
    cy: 328.32,
    r: 18,
    transform: "translate(-116.43 510.48) rotate(-77.08)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-162",
    cx: 262.19,
    cy: 328.32,
    r: 17.98,
    transform: "translate(-116.42 510.5) rotate(-77.09)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-163",
    cx: 262.19,
    cy: 328.32,
    r: 17.96,
    transform: "translate(-116.41 510.52) rotate(-77.09)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-164",
    cx: 262.19,
    cy: 328.32,
    r: 17.94,
    transform: "translate(-116.4 510.53) rotate(-77.09)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-165",
    cx: 262.19,
    cy: 328.32,
    r: 17.92,
    transform: "translate(-116.39 510.55) rotate(-77.09)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-166",
    cx: 262.19,
    cy: 328.32,
    r: 17.9,
    transform: "translate(-116.38 510.57) rotate(-77.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-167",
    cx: 262.19,
    cy: 328.32,
    r: 17.88,
    transform: "translate(-116.37 510.59) rotate(-77.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-168",
    cx: 262.19,
    cy: 328.32,
    r: 17.86,
    transform: "translate(-116.37 510.61) rotate(-77.1)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 262.19,
    cy: 328.32,
    r: 17.84,
    transform: "translate(-116.36 510.63) rotate(-77.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-169",
    cx: 262.19,
    cy: 328.32,
    r: 17.82,
    transform: "translate(-116.35 510.65) rotate(-77.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-170",
    cx: 262.19,
    cy: 328.32,
    r: 17.8,
    transform: "matrix(0.22, -0.97, 0.97, 0.22, -116.34, 510.67)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-171",
    cx: 262.19,
    cy: 328.32,
    r: 17.78,
    transform: "translate(-116.33 510.69) rotate(-77.11)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-172",
    cx: 262.19,
    cy: 328.32,
    r: 17.76,
    transform: "translate(-116.32 510.71) rotate(-77.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-173",
    cx: 262.19,
    cy: 328.32,
    r: 17.74,
    transform: "translate(-116.31 510.74) rotate(-77.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-174",
    cx: 262.19,
    cy: 328.32,
    r: 17.72,
    transform: "translate(-116.29 510.76) rotate(-77.12)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-175",
    cx: 262.19,
    cy: 328.32,
    r: 17.7,
    transform: "translate(-116.28 510.78) rotate(-77.13)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-176",
    cx: 262.19,
    cy: 328.32,
    r: 17.68,
    transform: "translate(-116.27 510.8) rotate(-77.13)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-177",
    cx: 262.19,
    cy: 328.32,
    r: 17.66,
    transform: "translate(-116.26 510.83) rotate(-77.14)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-178",
    cx: 262.19,
    cy: 328.32,
    r: 17.64,
    transform: "translate(-116.25 510.85) rotate(-77.14)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-179",
    cx: 262.19,
    cy: 328.32,
    r: 17.62,
    transform: "translate(-116.24 510.88) rotate(-77.14)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 262.19,
    cy: 328.32,
    r: 17.6,
    transform: "translate(-116.23 510.9) rotate(-77.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 262.19,
    cy: 328.32,
    r: 17.58,
    transform: "translate(-116.21 510.93) rotate(-77.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-180",
    cx: 262.19,
    cy: 328.32,
    r: 17.56,
    transform: "translate(-116.2 510.95) rotate(-77.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-181",
    cx: 262.19,
    cy: 328.32,
    r: 17.54,
    transform: "translate(-116.19 510.98) rotate(-77.16)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-182",
    cx: 262.19,
    cy: 328.32,
    r: 17.52,
    transform: "translate(-116.17 511.01) rotate(-77.16)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-183",
    cx: 262.19,
    cy: 328.32,
    r: 17.5,
    transform: "translate(-116.16 511.03) rotate(-77.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-184",
    cx: 262.19,
    cy: 328.32,
    r: 17.48,
    transform: "translate(-116.15 511.06) rotate(-77.17)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-185",
    cx: 262.19,
    cy: 328.32,
    r: 17.46,
    transform: "translate(-116.13 511.09) rotate(-77.18)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-186",
    cx: 262.19,
    cy: 328.32,
    r: 17.44,
    transform: "translate(-116.12 511.12) rotate(-77.18)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-187",
    cx: 262.19,
    cy: 328.32,
    r: 17.42,
    transform: "translate(-116.1 511.15) rotate(-77.18)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-188",
    cx: 262.19,
    cy: 328.32,
    r: 17.41,
    transform: "translate(-116.09 511.18) rotate(-77.19)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-189",
    cx: 262.19,
    cy: 328.32,
    r: 17.39,
    transform: "translate(-116.07 511.21) rotate(-77.19)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 262.19,
    cy: 328.32,
    r: 17.37,
    transform: "translate(-116.06 511.24) rotate(-77.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-190",
    cx: 262.19,
    cy: 328.32,
    r: 17.35,
    transform: "translate(-116.04 511.28) rotate(-77.2)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-191",
    cx: 262.19,
    cy: 328.32,
    r: 17.33,
    transform: "translate(-116.03 511.31) rotate(-77.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-192",
    cx: 262.19,
    cy: 328.32,
    r: 17.31,
    transform: "translate(-116.01 511.35) rotate(-77.21)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-193",
    cx: 262.19,
    cy: 328.32,
    r: 17.29,
    transform: "translate(-115.99 511.38) rotate(-77.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-194",
    cx: 262.19,
    cy: 328.32,
    r: 17.27,
    transform: "translate(-115.98 511.42) rotate(-77.22)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-195",
    cx: 262.19,
    cy: 328.32,
    r: 17.25,
    transform: "translate(-115.96 511.45) rotate(-77.23)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-196",
    cx: 262.19,
    cy: 328.32,
    r: 17.23,
    transform: "translate(-115.94 511.49) rotate(-77.24)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-197",
    cx: 262.19,
    cy: 328.32,
    r: 17.21,
    transform: "matrix(0.22, -0.98, 0.98, 0.22, -115.92, 511.53)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-198",
    cx: 262.19,
    cy: 328.32,
    r: 17.19,
    transform: "translate(-115.9 511.57) rotate(-77.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-199",
    cx: 262.19,
    cy: 328.32,
    r: 17.17,
    transform: "translate(-115.88 511.61) rotate(-77.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-200",
    cx: 262.19,
    cy: 328.32,
    r: 17.15,
    transform: "translate(-115.86 511.65) rotate(-77.26)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-27",
    cx: 262.19,
    cy: 328.32,
    r: 17.13,
    transform: "translate(-115.84 511.7) rotate(-77.27)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-201",
    cx: 262.19,
    cy: 328.32,
    r: 17.11,
    transform: "translate(-115.82 511.74) rotate(-77.27)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-202",
    cx: 262.19,
    cy: 328.32,
    r: 17.09,
    transform: "translate(-115.8 511.79) rotate(-77.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-203",
    cx: 262.19,
    cy: 328.32,
    r: 17.07,
    transform: "translate(-115.77 511.83) rotate(-77.29)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-204",
    cx: 262.19,
    cy: 328.32,
    r: 17.05,
    transform: "translate(-115.75 511.88) rotate(-77.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-205",
    cx: 262.19,
    cy: 328.32,
    r: 17.03,
    transform: "translate(-115.73 511.93) rotate(-77.3)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-206",
    cx: 262.19,
    cy: 328.32,
    r: 17.01,
    transform: "translate(-115.7 511.98) rotate(-77.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-207",
    cx: 262.19,
    cy: 328.32,
    r: 16.99,
    transform: "translate(-115.68 512.03) rotate(-77.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-208",
    cx: 262.19,
    cy: 328.32,
    r: 16.97,
    transform: "translate(-115.65 512.09) rotate(-77.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-209",
    cx: 262.19,
    cy: 328.32,
    r: 16.95,
    transform: "translate(-115.62 512.14) rotate(-77.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-210",
    cx: 262.19,
    cy: 328.32,
    r: 16.93,
    transform: "translate(-115.59 512.2) rotate(-77.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-211",
    cx: 262.19,
    cy: 328.32,
    r: 16.91,
    transform: "translate(-115.57 512.26) rotate(-77.35)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 262.19,
    cy: 328.32,
    r: 16.89,
    transform: "translate(-115.54 512.32) rotate(-77.36)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-212",
    cx: 262.19,
    cy: 328.32,
    r: 16.87,
    transform: "translate(-115.51 512.38) rotate(-77.37)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-213",
    cx: 262.19,
    cy: 328.32,
    r: 16.85,
    transform: "translate(-115.47 512.45) rotate(-77.38)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-214",
    cx: 262.19,
    cy: 328.32,
    r: 16.83,
    transform: "translate(-115.44 512.52) rotate(-77.39)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-215",
    cx: 262.19,
    cy: 328.32,
    r: 16.81,
    transform: "translate(-115.41 512.58) rotate(-77.4)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-216",
    cx: 262.19,
    cy: 328.32,
    r: 16.79,
    transform: "translate(-115.37 512.66) rotate(-77.41)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-217",
    cx: 262.19,
    cy: 328.32,
    r: 16.77,
    transform: "translate(-115.34 512.73) rotate(-77.42)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-218",
    cx: 262.19,
    cy: 328.32,
    r: 16.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-219",
    cx: 262.19,
    cy: 328.32,
    r: 16.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-220",
    cx: 262.19,
    cy: 328.32,
    r: 16.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-221",
    cx: 262.19,
    cy: 328.32,
    r: 16.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-222",
    cx: 262.19,
    cy: 328.32,
    r: 16.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 262.19,
    cy: 328.32,
    r: 16.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-223",
    cx: 262.19,
    cy: 328.32,
    r: 16.63
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-224",
    cx: 262.19,
    cy: 328.32,
    r: 16.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-225",
    cx: 262.19,
    cy: 328.32,
    r: 16.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-226",
    cx: 262.19,
    cy: 328.32,
    r: 16.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-227",
    cx: 262.19,
    cy: 328.32,
    r: 16.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-228",
    cx: 262.19,
    cy: 328.32,
    r: 16.54
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-229",
    cx: 262.19,
    cy: 328.32,
    r: 16.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-230",
    cx: 262.19,
    cy: 328.32,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-231",
    cx: 262.19,
    cy: 328.32,
    r: 16.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-232",
    cx: 262.19,
    cy: 328.32,
    r: 16.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-233",
    cx: 262.19,
    cy: 328.32,
    r: 16.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-234",
    cx: 262.19,
    cy: 328.32,
    r: 16.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 262.19,
    cy: 328.32,
    r: 16.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-235",
    cx: 262.19,
    cy: 328.32,
    r: 16.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-236",
    cx: 262.19,
    cy: 328.32,
    r: 16.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-237",
    cx: 262.19,
    cy: 328.32,
    r: 16.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-238",
    cx: 262.19,
    cy: 328.32,
    r: 16.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-239",
    cx: 262.19,
    cy: 328.32,
    r: 16.3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-240",
    cx: 262.19,
    cy: 328.32,
    r: 16.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-241",
    cx: 262.19,
    cy: 328.32,
    r: 16.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-242",
    cx: 262.19,
    cy: 328.32,
    r: 16.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-243",
    cx: 262.19,
    cy: 328.32,
    r: 16.22
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-244",
    cx: 262.19,
    cy: 328.32,
    r: 16.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-245",
    cx: 262.19,
    cy: 328.32,
    r: 16.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 262.19,
    cy: 328.32,
    r: 16.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-246",
    cx: 262.19,
    cy: 328.32,
    r: 16.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-247",
    cx: 262.19,
    cy: 328.32,
    r: 16.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-248",
    cx: 262.19,
    cy: 328.32,
    r: 16.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-249",
    cx: 262.19,
    cy: 328.32,
    r: 16.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-250",
    cx: 262.19,
    cy: 328.32,
    r: 16.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-251",
    cx: 262.19,
    cy: 328.32,
    r: 16.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-252",
    cx: 262.19,
    cy: 328.32,
    r: 16.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-253",
    cx: 262.19,
    cy: 328.32,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-254",
    cx: 262.19,
    cy: 328.32,
    r: 15.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-255",
    cx: 262.19,
    cy: 328.32,
    r: 15.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-256",
    cx: 262.19,
    cy: 328.32,
    r: 15.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 262.19,
    cy: 328.32,
    r: 15.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-257",
    cx: 262.19,
    cy: 328.32,
    r: 15.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-258",
    cx: 262.19,
    cy: 328.32,
    r: 15.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-259",
    cx: 262.19,
    cy: 328.32,
    r: 15.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-260",
    cx: 262.19,
    cy: 328.32,
    r: 15.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-261",
    cx: 262.19,
    cy: 328.32,
    r: 15.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-262",
    cx: 262.19,
    cy: 328.32,
    r: 15.81
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-263",
    cx: 262.19,
    cy: 328.32,
    r: 15.79
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-264",
    cx: 262.19,
    cy: 328.32,
    r: 15.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-265",
    cx: 262.19,
    cy: 328.32,
    r: 15.75
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-266",
    cx: 262.19,
    cy: 328.32,
    r: 15.73
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-267",
    cx: 262.19,
    cy: 328.32,
    r: 15.71
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 262.19,
    cy: 328.32,
    r: 15.69
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 262.19,
    cy: 328.32,
    r: 15.69
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.82,217.47l-6.38,1.95-3.36,1-1.48.46-.14-.46-6.32-20.6-.11-.36,1.31-.4,4.71-1.44,9.47-2.91a16,16,0,0,0-.91,11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.08,210.92a14.91,14.91,0,0,1-3.42,9.53,12.45,12.45,0,0,1-1,1.08,15,15,0,1,1,4.39-10.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M43.41,210.8h0a11,11,0,0,1,11-11h0a10.92,10.92,0,0,1,5.21,1.32A11,11,0,1,0,47,218.94,11,11,0,0,1,43.41,210.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.93,304.83h0a10,10,0,0,1-13.88,2.34h0a10,10,0,0,1-2.34-13.88h0A10,10,0,0,1,57.59,291h0A10,10,0,0,1,59.93,304.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M48.53,305.2h0a8.14,8.14,0,0,1-1.91-11.35h0a8.1,8.1,0,0,1,3-2.59,8.06,8.06,0,0,0-4.88,3.22,8.14,8.14,0,0,0,10.22,12A8.1,8.1,0,0,1,48.53,305.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.76,376.1h0a8.7,8.7,0,0,1-12.13,2h0a8.71,8.71,0,0,1-2-12.13h0a8.7,8.7,0,0,1,12.13-2h0A8.68,8.68,0,0,1,101.76,376.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.8,376.43h0a7.11,7.11,0,0,1-1.67-9.92h0a7.06,7.06,0,0,1,2.65-2.26,7.05,7.05,0,0,0-4.26,2.81,7.11,7.11,0,0,0,8.94,10.51A7.1,7.1,0,0,1,91.8,376.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M65.66,220.45a12.45,12.45,0,0,1-1,1.08,15,15,0,0,1-22.19-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M98.92,362.33l-18,10.14c-2.18,1.23-5.26.11-7.21-2.63L40.89,323.78c-2.4-3.36-2.14-7.71.53-9.22l29.16-16.43c2.71-1.53,6.62.58,8.22,4.44l21.66,52.34C101.73,358,101.08,361.11,98.92,362.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37,353.24h0a4.23,4.23,0,0,1,6-.4h0a4.24,4.24,0,0,1,.39,6h0a4.24,4.24,0,0,1-6,.39h0A4.23,4.23,0,0,1,116.37,353.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M121.2,353.57h0a3.46,3.46,0,0,1,.33,4.88h0a3.56,3.56,0,0,1-1.4,1,3.46,3.46,0,1,0-1.61-6.67A3.44,3.44,0,0,1,121.2,353.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M137.08,349.19l-9.41,6.41a4.12,4.12,0,0,1-5.71-1.08h0a4.12,4.12,0,0,1,1.09-5.71l9.41-6.41a4.13,4.13,0,0,1,5.71,1.08h0A4.12,4.12,0,0,1,137.08,349.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.24,361.83h0a4.22,4.22,0,0,1,5.52,2.29h0a4.23,4.23,0,0,1-2.3,5.52h0a4.22,4.22,0,0,1-5.51-2.3h0A4.22,4.22,0,0,1,156.24,361.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.43,364.27h0a3.46,3.46,0,0,1-1.88,4.51h0a3.41,3.41,0,0,1-1.68.25,3.46,3.46,0,0,0,4.36-4.57,3.47,3.47,0,0,0-2.84-2.13A3.48,3.48,0,0,1,160.43,364.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.27,358.5h0a4.23,4.23,0,0,1,5.52,2.3h0a4.23,4.23,0,0,1-2.3,5.52h0A4.22,4.22,0,0,1,178,364h0A4.23,4.23,0,0,1,180.27,358.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.46,360.94h0a3.47,3.47,0,0,1-1.88,4.52h0a3.4,3.4,0,0,1-1.68.24,3.46,3.46,0,1,0,1.52-6.69A3.46,3.46,0,0,1,184.46,360.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M176.6,367.4,165.31,369a4.12,4.12,0,0,1-4.63-3.5h0a4.12,4.12,0,0,1,3.51-4.63l11.28-1.56a4.11,4.11,0,0,1,4.63,3.5h0A4.12,4.12,0,0,1,176.6,367.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M200.07,364l-11.28,1.56a4.12,4.12,0,0,1-4.63-3.51h0a4.12,4.12,0,0,1,3.5-4.63l11.28-1.56a4.13,4.13,0,0,1,4.64,3.51h0A4.12,4.12,0,0,1,200.07,364Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,372.56h0a4.22,4.22,0,0,1,5.15,3h0a4.23,4.23,0,0,1-3,5.15h0a4.23,4.23,0,0,1-5.15-3h0A4.22,4.22,0,0,1,182,372.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M185.82,375.55h0a3.46,3.46,0,0,1-2.48,4.22h0a3.49,3.49,0,0,1-1.7,0,3.46,3.46,0,1,0,2.44-6.42A3.45,3.45,0,0,1,185.82,375.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.76,371.63h0a4.22,4.22,0,0,1,5.15,3h0a4.23,4.23,0,0,1-3,5.15h0a4.22,4.22,0,0,1-5.15-3h0A4.23,4.23,0,0,1,157.76,371.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M161.57,374.63h0a3.47,3.47,0,0,1-2.49,4.21h0a3.49,3.49,0,0,1-1.7,0,3.46,3.46,0,1,0,2.44-6.42A3.49,3.49,0,0,1,161.57,374.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M200.86,380.89H189.47a4.11,4.11,0,0,1-4.1-4.11h0a4.11,4.11,0,0,1,4.11-4.1h11.39a4.11,4.11,0,0,1,4.1,4.11h0A4.11,4.11,0,0,1,200.86,380.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M177.15,380.08l-11.39,0a4.12,4.12,0,0,1-4.11-4.11h0a4.13,4.13,0,0,1,4.12-4.1h11.39a4.11,4.11,0,0,1,4.1,4.11h0A4.12,4.12,0,0,1,177.15,380.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.73,384h0a4.22,4.22,0,0,1,5.17,3h0a4.22,4.22,0,0,1-3,5.17h0a4.22,4.22,0,0,1-5.17-3h0A4.22,4.22,0,0,1,180.73,384Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M184.56,386.93h0a3.47,3.47,0,0,1-2.45,4.24h0a3.5,3.5,0,0,1-1.7,0,3.46,3.46,0,1,0,2.39-6.44A3.43,3.43,0,0,1,184.56,386.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.85,383.32h0a4.22,4.22,0,0,1,5.17,3h0a4.22,4.22,0,0,1-3,5.17h0a4.22,4.22,0,0,1-5.17-3h0A4.22,4.22,0,0,1,156.85,383.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.68,386.28h0a3.47,3.47,0,0,1-2.45,4.24h0a3.5,3.5,0,0,1-1.7,0,3.46,3.46,0,1,0,2.39-6.44A3.43,3.43,0,0,1,160.68,386.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M199.69,392.15l-11.39.08a4.11,4.11,0,0,1-4.13-4.08h0a4.12,4.12,0,0,1,4.08-4.14l11.39-.07a4.11,4.11,0,0,1,4.13,4.07h0A4.12,4.12,0,0,1,199.69,392.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M176.31,392.19l-11.39.08a4.11,4.11,0,0,1-4.13-4.08h0a4.11,4.11,0,0,1,4.07-4.13l11.39-.08a4.13,4.13,0,0,1,4.14,4.08h0A4.11,4.11,0,0,1,176.31,392.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M113.38,358.84l-11.29,6.58A11.88,11.88,0,0,0,102,385.9l11,6.54a12,12,0,0,0,5.91,1.67l25.73.39a11.88,11.88,0,0,0,12.06-11.7l.2-13.12a11.89,11.89,0,0,0-11.7-12.07l-25.6-.39A11.91,11.91,0,0,0,113.38,358.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M62.73,291H42.07c-2.51,0-4.64-2.43-5-5.7l-6-54.9c-.43-4,1.93-7.59,5-7.59H69.56c3.11,0,5.48,3.68,5,7.72l-6.83,54.9C67.31,288.65,65.2,291,62.73,291Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 36.46,
    y: 227.98,
    width: 5.32,
    height: 58.27,
    rx: 2.53,
    transform: "translate(-27.55 5.73) rotate(-6.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 58.39,
    y: 314.18,
    width: 5.18,
    height: 59.64,
    rx: 2.01,
    transform: "translate(-183.05 93.99) rotate(-34.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 36.69,
    y: 253.55,
    width: 58.35,
    height: 5.18,
    rx: 2.35,
    transform: "translate(-196.71 287.85) rotate(-82.46)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 82.07,
    y: 301.53,
    width: 5.18,
    height: 59.68,
    rx: 2.37,
    transform: "translate(-124.55 60.8) rotate(-23.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 129.85,
    y: 344.3,
    width: 5.18,
    height: 36.07,
    rx: 2.01,
    transform: "translate(-232.89 486.27) rotate(-88.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 129.23,
    y: 370.72,
    width: 5.18,
    height: 36.07,
    rx: 1.84,
    transform: "translate(-259.9 511.47) rotate(-88.66)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 169.41,
    y: 378.6,
    width: 1.87,
    height: 14.91,
    rx: 0.72,
    transform: "translate(-214.52 559.08) rotate(-90.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 193.79,
    y: 378.31,
    width: 1.87,
    height: 14.91,
    rx: 0.72,
    transform: "translate(-189.69 583.16) rotate(-90.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 170.53,
    y: 366.48,
    width: 1.87,
    height: 14.91,
    rx: 0.72,
    transform: "translate(-202.67 544.98) rotate(-89.94)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 169.46,
    y: 354.65,
    width: 1.87,
    height: 14.91,
    rx: 0.72,
    transform: "translate(-164.95 580.52) rotate(-97.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 192.93,
    y: 351.69,
    width: 1.87,
    height: 13.74,
    rx: 0.72,
    transform: "translate(-134.76 599.7) rotate(-97.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 127.91,
    y: 339.56,
    width: 1.87,
    height: 15.28,
    rx: 0.72,
    transform: "translate(-85.65 649.11) rotate(-124.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 194.24,
    y: 367.47,
    width: 1.87,
    height: 14.28,
    rx: 0.72,
    transform: "translate(-179.66 569.35) rotate(-89.93)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbot401);
export default __webpack_public_path__ + "static/media/chatbot4-01.846436c1003303dd1a5403643be93cee.svg";
export { ForwardRef as ReactComponent };